export const LANGS = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "ar", label: "العربية", flag: "AR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "es", label: "Español", flag: "ES" },
];

export const RTL_LANGS = ["ar"];

const t = {
  fr: {
    "brand.tagline": "Marketplace B2B de l'huile d'olive tunisienne",
    "nav.home": "Accueil",
    "nav.market": "Marché",
    "nav.market.bulk": "Vrac",
    "nav.market.packaged": "Conditionné",
    "nav.market.requests": "Demandes",
    "nav.prices": "Prix",
    "nav.directory": "Annuaire des huileries",
    "nav.tools": "Outils",
    "nav.blog": "Blog",
    "nav.login": "Connexion",
    "nav.register": "Inscription",
    "nav.menu": "Menu",
    "nav.language": "Langue",
    "nav.currency": "Devise",
    "seo.home.title": "Marketplace B2B d'huile d'olive en gros en Tunisie",
    "seo.home.desc": "EvooTunisia connecte producteurs, moulins et acheteurs d'huile d'olive en gros. Négociez le vrac et le conditionné, suivez les prix du marché et trouvez des huileries vérifiées.",
    "seo.market.vrac.title": "Huile d'olive en vrac — Marché de gros",
    "seo.market.vrac.desc": "Achetez et vendez de l'huile d'olive en vrac (extra vierge, vierge, lampante). Lots vérifiés, filtres par qualité, acidité, prix et gouvernorat.",
    "seo.market.conditionne.title": "Huile d'olive conditionnée — Vente en gros",
    "seo.market.conditionne.desc": "Trouvez de l'huile d'olive conditionnée en gros : bouteilles, bidons et emballages personnalisés auprès de fournisseurs tunisiens vérifiés.",
    "seo.market.demandes.title": "Demandes d'achat d'huile d'olive en gros",
    "seo.market.demandes.desc": "Consultez les demandes d'achat d'huile d'olive publiées par les acheteurs et répondez avec vos offres de vente en gros.",
    "seo.prices.title": "Prix de l'huile d'olive en Tunisie — Cours & tendances",
    "seo.prices.desc": "Suivez les prix de l'huile d'olive en gros en Tunisie : cours actuels, historiques et tendances du marché par qualité.",
    "seo.directory.title": "Annuaire des huileries tunisiennes",
    "seo.directory.desc": "Découvrez les huileries et moulins à huile d'olive en Tunisie : coordonnées, certifications, variétés et capacités de production.",
    "seo.tools.title": "Outils pour professionnels de l'huile d'olive",
    "seo.tools.desc": "Calculatrice de coût de revient, alertes de marché, devis d'emballage et laboratoires d'inspection pour les professionnels de l'huile d'olive.",
    "seo.tools.calculator.title": "Calculatrice de coût de revient",
    "seo.tools.calculator.desc": "Estimez votre coût de revient et votre marge sur l'huile d'olive en gros, transport, conditionnement et commission inclus.",
    "seo.tools.alerts.title": "Alertes de marché — huile d'olive",
    "seo.tools.alerts.desc": "Recevez une alerte e-mail dès qu'un lot d'huile d'olive correspond à vos critères de prix, qualité et volume.",
    "seo.tools.packaging.title": "Devis d'emballage — huile d'olive",
    "seo.tools.packaging.desc": "Demandez des devis d'emballage (bouteilles, bidons, étiquettes) auprès de conditionneurs tunisiens vérifiés.",
    "seo.tools.inspection.title": "Laboratoires d'inspection & d'analyse",
    "seo.tools.inspection.desc": "Trouvez des laboratoires d'inspection et d'analyse de la qualité de l'huile d'olive avant expédition.",
    "seo.blog.title": "Blog & actualités de l'huile d'olive",
    "seo.blog.desc": "Analyses de marché, guides et actualités sur l'huile d'olive tunisienne, en plusieurs langues et mis à jour régulièrement.",
    "seo.faq.title": "Foire aux questions",
    "seo.faq.desc": "Réponses aux questions fréquentes sur l'achat et la vente d'huile d'olive en gros sur EvooTunisia.",

    "hero.badge": "Origine Tunisie · Vrac & Conditionné · Export",
    "hero.title": "Achetez et vendez l'huile d'olive tunisienne en gros",
    "hero.subtitle": "La place de marché qui relie huileries, coopératives, producteurs et courtiers aux acheteurs et importateurs. Transactions directes, prix transparents, qualité tracée.",
    "hero.cta.primary": "Explorer le marché",
    "hero.cta.secondary": "Publier un lot",
    "hero.stat.lots": "Lots en vente",
    "hero.stat.mills": "Huileries référencées",
    "hero.stat.regions": "Régions couvertes",
    "hero.stat.members": "Membres actifs",

    "value.heading": "Pourquoi EvooTunisia",
    "value.subtitle": "Un outil pensé pour les professionnels de la filière oléicole, du moulin à l'export.",
    "value.direct.title": "Mise en relation directe",
    "value.direct.desc": "Négociez sans intermédiaire entre vendeurs et acheteurs vérifiés.",
    "value.verified.title": "Acteurs vérifiés",
    "value.verified.desc": "Huileries, coopératives et courtiers avec profils et certifications.",
    "value.transparency.title": "Prix transparents",
    "value.transparency.desc": "Suivez les cours par région et qualité, mis à jour en continu.",
    "value.export.title": "Orienté export",
    "value.export.desc": "Traçabilité, acidité et conformité pour les marchés internationaux.",

    "lots.heading": "Lots récents à la vente",
    "lots.subtitle": "Une sélection d'offres publiées par nos vendeurs partout en Tunisie.",
    "lots.viewAll": "Voir tout le marché",
    "lots.quantity": "Quantité",
    "lots.acidity": "Acidité",
    "lots.view": "Voir le lot",
    "lots.organic": "Bio",
    "lots.perUnit": "/ {unit}",
    "type.vrac": "Vrac",
    "type.conditionne": "Conditionné",
    "quality.extra_vierge": "Extra vierge",
    "quality.vierge": "Vierge",
    "quality.lampante": "Lampante",
    "quality.bio": "Bio",

    "prices.heading": "Prix du marché",
    "prices.subtitle": "Cours indicatifs de l'huile d'olive par région et qualité.",
    "prices.region": "Région",
    "prices.quality": "Qualité",
    "prices.price": "Prix",
    "prices.change": "Variation",
    "prices.viewAll": "Voir tous les prix",
    "prices.updated": "Mis à jour aujourd'hui",
    "market.hub.subtitle": "Cotations à l'origine, prix en grande distribution, thermomètre et balance de marché.",
    "market.tab.origin": "Prix à l'origine",
    "market.tab.retail": "Prix conditionné / GD",
    "market.tab.thermo": "Thermomètre du marché",
    "market.tab.balance": "Balance de marché",
    "market.origin.title": "Prix du vrac à l'origine",
    "market.origin.desc": "Cotations par pays producteur et qualité. Tunisie en TND/kg, international en EUR/kg.",
    "market.retail.title": "Prix conditionné / grande distribution",
    "market.retail.desc": "Suivi des marques distributeur en supermarché (Tunisie).",
    "market.thermo.title": "Thermomètre du marché",
    "market.thermo.desc": "Tendance synthétique à partir des dernières variations de prix.",
    "market.balance.title": "Balance de marché (Tunisie)",
    "market.balance.desc": "Volumes de production, stocks, exportations et consommation.",
    "market.country": "Pays",
    "market.quality": "Qualité",
    "market.retailer": "Enseigne",
    "market.source": "Source",
    "market.brand": "Marque",
    "market.format": "Format",
    "market.latest": "Dernier prix",
    "market.change": "Variation",
    "market.evolution": "Évolution",
    "market.displayCurrency": "Devise d'affichage",
    "market.fxNote": "Taux de change du {date}",
    "market.updated": "Mis à jour",
    "market.noData": "Aucune donnée disponible.",
    "market.thermo.up": "Hausse",
    "market.thermo.stable": "Stable",
    "market.thermo.down": "Baisse",
    "market.thermo.basis": "Variation moyenne {pct}% sur les {weeks} dernières semaines ({count} séries)",
    "market.thermo.thresholds": "Seuils : hausse ≥ {up}% · baisse ≤ {down}%",
    "market.thermo.comment": "Commentaire de l'analyste",
    "market.season": "Campagne",
    "market.value": "Volume (t)",
    "metric.production": "Production",
    "metric.exports": "Exportations",
    "metric.stocks": "Stocks",
    "metric.consumption": "Consommation",
    "metric.imports": "Importations",
    "country.tunisia": "Tunisie",
    "country.spain": "Espagne",
    "country.italy": "Italie",
    "country.greece": "Grèce",
    "country.portugal": "Portugal",
    "country.turkey": "Turquie",
    "country.morocco": "Maroc",
    "dash.menu.admin": "Administration",
    "dash.menu.adminMarket": "Marché & Prix",
    "dash.menu.adminOverview": "Vue d'ensemble",
    "dash.menu.adminUsers": "Utilisateurs & entreprises",
    "dash.menu.adminLots": "Modération des lots",
    "dash.menu.adminSettings": "Réglages",
    "admin.overview.title": "Vue d'ensemble",
    "admin.overview.users": "Utilisateurs",
    "admin.overview.usersVerified": "vérifiés",
    "admin.overview.emailUnconfirmed": "email non confirmé",
    "admin.overview.companies": "Entreprises vérifiées",
    "admin.overview.pending": "en attente",
    "admin.overview.lotsActive": "Lots actifs",
    "admin.overview.deals": "Opérations conclues",
    "admin.overview.volume": "Volume échangé",
    "admin.overview.commissions": "commissions",
    "admin.overview.quotesOpen": "Devis en cours",
    "admin.overview.byType": "Utilisateurs par type",
    "admin.overview.monthly": "Activité mensuelle",
    "admin.overview.noData": "Aucune donnée pour le moment.",
    "admin.users.title": "Utilisateurs & entreprises",
    "admin.users.tabKyc": "Vérifications KYC",
    "admin.users.tabAll": "Tous les utilisateurs",
    "admin.users.pendingKyc": "Vérifications en attente",
    "admin.users.noPending": "Aucune vérification en attente.",
    "admin.users.history": "Historique",
    "admin.users.review": "Examiner",
    "admin.users.approve": "Approuver",
    "admin.users.reject": "Refuser",
    "admin.users.rejectReason": "Motif du refus",
    "admin.users.docs": "Documents KYC",
    "admin.users.viewDoc": "Ouvrir",
    "admin.users.noDocs": "Aucun document soumis.",
    "admin.users.decisionSaved": "Décision enregistrée",
    "admin.users.search": "Rechercher un utilisateur…",
    "admin.users.name": "Nom",
    "admin.users.email": "E-mail",
    "admin.users.type": "Type",
    "admin.users.emailConfirmed": "E-mail confirmé",
    "admin.users.confirmed": "Confirmé",
    "admin.users.notConfirmed": "Non confirmé",
    "admin.users.confirmEmail": "Confirmer",
    "admin.users.confirmDone": "E-mail confirmé",
    "admin.users.actions": "Actions",
    "admin.users.company": "Entreprise",
    "admin.users.export": "Exporter",
    "admin.users.exportDone": "Export de {count} utilisateur(s) réussi",
    "admin.users.contact": "Nom (contact)",
    "admin.users.filters": "Filtres",
    "admin.users.all": "Tous",
    "admin.users.filterKyc": "Vérification KYC",
    "admin.users.filterCountry": "Pays",
    "admin.users.filterGov": "Gouvernorat",
    "admin.users.kycVerified": "Vérifié",
    "admin.users.kycPending": "En attente",
    "admin.users.kycUnverified": "Non vérifié",
    "admin.users.kycRejected": "Refusé",
    "admin.users.showDeleted": "Afficher les comptes supprimés",
    "admin.users.resetFilters": "Réinitialiser les filtres",
    "admin.users.noResults": "Aucun utilisateur ne correspond aux filtres.",
    "admin.userdetail.back": "Retour à la liste",
    "admin.userdetail.identity": "Identité",
    "admin.userdetail.company": "Entreprise",
    "admin.userdetail.activity": "Activité",
    "admin.userdetail.kyc": "Documents KYC",
    "admin.userdetail.notes": "Notes internes",
    "admin.userdetail.actions": "Actions administratives",
    "admin.userdetail.role": "Rôle",
    "admin.userdetail.type": "Type",
    "admin.userdetail.status": "Statut",
    "admin.userdetail.lang": "Langue",
    "admin.userdetail.registered": "Inscrit le",
    "admin.userdetail.consent": "Consentement",
    "admin.userdetail.emailConfirmed": "E-mail confirmé",
    "admin.userdetail.lots": "Lots publiés",
    "admin.userdetail.negotiations": "Négociations",
    "admin.userdetail.deals": "Deals conclus",
    "admin.userdetail.requests": "Demandes d'achat",
    "admin.userdetail.quotes": "Devis",
    "admin.userdetail.noCompany": "Aucune entreprise rattachée.",
    "admin.userdetail.noKyc": "Aucun document KYC soumis.",
    "admin.userdetail.noNotes": "Aucune note interne.",
    "admin.userdetail.verifStatus": "Vérification",
    "admin.userdetail.suspend": "Suspendre",
    "admin.userdetail.reactivate": "Réactiver",
    "admin.userdetail.suspendReason": "Motif de la suspension",
    "admin.userdetail.suspendConfirm": "Suspendre le compte",
    "admin.userdetail.suspendedBadge": "Suspendu",
    "admin.userdetail.activeBadge": "Actif",
    "admin.userdetail.deletedBadge": "Supprimé",
    "admin.userdetail.suspendedInfo": "Compte suspendu :",
    "admin.userdetail.confirmEmail": "Confirmer l'e-mail",
    "admin.userdetail.resendConfirm": "Renvoyer le lien",
    "admin.userdetail.changeType": "Changer le type d'utilisateur",
    "admin.userdetail.saveType": "Enregistrer",
    "admin.userdetail.addNote": "Ajouter la note",
    "admin.userdetail.notePlaceholder": "Écrire une note interne…",
    "admin.userdetail.delete": "Supprimer le compte",
    "admin.userdetail.deleteTitle": "Supprimer cet utilisateur",
    "admin.userdetail.softDelete": "Suppression standard (anonymisation)",
    "admin.userdetail.softDeleteDesc": "Anonymise les données personnelles et conserve l'historique transactionnel (conformité INPDP/RGPD). Recommandé.",
    "admin.userdetail.hardDelete": "Suppression définitive",
    "admin.userdetail.hardDeleteDesc": "Efface totalement le compte. Réservé aux comptes sans aucune activité (spam / faux comptes).",
    "admin.userdetail.hardDeleteBlocked": "Impossible : ce compte a une activité sur la plateforme.",
    "admin.userdetail.deleteConfirm": "Confirmer la suppression",
    "admin.userdetail.deleted": "Compte supprimé",
    "admin.userdetail.suspended": "Compte suspendu",
    "admin.userdetail.reactivated": "Compte réactivé",
    "admin.userdetail.typeChanged": "Type mis à jour",
    "admin.userdetail.noteAdded": "Note ajoutée",
    "admin.userdetail.confirmed": "E-mail confirmé",
    "admin.userdetail.resetPassword": "Réinitialiser le mot de passe",
    "admin.userdetail.resetSent": "Lien de réinitialisation envoyé par e-mail",
    "admin.userdetail.activityEmpty": "Aucun élément.",
    "admin.userdetail.commission": "Commission",
    "admin.userdetail.roleBuyer": "Acheteur",
    "admin.userdetail.roleSeller": "Vendeur",
    "admin.userdetail.resent": "Lien de confirmation renvoyé",
    "admin.userdetail.cancel": "Annuler",
    "admin.userdetail.yes": "Oui",
    "admin.userdetail.no": "Non",
    "admin.userdetail.accountState": "Statut du compte",
    "admin.userdetail.lastLogin": "Dernière connexion",
    "admin.userdetail.never": "Jamais",
    "admin.userdetail.invoices": "Factures",
    "admin.userdetail.invoicesEmpty": "Aucune facture pour le moment.",
    "admin.userdetail.invoicesSoon": "La facturation sera disponible avec la génération des factures (Phase 10).",
    "statement.title": "Relevé de compte",
    "statement.billed": "Total facturé",
    "statement.paid": "Total payé",
    "statement.unpaid": "Solde impayé",
    "statement.empty": "Aucune facture pour le moment.",
    "invoice.number": "N° facture",
    "invoice.party": "Rôle",
    "invoice.buyer": "Acheteur",
    "invoice.seller": "Vendeur",
    "invoice.base": "Base HT",
    "invoice.rate": "Taux de commission",
    "invoice.ht": "Montant HT",
    "invoice.vat": "TVA",
    "invoice.ttc": "Total TTC",
    "invoice.date": "Date d'émission",
    "invoice.dueDate": "Échéance",
    "invoice.status": "Statut",
    "invoice.viewPdf": "Voir le PDF",
    "invoice.proof": "Justificatif",
    "invoice.noProof": "Aucun justificatif disponible.",
    "invoice.paymentRef": "Référence de paiement (n° virement)",
    "invoice.status.issued": "Émise",
    "invoice.status.awaiting_payment": "En attente de paiement",
    "invoice.status.paid": "Payée",
    "invoice.status.cancelled": "Annulée",
    "invoice.myTitle": "Mes factures",
    "invoice.mySubtitle": "Factures de commission sur vos opérations conclues.",
    "invoice.myEmpty": "Aucune facture pour le moment.",
    "invoice.myEmptyHint": "Les factures de commission sont générées à la conclusion d'une opération en vrac. Le conditionné est sans commission.",
    "invoice.payTitle": "Paiement par virement bancaire",
    "invoice.payHint": "Effectuez le virement du montant TTC, puis téléversez votre justificatif ci-dessous. L'administrateur validera la réception du paiement.",
    "invoice.uploadProof": "Téléverser le justificatif",
    "invoice.proofHint": "PDF, JPG ou PNG — 10 Mo max.",
    "invoice.proofSent": "Justificatif envoyé. En attente de validation par l'administrateur.",
    "invoice.awaitingValidation": "En attente de validation admin",
    "invoice.paidOn": "Payée le",
    "admin.billing.title": "Facturation & coordonnées bancaires",
    "admin.billing.desc": "Coordonnées de l'émetteur et RIB affichés sur les factures de commission.",
    "admin.billing.issuerLegal": "Raison sociale de l'émetteur",
    "admin.billing.taxId": "Matricule fiscal",
    "admin.billing.address": "Adresse",
    "admin.billing.email": "E-mail",
    "admin.billing.phone": "Téléphone",
    "admin.billing.bankName": "Banque",
    "admin.billing.rib": "RIB",
    "admin.billing.iban": "IBAN",
    "admin.billing.swift": "SWIFT/BIC",
    "admin.billing.vatRate": "Taux de TVA (%)",
    "admin.billing.paymentTerms": "Délai de paiement (jours)",
    "admin.billing.exportExempt": "Exonération de TVA à l'export",
    "admin.billing.exportNote": "Mention TVA export",
    "invoice.bankName": "Banque",
    "invoice.rib": "RIB",
    "invoice.iban": "IBAN",
    "invoice.swift": "SWIFT/BIC",
    "admin.userdetail.viewListing": "Voir la fiche du lot",
    "admin.userdetail.openThread": "Ouvrir le fil complet",
    "admin.userdetail.parties": "Parties",
    "admin.userdetail.lot": "Lot",
    "admin.userdetail.quantity": "Quantité",
    "admin.userdetail.unitPrice": "Prix unitaire",
    "admin.userdetail.total": "Montant total",
    "admin.userdetail.thread": "Historique des échanges",
    "admin.userdetail.offer": "Offre",
    "admin.userdetail.counter": "Contre-offre",
    "admin.userdetail.message": "Message",
    "admin.userdetail.systemEvent": "Événement",
    "admin.userdetail.quality": "Qualité",
    "admin.userdetail.targetPrice": "Prix cible",
    "admin.userdetail.governorate": "Gouvernorat",
    "admin.userdetail.packaging": "Conditionnement",
    "admin.userdetail.volume": "Volume",
    "admin.userdetail.units": "Unités",
    "admin.userdetail.whiteLabel": "Marque blanche",
    "admin.userdetail.contact": "Contact",
    "admin.userdetail.desc": "Description",
    "admin.userdetail.concludedAt": "Conclu le",
    "admin.userdetail.export": "Export",
    "admin.userdetail.national": "National",
    "admin.userdetail.rowClickHint": "Cliquer pour le détail",
    "admin.userdetail.detailNotFound": "Détail indisponible.",
    "common.reference": "Référence",
    "deals.operationRef": "Réf. opération",
    "deals.lotRef": "Réf. lot",
    "market.searchPlaceholder": "Titre ou référence…",
    "dash.menu.adminOps": "Opérations",
    "admin.lots.openFiche": "Ouvrir la fiche du lot",
    "admin.users.openFiche": "Ouvrir la fiche",
    "adminlot.back": "Retour aux lots",
    "adminlot.publicView": "Vue publique",
    "adminlot.specs": "Caractéristiques",
    "adminlot.price": "Prix",
    "adminlot.remaining": "Quantité restante",
    "adminlot.sold": "Quantité vendue",
    "adminlot.negotiations": "Négociations & offres",
    "adminlot.noNegos": "Aucune négociation sur ce lot.",
    "adminlot.offers": "Offres",
    "adminlot.seller": "Vendeur",
    "admindeals.title": "Opérations conclues",
    "admindeals.search": "Réf. opération, lot ou partie…",
    "admindeals.none": "Aucune opération conclue.",
    "admindeals.parties": "Parties (acheteur ← vendeur)",
    "geo.subdiv.governorate": "Gouvernorat",
    "geo.subdiv.muhafazah": "Gouvernorat",
    "geo.subdiv.emirate": "Émirat",
    "geo.subdiv.municipality": "Municipalité",
    "geo.subdiv.district": "District",
    "geo.subdiv.wilaya": "Wilaya",
    "geo.subdiv.canton": "Canton",
    "geo.subdiv.provinceTerr": "Province / Territoire",
    "geo.subdiv.province": "Province",
    "geo.subdiv.state": "État",
    "geo.subdiv.region": "Région",
    "geo.subdiv.provincia": "Province",
    "geo.subdiv.distrito": "District",
    "geo.subdiv.land": "Land / Région",
    "geo.subdiv.county": "Comté",
    "geo.subdiv.generic": "Région / État / Province",
    "geo.subdiv.select": "Sélectionner…",
    "geo.subdiv.freeholder": "Région / État / Province",
    "geo.search": "Rechercher…",
    "geo.empty": "Aucun résultat",
    "geo.city": "Ville",
    "geo.city.select": "Sélectionner une ville",
    "geo.city.freeholder": "Ville",
    "geo.city.notListed": "Ma ville n'est pas listée",
    "geo.city.backToList": "Revenir à la liste",
    "phone.invalid": "Numéro de téléphone invalide",
    "login.forgot": "Mot de passe oublié ?",
    "login.suspended": "Votre compte a été suspendu. Contactez l'administrateur pour plus d'informations.",
    "pwreset.forgotTitle": "Mot de passe oublié",
    "pwreset.forgotSubtitle": "Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.",
    "pwreset.email": "Adresse e-mail",
    "pwreset.sendLink": "Envoyer le lien",
    "pwreset.sentTitle": "Vérifiez votre boîte e-mail",
    "pwreset.sentDesc": "Si un compte est associé à cette adresse, vous recevrez un lien pour réinitialiser votre mot de passe. Ce lien expire dans 1 heure.",
    "pwreset.backToLogin": "Retour à la connexion",
    "pwreset.resetTitle": "Nouveau mot de passe",
    "pwreset.resetSubtitle": "Choisissez un nouveau mot de passe pour votre compte.",
    "pwreset.newPassword": "Nouveau mot de passe",
    "pwreset.confirmPassword": "Confirmez le mot de passe",
    "pwreset.minLength": "8 caractères minimum",
    "pwreset.mismatch": "Les mots de passe ne correspondent pas.",
    "pwreset.save": "Réinitialiser",
    "pwreset.successTitle": "Mot de passe réinitialisé",
    "pwreset.successDesc": "Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.",
    "pwreset.goLogin": "Se connecter",
    "pwreset.invalidTitle": "Lien invalide ou expiré",
    "pwreset.invalidDesc": "Ce lien de réinitialisation n'est plus valide (expiré, déjà utilisé ou incorrect). Demandez-en un nouveau.",
    "pwreset.requestNew": "Demander un nouveau lien",
    "pwreset.spamHelp": "Vous ne trouvez pas l'e-mail ? Vérifiez votre dossier spam. Les e-mails Hotmail/Outlook peuvent prendre quelques minutes.",
    "admin.lots.title": "Modération des lots",
    "admin.lots.all": "Tous",
    "admin.lots.available": "Disponible",
    "admin.lots.sold": "Vendu",
    "admin.lots.withdrawn": "Retiré",
    "admin.lots.search": "Rechercher un lot…",
    "admin.lots.lot": "Lot",
    "admin.lots.seller": "Vendeur",
    "admin.lots.type": "Type",
    "admin.lots.qty": "Quantité",
    "admin.lots.statusCol": "Statut",
    "admin.lots.actions": "Actions",
    "admin.lots.vrac": "Vrac",
    "admin.lots.conditionne": "Conditionné",
    "admin.lots.withdraw": "Retirer",
    "admin.lots.restore": "Réactiver",
    "admin.lots.statusChanged": "Statut mis à jour",
    "admin.lots.none": "Aucun lot.",
    "admin.lots.confirmWithdraw": "Retirer ce lot du marché ?",
    "admin.settings.title": "Réglages",
    "admin.settings.commission": "Barème de commission",
    "admin.settings.commissionDesc": "Taux appliqués sur chaque opération conclue (en %).",
    "admin.settings.vracNational": "Vrac national",
    "admin.settings.vracExport": "Vrac export",
    "admin.settings.conditionne": "Conditionné",
    "admin.settings.buyer": "Acheteur",
    "admin.settings.seller": "Vendeur",
    "admin.settings.pctNote": "Valeurs en pourcentage (ex. 0,2 = 0,2 %).",
    "admin.settings.save": "Enregistrer",
    "admin.settings.saved": "Enregistré",
    "admin.settings.platform": "Plateforme",
    "admin.settings.logo": "Logo de la plateforme (PDF)",
    "admin.settings.logoDesc": "Logo affiché sur les PDF de devis et documents.",
    "admin.settings.logoUpload": "Téléverser",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "contact.title": "Contactez-nous",
    "contact.subtitle": "Une question ? Écrivez-nous, nous vous répondrons rapidement.",
    "contact.intro": "Remplissez le formulaire ci-dessous et notre équipe reviendra vers vous dans les meilleurs délais.",
    "contact.name": "Nom complet",
    "contact.email": "E-mail",
    "contact.company": "Entreprise",
    "contact.phone": "Téléphone",
    "contact.subject": "Sujet",
    "contact.subjectPlaceholder": "Choisissez un sujet",
    "contact.message": "Message",
    "contact.cat.general": "Question générale",
    "contact.cat.sell": "Vendre de l'huile d'olive",
    "contact.cat.buy": "Acheter de l'huile d'olive",
    "contact.cat.partnership": "Partenariat",
    "contact.cat.press": "Presse",
    "contact.cat.other": "Autre",
    "contact.consentPre": "J'accepte que mes informations soient traitées conformément à la ",
    "contact.privacyLink": "politique de confidentialité",
    "contact.submit": "Envoyer le message",
    "contact.sending": "Envoi…",
    "contact.success": "Message envoyé",
    "contact.successDesc": "Merci de nous avoir contactés. Nous vous répondrons dans les plus brefs délais.",
    "admin.contact.title": "Messages de contact",
    "admin.contact.subjectCol": "Sujet",
    "admin.contact.detail": "Détail du message",
    "dash.menu.adminContact": "Messages de contact",
    "faq.title": "Questions fréquentes",
    "faq.subtitle": "Tout ce qu'il faut savoir pour acheter et vendre de l'huile d'olive en gros sur EvooTunisia.",
    "faq.empty": "Aucune question pour le moment.",
    "faq.moreHelp": "Vous ne trouvez pas votre réponse ? Créez un compte et contactez-nous depuis votre espace.",
    "faq.cta": "Créer un compte gratuit",
    "faq.admin.title": "Gestion de la FAQ",
    "faq.admin.new": "Nouvelle question",
    "faq.admin.empty": "Aucune question. Ajoutez la première.",
    "faq.admin.back": "Retour à la liste",
    "faq.admin.question": "Question",
    "faq.admin.answer": "Réponse",
    "faq.admin.category": "Catégorie",
    "faq.admin.order": "Ordre",
    "faq.admin.published": "Publiée",
    "faq.admin.save": "Enregistrer",
    "faq.admin.saved": "Question enregistrée",
    "faq.admin.confirmDelete": "Supprimer cette question ?",
    "faq.admin.deleted": "Question supprimée",
    "faq.admin.needQuestion": "La question en français est obligatoire.",
    "faq.admin.statusPublished": "Publiée",
    "faq.admin.statusDraft": "Masquée",
    "dash.menu.adminFaq": "FAQ",
    "admin.market.title": "Gestion Marché & Prix",
    "admin.market.tabOrigin": "Prix à l'origine",
    "admin.market.tabRetail": "Prix GD",
    "admin.market.tabBalance": "Balance",
    "admin.market.tabSettings": "Réglages",
    "admin.market.addPoint": "Ajouter un point",
    "admin.market.addSeries": "Ajouter une série",
    "admin.market.date": "Date",
    "admin.market.price": "Prix",
    "admin.market.period": "Campagne",
    "admin.market.value": "Valeur (t)",
    "admin.market.delete": "Supprimer",
    "admin.market.save": "Enregistrer",
    "admin.market.saved": "Enregistré",
    "admin.market.confirmDelete": "Supprimer cette série ?",
    "admin.market.fx": "Taux de change (base TND)",
    "admin.market.tndPerEur": "TND pour 1 EUR",
    "admin.market.tndPerUsd": "TND pour 1 USD",
    "admin.market.thresholds": "Thermomètre",
    "admin.market.thermoUp": "Seuil hausse (%)",
    "admin.market.thermoDown": "Seuil baisse (%)",
    "admin.market.thermoWeeks": "Semaines analysées",
    "admin.market.comment": "Commentaire du thermomètre",
    "admin.market.newSeriesTitle": "Nouvelle série",
    "admin.market.currency": "Devise",
    "admin.market.source": "Source",
    "source.auto_eu": "auto (UE)",
    "source.auto_world": "auto (mondial)",
    "source.manual": "manuel (admin)",
    "market.lastUpdate": "Dernière mise à jour",
    "market.attribution": "Source : Commission européenne (Agri-food Data Portal) & FRED.",
    "market.worldIndex": "Cours mondial de référence (FRED)",
    "market.worldIndexDesc": "Indice mondial mensuel du prix de l'huile d'olive.",
    "admin.market.tabFeeds": "Flux automatiques",
    "admin.market.feedStatus": "État des flux automatiques",
    "admin.market.syncNow": "Synchroniser maintenant",
    "admin.market.syncing": "Synchronisation…",
    "admin.market.syncDone": "Synchronisation terminée",
    "admin.market.lastSuccess": "Dernier succès",
    "admin.market.lastError": "Dernière erreur",
    "admin.market.feedEu": "Commission européenne (prix à l'origine)",
    "admin.market.feedWorld": "FRED (indice mondial)",
    "admin.market.feedNote": "Les prix tunisiens et les marques distributeur restent en saisie manuelle.",

    "how.heading": "Comment ça marche",
    "how.subtitle": "Trois étapes simples pour conclure vos transactions.",
    "how.step1.title": "Publier",
    "how.step1.desc": "Vendeurs : créez votre lot vrac ou conditionné avec quantité, qualité et prix.",
    "how.step2.title": "Négocier",
    "how.step2.desc": "Recevez des offres, échangez avec les acheteurs et ajustez vos conditions.",
    "how.step3.title": "Conclure",
    "how.step3.desc": "Validez la transaction, organisez la logistique et l'export en toute confiance.",

    "cta.heading": "Prêt à développer votre activité oléicole ?",
    "cta.subtitle": "Rejoignez la communauté des professionnels de l'huile d'olive en Tunisie.",
    "cta.button": "Créer un compte gratuit",

    "footer.about": "EvooTunisia est la place de marché B2B dédiée à l'achat-vente d'huile d'olive tunisienne en gros, du vrac au conditionné, pour le marché local et l'export.",
    "footer.marketplace": "Marketplace",
    "footer.company": "Entreprise",
    "footer.legal": "Légal",
    "footer.about.link": "À propos",
    "footer.contact": "Contact",
    "footer.cgu": "Conditions générales (CGU)",
    "footer.privacy": "Politique de confidentialité",
    "footer.cookies": "Gestion des cookies",
    "footer.rights": "Tous droits réservés.",
    "footer.newsletter": "Restez informé des cours et des nouveaux lots.",
    "footer.newsletter.placeholder": "Votre e-mail professionnel",
    "footer.newsletter.button": "S'abonner",

    "currency.label": "Devise",
    "common.comingSoon": "Bientôt disponible",
    "common.comingSoon.desc": "Cette section fait partie du socle et sera activée dans une prochaine étape.",
    "common.backHome": "Retour à l'accueil",

    "login.title": "Connexion",
    "login.subtitle": "Accédez à votre espace professionnel.",
    "login.email": "E-mail",
    "login.password": "Mot de passe",
    "login.button": "Se connecter",
    "login.noAccount": "Pas encore de compte ?",
    "login.demo": "Interface de démonstration — authentification non active.",

    "register.title": "Créer un compte",
    "register.subtitle": "Rejoignez la marketplace en quelques minutes.",
    "register.company": "Nom de l'entreprise",
    "register.role": "Vous êtes",
    "register.role.buyer": "Acheteur",
    "register.role.seller": "Vendeur",
    "register.role.broker": "Courtier",
    "usertype.label": "Type d'utilisateur",
    "usertype.placeholder": "— Choisissez-en un —",
    "usertype.producer": "Producteur / Moulin à huile",
    "usertype.packer": "Acheteur / Conditionneur",
    "usertype.distributor": "Distributeur",
    "usertype.broker": "Intermédiaire",
    "usertype.other": "Autre",
    "usertype.hint": "Modifiable à tout moment depuis « Mon entreprise ».",
    "usertype.sellNote": "Ce type peut publier des lots (après vérification du compte).",
    "usertype.buyOnlyNote": "Ce type peut acheter et négocier.",
    "usertype.current": "Type d'utilisateur",
    "usertype.required": "Veuillez choisir un type d'utilisateur",
    "register.country": "Pays",
    "taxid.matricule_fiscal": "Matricule Fiscal",
    "taxid.cif_nif": "CIF / NIF",
    "taxid.siren_siret": "SIREN / SIRET",
    "taxid.partita_iva": "Partita IVA",
    "taxid.nif_nipc": "NIF / NIPC",
    "taxid.afm": "AFM",
    "taxid.ice": "ICE / Identifiant Fiscal",
    "taxid.generic": "N° d'identification fiscale / registre de commerce",
    "taxid.vat": "N° TVA intracommunautaire",
    "taxid.vatOptional": "(optionnel)",
    "taxid.format": "Format",
    "taxid.invalid": "Format d'identifiant invalide pour ce pays",
    "taxid.err.matricule_fiscal": "Matricule Fiscal invalide. Format attendu : 7 chiffres + lettre de clé, suffixes d'établissement optionnels (ex. 1234567A/P/M/000).",
    "taxid.err.cif_nif": "CIF/NIF invalide. Format attendu : 8 à 10 caractères alphanumériques (ex. B12345678).",
    "taxid.err.siren_siret": "SIREN / SIRET invalide. Format attendu : 9 chiffres (SIREN) ou 14 chiffres (SIRET) (ex. 123456789).",
    "taxid.err.partita_iva": "Partita IVA invalide. Format attendu : 11 chiffres (ex. 12345678901).",
    "taxid.err.nif_nipc": "NIF / NIPC invalide. Format attendu : 9 chiffres (ex. 123456789).",
    "taxid.err.afm": "AFM invalide. Format attendu : 9 chiffres (ex. 123456789).",
    "taxid.err.ice": "ICE invalide. Format attendu : 7 à 15 chiffres (ex. 001234567000012).",
    "taxid.err.generic": "Identifiant d'entreprise invalide. Saisissez au moins 4 caractères alphanumériques.",
    "consent.before": "J'accepte les ",
    "consent.terms": "termes du service",
    "consent.mid": " et la ",
    "consent.privacy": "politique de protection des données",
    "consent.required": "Vous devez accepter les conditions pour continuer",
    "kyc.doc.companyDocDyn": "Document officiel de l'entreprise ({id})",
    "company.usertype.saved": "Type d'utilisateur mis à jour",
    "register.button": "Créer mon compte",
    "register.hasAccount": "Déjà inscrit ?",

    "page.market.title": "Le marché",
    "page.prices.title": "Prix & analyse de marché",
    "page.directory.title": "Annuaire des huileries",
    "page.tools.title": "Outils",
    "tools.hub.subtitle": "Des outils concrets pour acheter, vendre et exporter l'huile d'olive tunisienne.",
    "tools.open": "Ouvrir",
    "tools.backTools": "Retour aux outils",
    "tools.calc.title": "Calculatrice de coûts",
    "tools.calc.desc": "Estimez votre coût de revient et prix rendu (Incoterm, logistique, TND/EUR/USD).",
    "tools.calc.basic": "Basique",
    "tools.calc.advanced": "Avancée",
    "tools.calc.inputCurrency": "Devise de saisie",
    "tools.calc.pricePerKg": "Prix au kg",
    "tools.calc.quantity": "Quantité",
    "tools.calc.incoterm": "Incoterm",
    "tools.calc.transport": "Transport",
    "tools.calc.insurance": "Assurance",
    "tools.calc.customs": "Douane / export",
    "tools.calc.handling": "Manutention",
    "tools.calc.financing": "Coûts financiers",
    "tools.calc.otherCosts": "Autres coûts",
    "tools.calc.marginPct": "Marge",
    "tools.calc.density": "Densité (kg/L)",
    "tools.calc.results": "Résultats",
    "tools.calc.goodsValue": "Valeur marchandise",
    "tools.calc.totalLogistics": "Total logistique",
    "tools.calc.totalCost": "Coût total",
    "tools.calc.costPerKg": "Coût de revient / kg",
    "tools.calc.costPerL": "Coût de revient / L",
    "tools.calc.sellingPrice": "Prix de vente conseillé / kg",
    "tools.calc.conversion": "Conversion",
    "tools.calc.densityNote": "Conversion kg → L basée sur une densité par défaut de 0,916 kg/L (modifiable en mode avancé).",
    "tools.calc.incotermNote": "Renseignez les coûts logistiques à votre charge selon l'Incoterm choisi.",
    "tools.alerts.title": "Alertes de marché",
    "tools.alerts.desc": "Soyez notifié par e-mail des nouveaux lots et des mouvements de prix.",
    "tools.alerts.doubleOptin": "Double confirmation : après votre inscription, cliquez sur le lien reçu par e-mail pour activer votre alerte.",
    "tools.alerts.newLots": "Alerte nouveaux lots",
    "tools.alerts.newLotsDesc": "Recevez un e-mail dès qu'un lot correspond à vos critères.",
    "tools.alerts.priceMove": "Alerte mouvement de prix",
    "tools.alerts.priceMoveDesc": "Recevez un e-mail quand les prix bougent au-delà de votre seuil.",
    "tools.alerts.email": "E-mail professionnel",
    "tools.alerts.market": "Marché",
    "tools.alerts.quality": "Qualité",
    "tools.alerts.packaging": "Conditionnement",
    "tools.alerts.governorate": "Gouvernorat / origine",
    "tools.alerts.minQty": "Quantité minimale",
    "tools.alerts.maxPrice": "Prix max (TND)",
    "tools.alerts.threshold": "Seuil de variation (%)",
    "tools.alerts.thresholdNote": "Vous serez notifié quand la variation du marché dépasse ce seuil.",
    "tools.alerts.subscribe": "S'abonner",
    "tools.alerts.checkEmail": "Vérifiez votre boîte e-mail pour confirmer votre abonnement.",
    "tools.alerts.confirmedMsg": "Votre alerte est confirmée et active.",
    "tools.alerts.invalidMsg": "Lien de confirmation invalide ou expiré.",
    "tools.alerts.unsubMsg": "Vous êtes désabonné de cette alerte.",
    "tools.packaging.title": "Conditionnement en Brik / à façon",
    "tools.packaging.desc": "Demandez un devis de conditionnement (Brik, verre, PET) ou en marque blanche.",
    "tools.packaging.intro": "Décrivez votre besoin de conditionnement : une huilerie ou un conditionneur partenaire vous recontactera avec un devis.",
    "tools.packaging.company": "Société",
    "tools.packaging.contact": "Contact",
    "tools.packaging.email": "E-mail",
    "tools.packaging.phone": "Téléphone",
    "tools.packaging.type": "Type d'emballage",
    "tools.packaging.volume": "Volume",
    "tools.packaging.quantity": "Quantité (unités)",
    "tools.packaging.whiteLabel": "Marque blanche (MDD)",
    "tools.packaging.message": "Message",
    "tools.packaging.submit": "Demander un devis",
    "tools.packaging.success": "Demande envoyée",
    "tools.packaging.successDesc": "Votre demande de devis a bien été enregistrée. Nous vous recontacterons rapidement.",
    "tools.inspection.title": "Inspection & analyses",
    "tools.inspection.desc": "Faites certifier et analyser vos lots par des laboratoires reconnus.",
    "tools.inspection.intro": "Retrouvez des laboratoires et organismes d'inspection pour l'analyse physico-chimique et sensorielle de vos lots d'huile d'olive, et demandez une mise en relation.",
    "tools.inspection.tunisia": "Laboratoires en Tunisie",
    "tools.inspection.international": "Références internationales",
    "tools.inspection.coiYes": "Agréé COI",
    "tools.inspection.coiToVerify": "Agrément à vérifier",
    "tools.inspection.coiNote": "Agréments à vérifier auprès de la liste officielle du COI.",
    "tools.inspection.coiLink": "Liste officielle des laboratoires COI",
    "tools.inspection.website": "Site web",
    "tools.inspection.requestLink": "Demander une mise en relation",
    "tools.inspection.disclaimer": "Ces organismes sont des références du secteur et ne sont pas des partenaires d'EvooTunisia.",
    "tools.inspection.formTitle": "Demande de mise en relation",
    "tools.inspection.formDesc": "Indiquez vos besoins d'analyse ; nous vous orientons vers le bon laboratoire.",
    "tools.inspection.lab": "Laboratoire souhaité",
    "tools.inspection.noPreference": "Sans préférence",
    "tools.inspection.lotRef": "Référence du lot",
    "tools.inspection.analyses": "Analyses souhaitées",
    "tools.inspection.analysesPlaceholder": "Acidité, peroxydes, K270, panel test…",
    "tools.inspection.submit": "Envoyer la demande",
    "tools.inspection.success": "Demande envoyée",
    "tools.inspection.successDesc": "Votre demande de mise en relation a bien été enregistrée. Nous revenons vers vous rapidement.",
    "dash.menu.adminTools": "Outils & demandes",
    "admin.tools.title": "Outils & demandes",
    "admin.tools.tabAlerts": "Alertes",
    "admin.tools.tabQuotes": "Devis conditionnement",
    "admin.tools.tabLeads": "Demandes d'inspection",
    "admin.tools.tabLabs": "Laboratoires",
    "admin.tools.noData": "Aucune donnée pour le moment.",
    "admin.tools.rowHint": "Cliquer pour le détail",
    "admin.tools.alertDetail": "Détail de l'abonnement",
    "admin.tools.quoteDetail": "Détail de la demande de devis",
    "admin.tools.leadDetail": "Détail de la demande d'inspection",
    "admin.tools.frequency": "Fréquence",
    "admin.tools.freqInstant": "Instantanée",
    "admin.tools.freqWeekly": "Hebdomadaire",
    "admin.tools.createdAt": "Créé le",
    "admin.tools.confirmedAt": "Confirmé le",
    "admin.tools.sendHistory": "Historique d'envois",
    "admin.tools.lastSent": "Dernier envoi",
    "admin.tools.lastDigest": "Dernier résumé",
    "admin.tools.never": "Jamais",
    "admin.tools.confirmManually": "Confirmer manuellement",
    "admin.tools.resendConfirmation": "Renvoyer la confirmation",
    "admin.tools.unsubscribe": "Supprimer / désabonner",
    "admin.tools.confirmDeleteAlert": "Supprimer définitivement cet abonnement ?",
    "admin.tools.alertConfirmed": "Abonnement confirmé",
    "admin.tools.confirmationResent": "E-mail de confirmation renvoyé",
    "admin.tools.alertDeleted": "Abonnement supprimé",
    "admin.tools.phone": "Téléphone",
    "admin.tools.message": "Message",
    "admin.tools.thread": "Fil de discussion",
    "admin.tools.noThread": "Aucun échange pour le moment.",
    "admin.tools.requestedLab": "Laboratoire souhaité",
    "admin.tools.requestedAnalyses": "Analyses demandées",
    "admin.tools.concernedLot": "Lot concerné",
    "admin.tools.note": "Note interne",
    "admin.tools.notePlaceholder": "Note interne (visible admin uniquement)…",
    "admin.tools.saveNote": "Enregistrer la note",
    "admin.tools.contactByEmail": "Contacter par e-mail",
    "admin.tools.callContact": "Appeler",
    "admin.tools.criteria": "Critères",
    "admin.tools.status": "Statut",
    "admin.tools.date": "Date",
    "admin.tools.confirmed": "Confirmée",
    "admin.tools.pending": "En attente",
    "admin.tools.newLab": "Nouveau laboratoire",
    "admin.tools.labName": "Nom du laboratoire",
    "admin.tools.messages": "Messages",
    "request.status.new": "Nouveau",
    "request.status.in_progress": "Traité",
    "request.status.closed": "Clôturé",
    "quotes.title": "Demandes de devis",
    "quotes.empty": "Aucune demande de devis pour le moment.",
    "quotes.backList": "Retour à la liste",
    "quotes.noMessages": "Aucun message. Envoyez une première réponse.",
    "quotes.replyPlaceholder": "Écrivez votre réponse…",
    "quotes.replied": "Réponse envoyée.",
    "quotes.sent": "Message envoyé.",
    "quotes.threadTitle": "Suivi de votre demande de devis",
    "quotes.threadSubtitle": "Échangez avec les huileries qui répondent à votre demande.",
    "quotes.notFound": "Demande introuvable ou lien expiré.",
    "quotes.waitingReplies": "En attente des réponses des huileries…",
    "quote.emit": "Émettre un devis",
    "quote.newQuote": "Nouveau devis structuré",
    "quote.currency": "Devise",
    "quote.vatMode": "Mode TVA",
    "quote.vatGlobal": "TVA globale",
    "quote.vatPerLine": "TVA par ligne",
    "quote.vatRate": "Taux de TVA (%)",
    "quote.lines": "Lignes du devis",
    "quote.lineDesc": "Désignation",
    "quote.lineQty": "Quantité",
    "quote.lineUnit": "Unité",
    "quote.lineUnitPrice": "PU HT",
    "quote.lineVat": "TVA %",
    "quote.lineTotal": "Total HT",
    "quote.addLine": "Ajouter une ligne",
    "quote.delivery": "Livraison / délai",
    "quote.deliveryPh": "Ex. sous 3 semaines, franco Sfax",
    "quote.incoterm": "Incoterm",
    "quote.validity": "Validité (jours)",
    "quote.notes": "Notes / conditions",
    "quote.attachments": "Pièces jointes",
    "quote.addAttachment": "Joindre un fichier",
    "quote.attachmentHint": "PDF, JPG, PNG, WEBP · max 15 Mo",
    "quote.subtotal": "Sous-total HT",
    "quote.vat": "TVA",
    "quote.total": "Total TTC",
    "quote.send": "Envoyer le devis",
    "quote.sent": "Devis envoyé.",
    "quote.cancel": "Annuler",
    "quote.confirm": "Confirmer",
    "quote.byMill": "Devis de",
    "quote.issuedDate": "émis le",
    "quote.validityLabel": "Validité",
    "quote.days": "jours",
    "quote.downloadPdf": "Télécharger le PDF",
    "quote.accept": "Accepter",
    "quote.refuse": "Refuser",
    "quote.revise": "Demander une révision",
    "quote.reviseComment": "Précisez les changements souhaités…",
    "quote.refuseComment": "Motif (optionnel)…",
    "quote.confirmAccept": "Confirmer l'acceptation de ce devis ? Un PDF de confirmation sera généré.",
    "quote.actionDone": "Réponse enregistrée.",
    "quote.needLine": "Ajoutez au moins une ligne valide.",
    "quote.acceptedLock": "Un devis a été accepté. Les autres devis sont clôturés.",
    "quote.status.sent": "En attente",
    "quote.status.accepted": "Accepté",
    "quote.status.refused": "Refusé",
    "quote.status.revision_requested": "Révision demandée",
    "quote.sys.accepted": "a accepté le devis",
    "quote.sys.refused": "a refusé le devis",
    "quote.sys.revision_requested": "a demandé une révision du devis",
    "quote.commentLabel": "Commentaire",
    "quote.compare.title": "Comparateur de devis",
    "quote.compare.provider": "Prestataire",
    "quote.compare.delay": "Délai",
    "quote.compare.status": "Statut",
    "quote.compare.open": "Ouvrir",
    "quote.compare.sortTotal": "Total",
    "quote.compare.sortDelay": "Délai",
    "quote.compare.multiCurrency": "Devises différentes — comparez en tenant compte de la devise de chaque devis.",
    "tools.alerts.frequency": "Fréquence",
    "tools.alerts.freq.instant": "Instantané",
    "tools.alerts.freq.weekly": "Récap hebdomadaire",
    "tools.alerts.freq.instantNote": "Un e-mail à chaque nouveau lot correspondant.",
    "tools.alerts.freq.weeklyNote": "Un seul e-mail groupé chaque semaine.",
    "tools.calc.incotermCompare": "Comparateur d'Incoterms",
    "tools.calc.incotermCompareDesc": "Coût rendu estimé selon l'Incoterm, à partir des coûts saisis.",
    "tools.calc.incotermCompareNote": "Estimation indicative : les coûts inclus varient selon l'accord commercial réel.",
    "tools.calc.selected": "sélectionné",
    "confirm.loading": "Confirmation en cours…",
    "confirm.ok.title": "Votre alerte est confirmée ✅",
    "confirm.ok.desc": "C'est fait ! Vous recevrez désormais nos notifications par e-mail selon vos critères.",
    "confirm.already.title": "Alerte déjà confirmée",
    "confirm.already.desc": "Cette alerte était déjà active. Vous n'avez rien de plus à faire.",
    "confirm.invalid.title": "Lien invalide",
    "confirm.invalid.desc": "Ce lien de confirmation n'est pas valide. Vous pouvez vous réinscrire ci-dessous.",
    "confirm.expired.title": "Lien expiré",
    "confirm.expired.desc": "Ce lien de confirmation a expiré. Merci de vous réinscrire pour recevoir vos alertes.",
    "confirm.error.title": "Une erreur est survenue",
    "confirm.error.desc": "Impossible de confirmer votre alerte pour le moment. Réessayez plus tard ou réinscrivez-vous.",
    "confirm.resubscribe": "Se réinscrire",
    "confirm.browseMarket": "Explorer le marché",
    "tools.alerts.alreadySubscribed": "Cette adresse est déjà inscrite aux alertes.",
    "tools.alerts.managePrefs": "Gérer mes préférences d'alerte",
    "tools.alerts.manageLinkSent": "Un lien sécurisé vous a été envoyé par e-mail.",
    "tools.alerts.alreadyPending": "Un e-mail de confirmation vous a déjà été envoyé.",
    "tools.alerts.resendConfirm": "Renvoyer l'e-mail de confirmation",
    "tools.alerts.resent": "E-mail de confirmation renvoyé.",
    "manage.title": "Gérer mes alertes",
    "manage.subtitle": "Modifiez vos critères, votre fréquence ou désabonnez-vous.",
    "manage.forEmail": "Vous gérez les alertes de :",
    "manage.none": "Aucune alerte pour cette adresse.",
    "manage.save": "Enregistrer",
    "manage.saved": "Préférences enregistrées.",
    "manage.unsubscribe": "Se désabonner",
    "manage.unsubscribed": "Vous êtes désabonné de cette alerte.",
    "manage.confirmUnsub": "Se désabonner supprimera définitivement cette alerte et votre e-mail associé. Continuer ?",
    "manage.consumed": "Vos préférences ont été enregistrées. Ce lien à usage unique est maintenant utilisé. Pour d'autres modifications, demandez un nouveau lien.",
    "manage.requestNew": "Recevoir un nouveau lien",
    "manage.active": "Active",
    "manage.paused": "En pause",
    "manage.invalid.title": "Lien invalide",
    "manage.invalid.desc": "Ce lien de gestion n'est pas valide. Demandez-en un nouveau depuis la page d'inscription aux alertes.",
    "manage.expired.title": "Lien expiré",
    "manage.expired.desc": "Ce lien de gestion a expiré. Demandez-en un nouveau depuis la page d'inscription aux alertes.",
    "page.blog.title": "Blog & Actualités",

    "directory.capacity": "Capacité",
    "directory.subtitle": "Le répertoire des huileries et moulins vérifiés, en Tunisie et à l'export.",
    "directory.search": "Rechercher une huilerie, une ville...",
    "directory.tunisia": "Tunisie",
    "directory.export": "Export (autres pays)",
    "directory.allRegions": "Tous",
    "directory.allVarieties": "Toutes variétés",
    "directory.filterVariety": "Variété",
    "directory.organicOnly": "Bio uniquement",
    "directory.viewProfile": "Voir la fiche",
    "directory.viewLots": "Voir ses lots",
    "directory.lotsAvailable": "{n} lot(s) en vente",
    "directory.noResults": "Aucune huilerie ne correspond à votre recherche.",
    "directory.varieties": "Variétés d'olives",
    "directory.certifications": "Certifications",
    "directory.contact": "Coordonnées",
    "directory.country": "Pays",
    "directory.about": "À propos",
    "directory.back": "Retour à l'annuaire",
    "directory.verified": "Vérifiée",
    "directory.results": "{n} huilerie(s)",
    "directory.exportTo": "Exporte vers",
    "directory.allCountries": "Tous les pays",
    "directory.selectGovernorate": "Gouvernorat",
    "directory.exportOpen": "Ouvert à l'export",
    "directory.exportMarkets": "Marchés d'export",
    "dirprofile.exportOpen": "Ouvert à l'export",
    "dirprofile.exportMarkets": "Marchés d'export",
    "dirprofile.exportMarketsHelp": "Ajoutez les pays vers lesquels vous exportez.",
    "dirprofile.addMarket": "Ajouter un pays...",
    "dash.menu.directoryProfile": "Ma fiche annuaire",
    "dirprofile.title": "Ma fiche annuaire",
    "dirprofile.intro": "Enrichissez votre vitrine publique dans l'annuaire des huileries.",
    "dirprofile.visible": "Visible dans l'annuaire",
    "dirprofile.visibleHelp": "Désactivez pour masquer votre fiche du public.",
    "dirprofile.description": "Description",
    "dirprofile.varieties": "Variétés d'olives",
    "dirprofile.varietiesHelp": "Séparez par des virgules (Chetoui, Chemlali...).",
    "dirprofile.capacity": "Capacité (tonnes/an)",
    "dirprofile.certifications": "Certifications",
    "dirprofile.certHelp": "Séparez par des virgules (Bio EU, IGP...).",
    "dirprofile.organic": "Certifiée biologique",
    "dirprofile.city": "Ville",
    "dirprofile.country": "Pays",
    "dirprofile.contactEmail": "Email de contact",
    "dirprofile.photos": "Photos",
    "dirprofile.addPhoto": "Ajouter une photo",
    "dirprofile.logo": "Logo de l'huilerie",
    "dirprofile.logoHelp": "Affiché sur vos devis PDF. PNG/JPG/WEBP, fond clair de préférence.",
    "dirprofile.addLogo": "Ajouter un logo",
    "dirprofile.replaceLogo": "Remplacer",
    "dirprofile.save": "Enregistrer ma fiche",
    "dirprofile.saved": "Fiche mise à jour",
    "dirprofile.locked": "Votre entreprise doit être vérifiée en tant que vendeur pour apparaître dans l'annuaire.",
    "directory.system": "Système",
    "directory.certifications": "Certifications",
    "blog.readMore": "Lire l'article",
    "blog.subtitle": "Analyses de marché, oléiculture, qualité et export — le média B2B de la filière huile d'olive tunisienne.",
    "blog.type.all": "Tout",
    "blog.type.article": "Articles",
    "blog.type.market": "Point marché",
    "blog.cat.all": "Toutes catégories",
    "blog.cat.marche": "Marché & prix",
    "blog.cat.oleiculture": "Oléiculture",
    "blog.cat.qualite": "Qualité",
    "blog.cat.export": "Export",
    "blog.cat.recettes": "Recettes & usages",
    "blog.cat.reglementation": "Réglementation",
    "blog.empty": "Aucun article pour le moment. Revenez bientôt !",
    "blog.linkCopied": "Lien copié dans le presse-papiers",
    "blog.notFound": "Article introuvable.",
    "blog.backToBlog": "Retour au blog",
    "blog.share": "Partager",
    "blog.aiPublicNotice": "Cet article a été rédigé avec l'assistance de l'IA et relu par notre rédaction.",
    "blog.related": "À lire aussi",
    "blog.admin.title": "Blog & contenus",
    "blog.admin.new": "Nouvel article",
    "blog.admin.empty": "Aucun article. Créez votre premier contenu.",
    "blog.admin.confirmDelete": "Supprimer définitivement cet article ?",
    "blog.admin.deleted": "Article supprimé",
    "blog.admin.needContent": "Ajoutez au moins un titre ou un contenu dans une langue.",
    "blog.admin.saved": "Article enregistré",
    "blog.admin.status.draft": "Brouillon",
    "blog.admin.status.published": "Publié",
    "blog.admin.backList": "Retour à la liste",
    "blog.admin.langContent": "Contenu",
    "blog.admin.fTitle": "Titre",
    "blog.admin.fSlug": "Slug (URL)",
    "blog.admin.fExcerpt": "Extrait / chapô",
    "blog.admin.fContent": "Contenu (Markdown)",
    "blog.admin.contentPlaceholder": "Rédigez votre article en Markdown…",
    "blog.admin.seo": "Référencement (SEO)",
    "blog.admin.metaTitle": "Titre meta",
    "blog.admin.metaDesc": "Description meta",
    "blog.admin.settings": "Paramètres",
    "blog.admin.category": "Catégorie",
    "blog.admin.type": "Type de contenu",
    "blog.admin.author": "Auteur",
    "blog.admin.cover": "Image de couverture",
    "blog.admin.coverUpload": "Téléverser une image",
    "blog.admin.coverUploading": "Téléversement…",
    "blog.admin.coverOr": "ou collez une URL d'image",
    "blog.admin.coverRemove": "Retirer",
    "blog.admin.coverHint": "JPG, PNG ou WEBP — max 15 Mo. Utilisez des photos réelles (oliviers, moulins).",
    "blog.admin.currentStatus": "Statut actuel",
    "blog.admin.saveDraft": "Enregistrer le brouillon",
    "blog.admin.publish": "Publier",
    "blog.admin.write": "Écrire",
    "blog.admin.preview": "Aperçu",
    "blog.ai.title": "Générateur d'article (IA)",
    "blog.ai.subject": "Sujet de l'article",
    "blog.ai.langs": "Langues à générer",
    "blog.ai.tone": "Ton",
    "blog.ai.length": "Longueur",
    "blog.ai.len.court": "Court",
    "blog.ai.len.moyen": "Moyen",
    "blog.ai.len.long": "Long",
    "blog.ai.type": "Type de contenu",
    "blog.ai.keywords": "Mots-clés SEO (optionnel)",
    "blog.ai.sourceData": "Données source (optionnel)",
    "blog.ai.sourcePlaceholder": "Collez ici des chiffres/faits à utiliser tels quels (l'IA n'inventera rien).",
    "blog.ai.warning": "L'IA peut se tromper. Relisez et vérifiez les faits avant de publier.",
    "blog.ai.generate": "Générer le brouillon",
    "blog.ai.translateBtn": "Traduire vers les autres langues",
    "blog.ai.needSubject": "Indiquez un sujet.",
    "blog.ai.done": "Brouillon généré",
    "blog.ai.failed": "La génération a échoué. Réessayez.",
    "blog.ai.needSource": "Rédigez d'abord le contenu dans la langue source.",
    "blog.ai.translated": "Traductions générées",
    "dash.menu.adminBlog": "Blog",

    "nav.dashboard": "Tableau de bord",
    "auth.logout": "Déconnexion",
    "auth.error": "Une erreur est survenue. Réessayez.",
    "badge.verified": "Vérifié",
    "common.loading": "Chargement…",
    "common.optional": "(optionnel)",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",

    "register.name": "Nom du représentant",
    "register.matricule": "Matricule fiscal",
    "register.address": "Adresse",
    "register.governorate": "Gouvernorat",
    "register.phone": "Téléphone",
    "register.website": "Site web",
    "register.section.account": "Vos identifiants",
    "register.section.company": "Votre entreprise",
    "register.free": "Inscription 100 % gratuite — aucun paiement requis.",

    "dash.welcome": "Bienvenue, {name}",
    "dash.subtitle": "Gérez votre activité sur EvooTunisia.",
    "dash.menu.overview": "Vue d'ensemble",
    "dash.menu.lots": "Mes lots",
    "dash.menu.offers": "Mes offres",
    "dash.menu.messages": "Messages",
    "dash.menu.company": "Mon entreprise",
    "dash.menu.verification": "Vérification",
    "dash.menu.settings": "Paramètres",
    "dash.verify.cta": "Vérifier mon compte",
    "dash.verify.banner": "Votre compte n'est pas encore vérifié. Vérifiez-le pour obtenir le badge et prioriser vos lots.",
    "dash.card.status": "Statut du compte",
    "dash.card.role": "Type de compte",
    "dash.card.company": "Entreprise",

    "company.title": "Mon entreprise",
    "company.subtitle": "Informations de votre entreprise rattachée.",
    "company.saved": "Entreprise mise à jour.",
    "company.matriculeLocked": "Le matricule fiscal ne peut pas être modifié.",

    "kyc.title": "Vérification du compte",
    "kyc.subtitle": "Téléversez vos documents pour obtenir le badge « Vérifié ».",
    "kyc.status.unverified": "Non vérifié",
    "kyc.status.pending": "En attente",
    "kyc.status.verified": "Vérifié",
    "kyc.status.rejected": "Refusé",
    "kyc.doc.company_doc": "Document officiel de l'entreprise (patente / matricule fiscal)",
    "kyc.doc.link_proof": "Preuve du lien avec l'entreprise",
    "kyc.doc.id_document": "Pièce d'identité du représentant",
    "kyc.doc.bank_rib": "RIB / certificat bancaire",
    "kyc.upload": "Téléverser",
    "kyc.replace": "Remplacer",
    "kyc.uploaded": "Téléversé",
    "kyc.view": "Voir",
    "kyc.submit": "Soumettre pour vérification",
    "kyc.submitted": "Documents soumis. Vérification en attente.",
    "kyc.secure": "Vos documents sont chiffrés et ne sont jamais rendus publics.",
    "kyc.sellerNote": "En tant que vendeur, un RIB / certificat bancaire est requis.",
    "kyc.pendingNote": "Vos documents sont en cours d'examen par notre équipe.",
    "kyc.verifiedNote": "Félicitations ! Votre compte est vérifié.",
    "kyc.rejectedNote": "Votre vérification a été refusée. Merci de re-soumettre des documents valides.",

    "settings.title": "Paramètres",
    "settings.email": "E-mail",
    "settings.role": "Type de compte",
    "settings.notifications": "Notifications",
    "settings.notifyQuotes": "Recevoir les nouvelles demandes de devis par e-mail",
    "settings.notifyQuotesSaved": "Préférence enregistrée",
    "settings.emailPrefs": "Préférences d'e-mail",
    "settings.emailPrefsDesc": "Choisissez les e-mails que vous souhaitez recevoir. La cloche de notifications reste toujours active.",
    "settings.prefsSaved": "Préférences enregistrées",
    "settings.pref.negotiations": "Offres & négociations",
    "settings.pref.quotes": "Devis de conditionnement",
    "settings.pref.verification": "Décision de vérification (KYC)",
    "settings.pref.alerts": "Alertes de marché",
    "settings.pref.transactionalNote": "Les e-mails de sécurité et transactionnels (confirmation d'adresse, réinitialisation de mot de passe) sont toujours envoyés.",
    "dash.menu.deals": "Historique des deals",
    "deals.title": "Historique des deals",
    "deals.empty": "Aucune opération conclue pour le moment.",
    "deals.revenue": "Chiffre d'affaires",
    "deals.spend": "Total des achats",
    "deals.totalCommission": "Commissions cumulées",
    "deals.count": "opérations",
    "deals.date": "Date",
    "deals.role": "Rôle",
    "deals.product": "Produit",
    "deals.counterparty": "Contrepartie",
    "deals.quantity": "Quantité",
    "deals.total": "Montant",
    "deals.commission": "Commission",
    "deals.seller": "Vente",
    "deals.buyer": "Achat",
    "settings.soon": "D'autres paramètres arriveront bientôt.",

    "auth.google": "Continuer avec Google",
    "auth.or": "ou",
    "auth.connecting": "Connexion en cours…",
    "profile.title": "Compléter votre profil",
    "profile.subtitle": "Encore une étape : renseignez votre entreprise pour accéder à la marketplace.",
    "profile.submit": "Terminer",
    "profile.welcome": "Bienvenue {name} ! Choisissez votre type de compte et votre entreprise.",

    "quality.premium_bio": "Premium / Bio",
    "quality.grignon": "Grignon",
    "incoterm.label": "Incoterm",
    "common.close": "Fermer",
    "common.all": "Tous",

    "vrac.publish": "Publier un lot",
    "vrac.filters": "Filtres",
    "vrac.filter.quality": "Qualité",
    "vrac.filter.qty": "Quantité (kg)",
    "vrac.filter.acidityMax": "Acidité max (º)",
    "vrac.filter.governorate": "Gouvernorat",
    "vrac.filter.price": "Prix (TND/kg)",
    "vrac.filter.incoterm": "Incoterm",
    "vrac.filter.min": "Min",
    "vrac.filter.max": "Max",
    "vrac.filter.reset": "Réinitialiser",
    "vrac.sort": "Trier",
    "vrac.sort.recent": "Plus récents",
    "vrac.sort.price_asc": "Prix croissant",
    "vrac.sort.price_desc": "Prix décroissant",
    "vrac.sort.qty_desc": "Quantité",
    "vrac.empty": "Aucun lot ne correspond à votre recherche.",
    "vrac.results": "{n} lot(s)",

    "lot.acidity": "Acidité",
    "lot.peroxides": "Indice de peroxyde",
    "lot.k270": "K270",
    "lot.polyphenols": "Polyphénols",
    "lot.panel": "Panel test",
    "lot.incoterm": "Incoterm",
    "lot.origin": "Origine",
    "lot.availability": "Disponibilité",
    "lot.description": "Description",
    "lot.documents": "Analyses & documents",
    "lot.characteristics": "Caractéristiques",
    "lot.seller": "Vendeur",
    "lot.makeOffer": "Faire une offre",
    "lot.contact": "Contacter",
    "lot.notFound": "Lot introuvable",
    "lot.perKg": "/ kg",
    "lot.back": "Retour au marché",

    "offer.title": "Faire une offre",
    "offer.subtitle": "Démarrez une négociation privée avec le vendeur.",
    "offer.price": "Prix proposé",
    "offer.quantity": "Quantité",
    "offer.message": "Message",
    "offer.send": "Envoyer l'offre",
    "offer.sent": "Offre envoyée !",

    "lotform.new": "Nouveau lot vrac",
    "lotform.edit": "Modifier le lot",
    "lotform.title": "Titre du lot",
    "lotform.variety": "Variété",
    "lotform.acidity": "Acidité (º)",
    "lotform.peroxides": "Indice de peroxyde",
    "lotform.k270": "K270",
    "lotform.polyphenols": "Polyphénols",
    "lotform.panel": "Panel test",
    "lotform.governorate": "Gouvernorat d'origine",
    "lotform.country": "Pays d'origine",
    "lotform.availability": "Disponibilité",
    "lotform.photos": "Photos",
    "lotform.docs": "Analyses (PDF)",
    "lotform.addFiles": "Ajouter des fichiers",
    "lotform.uploading": "Envoi…",
    "lotform.created": "Lot publié !",
    "lotform.updated": "Lot mis à jour",

    "mylots.new": "Publier un lot",
    "mylots.empty": "Vous n'avez pas encore publié de lot.",
    "mylots.notVerifiedTitle": "Compte non vérifié",
    "mylots.notVerified": "Seuls les vendeurs vérifiés peuvent publier des lots.",
    "mylots.markSold": "Marquer vendu",
    "mylots.reactivate": "Réactiver",
    "mylots.withdraw": "Retirer",
    "mylots.edit": "Modifier",
    "status.available": "Disponible",
    "status.sold": "Vendu",
    "status.withdrawn": "Retiré",

    "myoffers.empty": "Aucune offre pour le moment.",
    "myoffers.sent": "Envoyée",
    "myoffers.received": "Reçue",

    "req.publish": "Publier une demande",
    "req.new": "Nouvelle demande d'achat",
    "req.quality": "Qualité recherchée",
    "req.quantity": "Quantité (kg)",
    "req.targetPrice": "Prix cible (TND/kg)",
    "req.origin": "Origine souhaitée",
    "req.description": "Détails",
    "req.submit": "Publier la demande",
    "req.created": "Demande publiée !",
    "req.empty": "Aucune demande d'achat pour l'instant.",
    "req.looking": "recherche",
    "req.buyerNote": "Publiez ce que vous recherchez pour recevoir des propositions.",

    "cond.market": "Marché Conditionné",
    "cond.publish": "Publier un lot conditionné",
    "cond.units": "unités",
    "cond.format": "Format",
    "cond.minOrder": "Commande minimale",
    "cond.brand": "Marque",
    "cond.whiteLabel": "Marque blanche",
    "cond.whiteLabelBadge": "Marque blanche",
    "cond.perUnit": "/ unité",
    "cond.filter.packaging": "Type d'emballage",
    "cond.filter.price": "Prix (TND/unité)",
    "cond.filter.volume": "Format (volume)",
    "packaging.verre": "Verre",
    "packaging.pet": "PET",
    "packaging.bidon_metal": "Bidon métal",
    "packaging.brik": "Brik",
    "packaging.canette": "Canette",
    "packaging.monodose": "Monodose",
    "packaging.dosettes": "Dosettes / perles",
    "lotform.market": "Type de marché",
    "lotform.packaging": "Type d'emballage",
    "lotform.volume": "Volume par unité (ml)",
    "lotform.units": "Nombre d'unités",
    "lotform.minOrder": "Commande minimale (unités)",
    "lotform.brand": "Marque / étiquette",
    "lotform.whiteLabel": "Marque blanche disponible",
    "lotform.pricePerUnit": "Prix par unité (TND)",
    "alert.title": "Alertes de nouveaux lots conditionnés",
    "alert.cta": "Recevoir des alertes",
    "alert.subtitle": "Soyez notifié par e-mail selon vos critères.",
    "alert.email": "Votre e-mail",
    "alert.quality": "Qualité (optionnel)",
    "alert.packaging": "Emballage (optionnel)",
    "alert.governorate": "Origine (optionnel)",
    "alert.maxPrice": "Prix max par unité (optionnel)",
    "alert.submit": "Activer les alertes",
    "alert.created": "Presque terminé ! Vérifiez votre e-mail pour confirmer votre alerte.",
    "alert.note": "L'envoi d'e-mails sera activé prochainement.",

    "nego.center": "Messagerie & négociations",
    "nego.empty": "Aucune conversation pour l'instant.",
    "nego.selectConv": "Sélectionnez une conversation",
    "nego.you": "Vous",
    "nego.buyer": "Acheteur",
    "nego.seller": "Vendeur",
    "nego.counter": "Contre-offre",
    "nego.accept": "Accepter",
    "nego.refuse": "Refuser",
    "nego.send": "Envoyer",
    "nego.message": "Message",
    "nego.messagePlaceholder": "Écrire un message…",
    "nego.price": "Prix",
    "nego.quantity": "Quantité",
    "nego.makeCounter": "Faire une contre-offre",
    "nego.status.pending": "En attente",
    "nego.status.countered": "Contrée",
    "nego.status.accepted": "Acceptée",
    "nego.status.refused": "Refusée",
    "nego.status.expired": "Expirée",
    "nego.awaiting": "En attente de votre réponse",
    "nego.concluded": "Opération conclue",
    "nego.closedUnavailable": "Lot indisponible",
    "nego.downloadQuote": "Télécharger la confirmation de devis (PDF)",
    "nego.lotUnavailableMsg": "Ce lot n'est plus disponible.",
    "nego.summary": "Récapitulatif",
    "nego.finalQty": "Quantité",
    "nego.finalPrice": "Prix unitaire",
    "nego.total": "Montant total",
    "nego.commBuyer": "Commission acheteur",
    "nego.commSeller": "Commission vendeur",
    "nego.export": "Opération à l'export (international)",
    "nego.transportNote": "La plateforme ne gère pas le transport. La logistique est assurée par les parties selon l'Incoterm convenu.",
    "nego.offerLine": "Offre : {qty} × {price}",
    "nego.tabActive": "Négociations actives",
    "nego.tabConcluded": "Conclues / Archivées",
    "nego.emptyActive": "Aucune négociation active.",
    "nego.emptyConcluded": "Aucune opération conclue.",
    "nego.lotLabel": "Lot",
    "nego.offerStatus": "Statut de l'offre",
    "admin.commission.title": "Barème de commission",
    "admin.commission.vracNatB": "Vrac national — acheteur (%)",
    "admin.commission.vracNatS": "Vrac national — vendeur (%)",
    "admin.commission.vracExpB": "Vrac export — acheteur (%)",
    "admin.commission.vracExpS": "Vrac export — vendeur (%)",
    "admin.commission.condB": "Conditionné — acheteur (%)",
    "admin.commission.condS": "Conditionné — vendeur (%)",
    "admin.commission.saved": "Barème enregistré.",
    "emailconf.checkTitle": "Vérifiez votre adresse e-mail",
    "emailconf.checkDesc": "Nous avons envoyé un lien de confirmation à {email}. Cliquez sur ce lien pour activer votre compte, puis connectez-vous.",
    "emailconf.spamHelp": "Vous n'avez pas reçu l'e-mail ? Pensez à vérifier votre dossier spam / courrier indésirable, puis cliquez sur « Renvoyer l'e-mail de confirmation ».",
    "emailconf.resend": "Renvoyer l'e-mail de confirmation",
    "emailconf.resent": "E-mail de confirmation renvoyé.",
    "emailconf.loginBlockedTitle": "Confirmez votre adresse e-mail",
    "emailconf.loginBlockedDesc": "Votre adresse e-mail n'est pas encore confirmée. Cliquez sur le lien reçu par e-mail pour accéder à votre compte.",
    "emailconf.confirming": "Confirmation en cours…",
    "emailconf.confirmedTitle": "Adresse e-mail confirmée",
    "emailconf.confirmedDesc": "Votre adresse e-mail est confirmée. Vous pouvez maintenant vous connecter.",
    "emailconf.invalidTitle": "Lien invalide",
    "emailconf.invalidDesc": "Ce lien de confirmation n'est pas valide. Saisissez votre e-mail pour recevoir un nouveau lien.",
    "emailconf.expiredTitle": "Lien expiré",
    "emailconf.expiredDesc": "Ce lien de confirmation a expiré. Saisissez votre e-mail pour recevoir un nouveau lien.",
    "emailconf.goLogin": "Aller à la connexion",
    "emailconf.emailPlaceholder": "Votre adresse e-mail",
    "emailconf.notKyc": "La confirmation d'e-mail est distincte de la vérification documentaire (KYC) de votre entreprise.",
    "emailconf.backToLogin": "Retour à la connexion",
    "notif.title": "Notifications",
    "notif.empty": "Aucune notification.",
    "notif.markAll": "Tout marquer comme lu",
    "myquotes.title": "Mes demandes de devis",
    "myquotes.subtitle": "Suivez vos demandes envoyées et les devis reçus.",
    "myquotes.empty": "Vous n'avez pas encore envoyé de demande de devis.",
    "myquotes.new": "Nouvelle demande",
    "myquotes.responsesCount": "{n} devis reçu(s)",
    "verifygate.title": "Vérification requise",
    "verifygate.desc": "Votre compte doit être vérifié (KYC) pour conclure une opération. Vous pouvez continuer à naviguer, demander des devis et négocier, mais la conclusion nécessite un compte vérifié.",
    "verifygate.counterparty": "L'autre partie n'est pas encore vérifiée. La conclusion sera possible une fois les deux comptes vérifiés.",
    "verifygate.cta": "Compléter la vérification",
    "verifygate.later": "Plus tard",
    "packaging.loggedInNote": "Demande envoyée en tant que {company}. Elle apparaîtra dans « Mes demandes de devis ».",
    "packaging.viewMyQuotes": "Voir mes demandes de devis",
    "cookie.title": "Nous respectons votre vie privée",
    "cookie.message": "Nous utilisons des cookies essentiels au fonctionnement du site et, avec votre accord, des cookies de mesure d'audience et de marketing. Vous pouvez accepter, refuser ou personnaliser vos choix.",
    "cookie.policy": "Politique cookies",
    "cookie.accept": "Tout accepter",
    "cookie.reject": "Tout refuser",
    "cookie.manage": "Personnaliser",
    "cookie.save": "Enregistrer mes choix",
    "cookie.essential": "Cookies essentiels",
    "cookie.essentialDesc": "Nécessaires au fonctionnement du site (toujours actifs).",
    "cookie.analytics": "Mesure d'audience",
    "cookie.analyticsDesc": "Nous aident à comprendre l'utilisation du site.",
    "cookie.marketing": "Marketing",
    "cookie.marketingDesc": "Personnalisation des contenus et publicités.",
    "admin.treasury.title": "Trésorerie des commissions",
    "admin.treasury.subtitle": "Facturé vs encaissé par mois. Encaissement manuel par virement bancaire (le statut « Payée » est validé par un administrateur).",
    "admin.treasury.runReminders": "Envoyer les relances",
    "admin.treasury.remindersSent": "{n} relance(s) de paiement envoyée(s)",
    "admin.treasury.remindersError": "Échec de l'envoi des relances",
    "admin.treasury.billed": "Facturé",
    "admin.treasury.collected": "Encaissé",
    "admin.treasury.outstanding": "En attente",
    "admin.treasury.overdue": "Échues",
    "admin.treasury.invoices": "factures",
    "admin.treasury.paid": "payées",
    "admin.treasury.awaiting": "en validation",
    "admin.treasury.issued": "émises",
    "admin.treasury.month": "Mois",
    "admin.treasury.noData": "Aucune facture pour le moment.",
    "pricedigest.badge": "Gratuit · Hebdomadaire",
    "pricedigest.title": "Recevez les prix du marché chaque semaine",
    "pricedigest.desc": "Un e-mail par semaine avec les prix de l'huile d'olive à l'origine en Tunisie et la tendance du marché. Résiliable en un clic.",
    "pricedigest.subscribe": "Je m'abonne",
    "pricedigest.consent": "J'accepte de recevoir cet e-mail hebdomadaire et la",
    "pricedigest.privacy": "politique de protection des données",
    "pricedigest.consentRequired": "Veuillez accepter pour continuer.",
    "pricedigest.optinNote": "Double confirmation : vous recevrez un e-mail pour valider votre inscription.",
    "dash.menu.adminInvoices": "Factures",
    "admin.invoices.title": "Factures (toutes)",
    "admin.invoices.allStatuses": "Tous les statuts",
    "admin.invoices.period": "Période (mois)",
    "admin.invoices.search": "Recherche",
    "admin.invoices.searchPlaceholder": "N° facture, opération, entreprise…",
    "admin.invoices.count": "Factures",
    "admin.invoices.empty": "Aucune facture ne correspond à ces filtres.",
    "admin.invoices.export": "Exporter",
    "admin.invoices.exportCsv": "CSV (.csv)",
    "admin.invoices.exportExcel": "Excel (.xlsx)",
    "admin.invoices.exportError": "Échec de l'export.",
    "admin.digest.title": "Digest prix hebdomadaire",
    "admin.digest.subtitle": "Aperçu et test de l'e-mail envoyé automatiquement chaque lundi aux abonnés confirmés.",
    "admin.digest.subscribers": "abonnés confirmés",
    "admin.digest.preview": "Aperçu",
    "admin.digest.previewTitle": "Aperçu du digest prix",
    "admin.digest.testEmail": "E-mail de test",
    "admin.digest.sendTest": "Envoyer un test",
    "admin.digest.testSent": "E-mail de test envoyé à {email}",
    "admin.digest.testError": "Échec de l'envoi du test.",
    "admin.digest.emailRequired": "Veuillez saisir un e-mail.",
    "admin.digest.unavailable": "Aucune donnée de prix disponible pour générer le digest.",
  },

  ar: {
    "brand.tagline": "سوق B2B لزيت الزيتون التونسي",
    "nav.home": "الرئيسية",
    "nav.market": "السوق",
    "nav.market.bulk": "سائب",
    "nav.market.packaged": "معبأ",
    "nav.market.requests": "الطلبات",
    "nav.prices": "الأسعار",
    "nav.directory": "دليل المعاصر",
    "nav.tools": "أدوات",
    "nav.blog": "المدونة",
    "nav.login": "تسجيل الدخول",
    "nav.register": "إنشاء حساب",
    "nav.menu": "القائمة",
    "nav.language": "اللغة",
    "nav.currency": "العملة",
    "seo.home.title": "منصة B2B لبيع زيت الزيتون بالجملة في تونس",
    "seo.home.desc": "تربط EvooTunisia المنتجين والمعاصر والمشترين لزيت الزيتون بالجملة. تفاوض على الزيت السائب والمعبأ، وتابع أسعار السوق، واعثر على معاصر موثّقة.",
    "seo.market.vrac.title": "زيت زيتون سائب — سوق الجملة",
    "seo.market.vrac.desc": "اشترِ وبِع زيت الزيتون السائب (بكر ممتاز، بكر، لامبانت). لوطات موثّقة وفلاتر حسب الجودة والحموضة والسعر والولاية.",
    "seo.market.conditionne.title": "زيت زيتون معبأ — بيع بالجملة",
    "seo.market.conditionne.desc": "اعثر على زيت زيتون معبأ بالجملة: قوارير وعبوات وتغليف مخصّص من مورّدين تونسيين موثّقين.",
    "seo.market.demandes.title": "طلبات شراء زيت الزيتون بالجملة",
    "seo.market.demandes.desc": "اطّلع على طلبات شراء زيت الزيتون التي ينشرها المشترون وردّ عليها بعروض البيع بالجملة.",
    "seo.prices.title": "أسعار زيت الزيتون في تونس — الأسعار والاتجاهات",
    "seo.prices.desc": "تابع أسعار زيت الزيتون بالجملة في تونس: الأسعار الحالية والتاريخية واتجاهات السوق حسب الجودة.",
    "seo.directory.title": "دليل معاصر الزيتون التونسية",
    "seo.directory.desc": "اكتشف معاصر ومطاحن زيت الزيتون في تونس: بيانات الاتصال والشهادات والأصناف وطاقات الإنتاج.",
    "seo.tools.title": "أدوات لمحترفي زيت الزيتون",
    "seo.tools.desc": "حاسبة سعر التكلفة، وتنبيهات السوق، وعروض التغليف، ومخابر الفحص لمحترفي زيت الزيتون.",
    "seo.tools.calculator.title": "حاسبة سعر التكلفة",
    "seo.tools.calculator.desc": "قدّر سعر التكلفة والهامش لزيت الزيتون بالجملة، بما في ذلك النقل والتغليف والعمولة.",
    "seo.tools.alerts.title": "تنبيهات السوق — زيت الزيتون",
    "seo.tools.alerts.desc": "احصل على تنبيه عبر البريد فور توفّر لوط زيت زيتون يطابق معايير السعر والجودة والكمية.",
    "seo.tools.packaging.title": "عروض التغليف — زيت الزيتون",
    "seo.tools.packaging.desc": "اطلب عروض تغليف (قوارير، عبوات، ملصقات) من مغلّفين تونسيين موثّقين.",
    "seo.tools.inspection.title": "مخابر الفحص والتحليل",
    "seo.tools.inspection.desc": "اعثر على مخابر لفحص وتحليل جودة زيت الزيتون قبل الشحن.",
    "seo.blog.title": "مدونة وأخبار زيت الزيتون",
    "seo.blog.desc": "تحليلات السوق وأدلة وأخبار حول زيت الزيتون التونسي، بعدة لغات ويُحدَّث بانتظام.",
    "seo.faq.title": "الأسئلة الشائعة",
    "seo.faq.desc": "إجابات عن الأسئلة الشائعة حول شراء وبيع زيت الزيتون بالجملة على EvooTunisia.",

    "hero.badge": "منشأ تونس · سائب ومعبأ · تصدير",
    "hero.title": "اشترِ وبِع زيت الزيتون التونسي بالجملة",
    "hero.subtitle": "المنصة التي تربط المعاصر والتعاونيات والمنتجين والوسطاء بالمشترين والمصدّرين. معاملات مباشرة، أسعار شفافة، جودة موثّقة.",
    "hero.cta.primary": "استكشف السوق",
    "hero.cta.secondary": "أضف عرضًا",
    "hero.stat.lots": "عروض معروضة",
    "hero.stat.mills": "معاصر مسجّلة",
    "hero.stat.regions": "مناطق مغطّاة",
    "hero.stat.members": "أعضاء نشطون",

    "value.heading": "لماذا EvooTunisia",
    "value.subtitle": "أداة مصمّمة لمهنيي قطاع الزيتون، من المعصرة إلى التصدير.",
    "value.direct.title": "تواصل مباشر",
    "value.direct.desc": "تفاوض دون وسيط بين بائعين ومشترين موثوقين.",
    "value.verified.title": "أطراف موثوقة",
    "value.verified.desc": "معاصر وتعاونيات ووسطاء بملفات وشهادات.",
    "value.transparency.title": "أسعار شفافة",
    "value.transparency.desc": "تابع الأسعار حسب المنطقة والجودة، محدّثة باستمرار.",
    "value.export.title": "موجّه للتصدير",
    "value.export.desc": "تتبّع وحموضة ومطابقة للأسواق الدولية.",

    "lots.heading": "عروض حديثة للبيع",
    "lots.subtitle": "مجموعة مختارة من العروض المنشورة من بائعينا في كل أنحاء تونس.",
    "lots.viewAll": "عرض كل السوق",
    "lots.quantity": "الكمية",
    "lots.acidity": "الحموضة",
    "lots.view": "عرض التفاصيل",
    "lots.organic": "عضوي",
    "lots.perUnit": "/ {unit}",
    "type.vrac": "سائب",
    "type.conditionne": "معبأ",
    "quality.extra_vierge": "بكر ممتاز",
    "quality.vierge": "بكر",
    "quality.lampante": "لامبانت",
    "quality.bio": "عضوي",

    "prices.heading": "أسعار السوق",
    "prices.subtitle": "أسعار استرشادية لزيت الزيتون حسب المنطقة والجودة.",
    "prices.region": "المنطقة",
    "prices.quality": "الجودة",
    "prices.price": "السعر",
    "prices.change": "التغيّر",
    "prices.viewAll": "عرض كل الأسعار",
    "prices.updated": "محدّث اليوم",
    "market.hub.subtitle": "أسعار المصدر، أسعار التجزئة، مقياس السوق والميزان.",
    "market.tab.origin": "أسعار المصدر",
    "market.tab.retail": "أسعار المعبأ / التوزيع الكبير",
    "market.tab.thermo": "مقياس حرارة السوق",
    "market.tab.balance": "ميزان السوق",
    "market.origin.title": "أسعار الزيت السائب عند المصدر",
    "market.origin.desc": "أسعار حسب البلد المنتج والجودة. تونس بالدينار/كغ، الدولي باليورو/كغ.",
    "market.retail.title": "أسعار المعبأ / التوزيع الكبير",
    "market.retail.desc": "متابعة العلامات التجارية للموزعين في المتاجر الكبرى (تونس).",
    "market.thermo.title": "مقياس حرارة السوق",
    "market.thermo.desc": "اتجاه تركيبي انطلاقاً من آخر التغيرات في الأسعار.",
    "market.balance.title": "ميزان السوق (تونس)",
    "market.balance.desc": "أحجام الإنتاج والمخزون والصادرات والاستهلاك.",
    "market.country": "البلد",
    "market.quality": "الجودة",
    "market.source": "المصدر",
    "market.retailer": "المتجر",
    "market.brand": "العلامة",
    "market.format": "الصيغة",
    "market.latest": "آخر سعر",
    "market.change": "التغيّر",
    "market.evolution": "التطور",
    "market.displayCurrency": "عملة العرض",
    "market.fxNote": "سعر الصرف بتاريخ {date}",
    "market.updated": "محدّث",
    "market.noData": "لا توجد بيانات.",
    "market.thermo.up": "ارتفاع",
    "market.thermo.stable": "مستقر",
    "market.thermo.down": "انخفاض",
    "market.thermo.basis": "متوسط التغيّر {pct}% خلال آخر {weeks} أسابيع ({count} سلاسل)",
    "market.thermo.thresholds": "العتبات: ارتفاع ≥ {up}% · انخفاض ≤ {down}%",
    "market.thermo.comment": "تعليق المحلل",
    "market.season": "الموسم",
    "market.value": "الحجم (طن)",
    "metric.production": "الإنتاج",
    "metric.exports": "الصادرات",
    "metric.stocks": "المخزون",
    "metric.consumption": "الاستهلاك",
    "metric.imports": "الواردات",
    "country.tunisia": "تونس",
    "country.spain": "إسبانيا",
    "country.italy": "إيطاليا",
    "country.greece": "اليونان",
    "country.portugal": "البرتغال",
    "country.turkey": "تركيا",
    "country.morocco": "المغرب",
    "dash.menu.admin": "الإدارة",
    "dash.menu.adminMarket": "السوق والأسعار",
    "dash.menu.adminOverview": "نظرة عامة",
    "dash.menu.adminUsers": "المستخدمون والشركات",
    "dash.menu.adminLots": "الإشراف على العروض",
    "dash.menu.adminSettings": "الإعدادات",
    "admin.overview.title": "نظرة عامة",
    "admin.overview.users": "المستخدمون",
    "admin.overview.usersVerified": "موثّقون",
    "admin.overview.emailUnconfirmed": "بريد غير مؤكد",
    "admin.overview.companies": "شركات موثّقة",
    "admin.overview.pending": "قيد الانتظار",
    "admin.overview.lotsActive": "عروض نشطة",
    "admin.overview.deals": "صفقات مبرمة",
    "admin.overview.volume": "الحجم المتبادل",
    "admin.overview.commissions": "عمولات",
    "admin.overview.quotesOpen": "طلبات عروض جارية",
    "admin.overview.byType": "المستخدمون حسب النوع",
    "admin.overview.monthly": "النشاط الشهري",
    "admin.overview.noData": "لا توجد بيانات حاليًا.",
    "admin.users.title": "المستخدمون والشركات",
    "admin.users.tabKyc": "طلبات التوثيق (KYC)",
    "admin.users.tabAll": "كل المستخدمين",
    "admin.users.pendingKyc": "طلبات التوثيق المعلّقة",
    "admin.users.noPending": "لا توجد طلبات توثيق معلّقة.",
    "admin.users.history": "السجل",
    "admin.users.review": "مراجعة",
    "admin.users.approve": "قبول",
    "admin.users.reject": "رفض",
    "admin.users.rejectReason": "سبب الرفض",
    "admin.users.docs": "وثائق التوثيق",
    "admin.users.viewDoc": "فتح",
    "admin.users.noDocs": "لم تُرسل أي وثيقة.",
    "admin.users.decisionSaved": "تم حفظ القرار",
    "admin.users.search": "ابحث عن مستخدم…",
    "admin.users.name": "الاسم",
    "admin.users.email": "البريد الإلكتروني",
    "admin.users.type": "النوع",
    "admin.users.emailConfirmed": "بريد مؤكد",
    "admin.users.confirmed": "مؤكد",
    "admin.users.notConfirmed": "غير مؤكد",
    "admin.users.confirmEmail": "تأكيد",
    "admin.users.confirmDone": "تم تأكيد البريد",
    "admin.users.actions": "إجراءات",
    "admin.users.company": "الشركة",
    "admin.users.export": "تصدير",
    "admin.users.exportDone": "تم تصدير {count} مستخدم",
    "admin.users.contact": "الاسم (جهة الاتصال)",
    "admin.users.filters": "عوامل التصفية",
    "admin.users.all": "الكل",
    "admin.users.filterKyc": "التحقق (KYC)",
    "admin.users.filterCountry": "البلد",
    "admin.users.filterGov": "الولاية",
    "admin.users.kycVerified": "موثّق",
    "admin.users.kycPending": "قيد الانتظار",
    "admin.users.kycUnverified": "غير موثّق",
    "admin.users.kycRejected": "مرفوض",
    "admin.users.showDeleted": "عرض الحسابات المحذوفة",
    "admin.users.resetFilters": "إعادة ضبط عوامل التصفية",
    "admin.users.noResults": "لا يوجد مستخدم يطابق عوامل التصفية.",
    "admin.userdetail.back": "العودة إلى القائمة",
    "admin.userdetail.identity": "الهوية",
    "admin.userdetail.company": "الشركة",
    "admin.userdetail.activity": "النشاط",
    "admin.userdetail.kyc": "وثائق التوثيق (KYC)",
    "admin.userdetail.notes": "ملاحظات داخلية",
    "admin.userdetail.actions": "إجراءات إدارية",
    "admin.userdetail.role": "الدور",
    "admin.userdetail.type": "النوع",
    "admin.userdetail.status": "الحالة",
    "admin.userdetail.lang": "اللغة",
    "admin.userdetail.registered": "تاريخ التسجيل",
    "admin.userdetail.consent": "الموافقة",
    "admin.userdetail.emailConfirmed": "بريد مؤكد",
    "admin.userdetail.lots": "عروض منشورة",
    "admin.userdetail.negotiations": "مفاوضات",
    "admin.userdetail.deals": "صفقات مبرمة",
    "admin.userdetail.requests": "طلبات شراء",
    "admin.userdetail.quotes": "عروض أسعار",
    "admin.userdetail.noCompany": "لا توجد شركة مرتبطة.",
    "admin.userdetail.noKyc": "لم تُرسل أي وثيقة توثيق.",
    "admin.userdetail.noNotes": "لا توجد ملاحظات داخلية.",
    "admin.userdetail.verifStatus": "التوثيق",
    "admin.userdetail.suspend": "تعليق",
    "admin.userdetail.reactivate": "إعادة التفعيل",
    "admin.userdetail.suspendReason": "سبب التعليق",
    "admin.userdetail.suspendConfirm": "تعليق الحساب",
    "admin.userdetail.suspendedBadge": "معلّق",
    "admin.userdetail.activeBadge": "نشط",
    "admin.userdetail.deletedBadge": "محذوف",
    "admin.userdetail.suspendedInfo": "حساب معلّق:",
    "admin.userdetail.confirmEmail": "تأكيد البريد",
    "admin.userdetail.resendConfirm": "إعادة إرسال الرابط",
    "admin.userdetail.changeType": "تغيير نوع المستخدم",
    "admin.userdetail.saveType": "حفظ",
    "admin.userdetail.addNote": "إضافة ملاحظة",
    "admin.userdetail.notePlaceholder": "اكتب ملاحظة داخلية…",
    "admin.userdetail.delete": "حذف الحساب",
    "admin.userdetail.deleteTitle": "حذف هذا المستخدم",
    "admin.userdetail.softDelete": "حذف قياسي (إخفاء الهوية)",
    "admin.userdetail.softDeleteDesc": "يُخفي البيانات الشخصية ويحتفظ بالسجل المعاملاتي (امتثال INPDP/GDPR). موصى به.",
    "admin.userdetail.hardDelete": "حذف نهائي",
    "admin.userdetail.hardDeleteDesc": "يمحو الحساب بالكامل. مخصص للحسابات بلا أي نشاط (بريد مزعج / حسابات وهمية).",
    "admin.userdetail.hardDeleteBlocked": "غير ممكن: لهذا الحساب نشاط على المنصة.",
    "admin.userdetail.deleteConfirm": "تأكيد الحذف",
    "admin.userdetail.deleted": "تم حذف الحساب",
    "admin.userdetail.suspended": "تم تعليق الحساب",
    "admin.userdetail.reactivated": "تمت إعادة تفعيل الحساب",
    "admin.userdetail.typeChanged": "تم تحديث النوع",
    "admin.userdetail.noteAdded": "تمت إضافة الملاحظة",
    "admin.userdetail.confirmed": "تم تأكيد البريد",
    "admin.userdetail.resent": "تمت إعادة إرسال رابط التأكيد",
    "admin.userdetail.cancel": "إلغاء",
    "admin.userdetail.yes": "نعم",
    "admin.userdetail.no": "لا",
    "admin.userdetail.accountState": "حالة الحساب",
    "admin.userdetail.lastLogin": "آخر تسجيل دخول",
    "admin.userdetail.never": "أبداً",
    "admin.userdetail.invoices": "الفواتير",
    "admin.userdetail.invoicesEmpty": "لا توجد فواتير حالياً.",
    "admin.userdetail.invoicesSoon": "ستتوفر الفوترة مع إصدار الفواتير (المرحلة 10).",
    "statement.title": "كشف الحساب",
    "statement.billed": "إجمالي الفواتير",
    "statement.paid": "إجمالي المدفوع",
    "statement.unpaid": "الرصيد غير المدفوع",
    "statement.empty": "لا توجد فواتير حالياً.",
    "invoice.number": "رقم الفاتورة",
    "invoice.party": "الدور",
    "invoice.buyer": "المشتري",
    "invoice.seller": "البائع",
    "invoice.base": "الأساس دون ضريبة",
    "invoice.rate": "نسبة العمولة",
    "invoice.ht": "المبلغ دون ضريبة",
    "invoice.vat": "الأداء",
    "invoice.ttc": "المجموع مع الأداء",
    "invoice.date": "تاريخ الإصدار",
    "invoice.dueDate": "تاريخ الاستحقاق",
    "invoice.status": "الحالة",
    "invoice.viewPdf": "عرض ملف PDF",
    "invoice.proof": "وثيقة الإثبات",
    "invoice.noProof": "لا توجد وثيقة إثبات.",
    "invoice.paymentRef": "مرجع الدفع (رقم التحويل)",
    "invoice.status.issued": "صادرة",
    "invoice.status.awaiting_payment": "في انتظار الدفع",
    "invoice.status.paid": "مدفوعة",
    "invoice.status.cancelled": "ملغاة",
    "invoice.myTitle": "فواتيري",
    "invoice.mySubtitle": "فواتير العمولة على عملياتك المُبرمة.",
    "invoice.myEmpty": "لا توجد فواتير حالياً.",
    "invoice.myEmptyHint": "تُصدَر فواتير العمولة عند إبرام عملية بيع بالجملة. الزيت المعبأ بدون عمولة.",
    "invoice.payTitle": "الدفع عبر تحويل بنكي",
    "invoice.payHint": "قم بتحويل المبلغ الإجمالي مع الأداء ثم حمّل وثيقة الإثبات أدناه. سيتحقق المسؤول من استلام الدفع.",
    "invoice.uploadProof": "تحميل وثيقة الإثبات",
    "invoice.proofHint": "PDF أو JPG أو PNG — 10 ميغابايت كحد أقصى.",
    "invoice.proofSent": "تم إرسال وثيقة الإثبات. في انتظار مصادقة المسؤول.",
    "invoice.awaitingValidation": "في انتظار مصادقة المسؤول",
    "invoice.paidOn": "مدفوعة بتاريخ",
    "admin.billing.title": "الفوترة والبيانات البنكية",
    "admin.billing.desc": "بيانات المُصدِر وRIB المعروضة على فواتير العمولة.",
    "admin.billing.issuerLegal": "الاسم القانوني للمُصدِر",
    "admin.billing.taxId": "المعرّف الجبائي",
    "admin.billing.address": "العنوان",
    "admin.billing.email": "البريد الإلكتروني",
    "admin.billing.phone": "الهاتف",
    "admin.billing.bankName": "البنك",
    "admin.billing.rib": "RIB",
    "admin.billing.iban": "IBAN",
    "admin.billing.swift": "SWIFT/BIC",
    "admin.billing.vatRate": "نسبة الأداء (٪)",
    "admin.billing.paymentTerms": "أجل الدفع (أيام)",
    "admin.billing.exportExempt": "الإعفاء من الأداء عند التصدير",
    "admin.billing.exportNote": "ملاحظة الأداء عند التصدير",
    "invoice.bankName": "البنك",
    "invoice.rib": "RIB",
    "invoice.iban": "IBAN",
    "invoice.swift": "SWIFT/BIC",
    "admin.userdetail.viewListing": "عرض بطاقة العرض",
    "admin.userdetail.openThread": "فتح المحادثة كاملة",
    "admin.userdetail.parties": "الأطراف",
    "admin.userdetail.lot": "العرض",
    "admin.userdetail.quantity": "الكمية",
    "admin.userdetail.unitPrice": "سعر الوحدة",
    "admin.userdetail.total": "المبلغ الإجمالي",
    "admin.userdetail.thread": "سجل التبادلات",
    "admin.userdetail.offer": "عرض سعر",
    "admin.userdetail.counter": "عرض مضاد",
    "admin.userdetail.message": "رسالة",
    "admin.userdetail.systemEvent": "حدث",
    "admin.userdetail.quality": "الجودة",
    "admin.userdetail.targetPrice": "السعر المستهدف",
    "admin.userdetail.governorate": "الولاية",
    "admin.userdetail.packaging": "التعبئة",
    "admin.userdetail.volume": "الحجم",
    "admin.userdetail.units": "الوحدات",
    "admin.userdetail.whiteLabel": "علامة خاصة",
    "admin.userdetail.contact": "جهة الاتصال",
    "admin.userdetail.desc": "الوصف",
    "admin.userdetail.concludedAt": "أُبرمت في",
    "admin.userdetail.export": "تصدير",
    "admin.userdetail.national": "محلي",
    "admin.userdetail.rowClickHint": "انقر لعرض التفاصيل",
    "admin.userdetail.detailNotFound": "التفاصيل غير متوفرة.",
    "common.reference": "المرجع",
    "deals.operationRef": "مرجع العملية",
    "deals.lotRef": "مرجع العرض",
    "market.searchPlaceholder": "العنوان أو المرجع…",
    "dash.menu.adminOps": "العمليات",
    "admin.lots.openFiche": "فتح بطاقة العرض",
    "admin.users.openFiche": "فتح البطاقة",
    "adminlot.back": "العودة إلى العروض",
    "adminlot.publicView": "العرض العام",
    "adminlot.specs": "المواصفات",
    "adminlot.price": "السعر",
    "adminlot.remaining": "الكمية المتبقية",
    "adminlot.sold": "الكمية المباعة",
    "adminlot.negotiations": "المفاوضات والعروض",
    "adminlot.noNegos": "لا توجد مفاوضات على هذا العرض.",
    "adminlot.offers": "العروض",
    "adminlot.seller": "البائع",
    "admindeals.title": "العمليات المبرمة",
    "admindeals.search": "مرجع العملية أو العرض أو طرف…",
    "admindeals.none": "لا توجد عمليات مبرمة.",
    "admindeals.parties": "الأطراف (المشتري ← البائع)",
    "geo.subdiv.governorate": "الولاية",
    "geo.subdiv.muhafazah": "محافظة",
    "geo.subdiv.emirate": "إمارة",
    "geo.subdiv.municipality": "بلدية",
    "geo.subdiv.district": "مقاطعة",
    "geo.subdiv.wilaya": "ولاية",
    "geo.subdiv.canton": "كانتون",
    "geo.subdiv.provinceTerr": "مقاطعة / إقليم",
    "geo.subdiv.province": "مقاطعة",
    "geo.subdiv.state": "ولاية",
    "geo.subdiv.region": "منطقة",
    "geo.subdiv.provincia": "مقاطعة",
    "geo.subdiv.distrito": "مقاطعة",
    "geo.subdiv.land": "ولاية / منطقة",
    "geo.subdiv.county": "مقاطعة",
    "geo.subdiv.generic": "منطقة / ولاية / مقاطعة",
    "geo.subdiv.select": "اختر…",
    "geo.subdiv.freeholder": "منطقة / ولاية / مقاطعة",
    "geo.search": "بحث…",
    "geo.empty": "لا توجد نتائج",
    "geo.city": "المدينة",
    "geo.city.select": "اختر مدينة",
    "geo.city.freeholder": "المدينة",
    "geo.city.notListed": "مدينتي غير مدرجة",
    "geo.city.backToList": "العودة إلى القائمة",
    "phone.invalid": "رقم هاتف غير صالح",
    "login.forgot": "هل نسيت كلمة المرور؟",
    "login.suspended": "تم تعليق حسابك. تواصل مع المشرف لمزيد من المعلومات.",
    "pwreset.forgotTitle": "نسيت كلمة المرور",
    "pwreset.forgotSubtitle": "أدخل بريدك الإلكتروني لتلقّي رابط إعادة التعيين.",
    "pwreset.email": "البريد الإلكتروني",
    "pwreset.sendLink": "إرسال الرابط",
    "pwreset.sentTitle": "تحقق من بريدك الإلكتروني",
    "pwreset.sentDesc": "إذا كان هناك حساب مرتبط بهذا العنوان، فستتلقى رابطًا لإعادة تعيين كلمة المرور. ينتهي الرابط خلال ساعة واحدة.",
    "pwreset.backToLogin": "العودة إلى تسجيل الدخول",
    "pwreset.resetTitle": "كلمة مرور جديدة",
    "pwreset.resetSubtitle": "اختر كلمة مرور جديدة لحسابك.",
    "pwreset.newPassword": "كلمة المرور الجديدة",
    "pwreset.confirmPassword": "تأكيد كلمة المرور",
    "pwreset.minLength": "8 أحرف على الأقل",
    "pwreset.mismatch": "كلمتا المرور غير متطابقتين.",
    "pwreset.save": "إعادة التعيين",
    "pwreset.successTitle": "تمت إعادة تعيين كلمة المرور",
    "pwreset.successDesc": "تم تحديث كلمة مرورك. يمكنك الآن تسجيل الدخول.",
    "pwreset.goLogin": "تسجيل الدخول",
    "pwreset.invalidTitle": "رابط غير صالح أو منتهٍ",
    "pwreset.invalidDesc": "لم يعد رابط إعادة التعيين صالحًا (منتهٍ أو مستخدم سابقًا أو غير صحيح). اطلب رابطًا جديدًا.",
    "pwreset.requestNew": "طلب رابط جديد",
    "pwreset.spamHelp": "لا تجد البريد؟ تحقق من مجلد الرسائل غير المرغوب فيها. قد تتأخر رسائل Hotmail/Outlook بضع دقائق.",
    "admin.lots.title": "الإشراف على العروض",
    "admin.lots.all": "الكل",
    "admin.lots.available": "متاح",
    "admin.lots.sold": "مُباع",
    "admin.lots.withdrawn": "مسحوب",
    "admin.lots.search": "ابحث عن عرض…",
    "admin.lots.lot": "العرض",
    "admin.lots.seller": "البائع",
    "admin.lots.type": "النوع",
    "admin.lots.qty": "الكمية",
    "admin.lots.statusCol": "الحالة",
    "admin.lots.actions": "إجراءات",
    "admin.lots.vrac": "سائب",
    "admin.lots.conditionne": "معبّأ",
    "admin.lots.withdraw": "سحب",
    "admin.lots.restore": "إعادة تفعيل",
    "admin.lots.statusChanged": "تم تحديث الحالة",
    "admin.lots.none": "لا توجد عروض.",
    "admin.lots.confirmWithdraw": "سحب هذا العرض من السوق؟",
    "admin.settings.title": "الإعدادات",
    "admin.settings.commission": "جدول العمولات",
    "admin.settings.commissionDesc": "النِّسب المطبّقة على كل صفقة مبرمة (٪).",
    "admin.settings.vracNational": "سائب محلي",
    "admin.settings.vracExport": "سائب تصدير",
    "admin.settings.conditionne": "معبّأ",
    "admin.settings.buyer": "المشتري",
    "admin.settings.seller": "البائع",
    "admin.settings.pctNote": "القيم بالنسبة المئوية (مثال 0.2 = 0.2٪).",
    "admin.settings.save": "حفظ",
    "admin.settings.saved": "تم الحفظ",
    "admin.settings.platform": "المنصة",
    "admin.settings.logo": "شعار المنصة (PDF)",
    "admin.settings.logoDesc": "الشعار المعروض على ملفات PDF للعروض والوثائق.",
    "admin.settings.logoUpload": "رفع",
    "nav.faq": "الأسئلة الشائعة",
    "nav.contact": "اتصل بنا",
    "contact.title": "اتصل بنا",
    "contact.subtitle": "هل لديك سؤال؟ راسلنا وسنرد عليك بسرعة.",
    "contact.intro": "املأ النموذج أدناه وسيتواصل معك فريقنا في أقرب وقت ممكن.",
    "contact.name": "الاسم الكامل",
    "contact.email": "البريد الإلكتروني",
    "contact.company": "الشركة",
    "contact.phone": "الهاتف",
    "contact.subject": "الموضوع",
    "contact.subjectPlaceholder": "اختر موضوعًا",
    "contact.message": "الرسالة",
    "contact.cat.general": "سؤال عام",
    "contact.cat.sell": "بيع زيت الزيتون",
    "contact.cat.buy": "شراء زيت الزيتون",
    "contact.cat.partnership": "شراكة",
    "contact.cat.press": "الصحافة",
    "contact.cat.other": "أخرى",
    "contact.consentPre": "أوافق على معالجة بياناتي وفقًا لـ",
    "contact.privacyLink": "سياسة الخصوصية",
    "contact.submit": "إرسال الرسالة",
    "contact.sending": "جارٍ الإرسال…",
    "contact.success": "تم إرسال الرسالة",
    "contact.successDesc": "شكرًا لتواصلك معنا. سنرد عليك في أقرب وقت ممكن.",
    "admin.contact.title": "رسائل الاتصال",
    "admin.contact.subjectCol": "الموضوع",
    "admin.contact.detail": "تفاصيل الرسالة",
    "dash.menu.adminContact": "رسائل الاتصال",
    "faq.title": "الأسئلة الشائعة",
    "faq.subtitle": "كل ما تحتاج معرفته لشراء وبيع زيت الزيتون بالجملة على EvooTunisia.",
    "faq.empty": "لا توجد أسئلة حاليًا.",
    "faq.moreHelp": "لم تجد إجابتك؟ أنشئ حسابًا وتواصل معنا من مساحتك.",
    "faq.cta": "إنشاء حساب مجاني",
    "faq.admin.title": "إدارة الأسئلة الشائعة",
    "faq.admin.new": "سؤال جديد",
    "faq.admin.empty": "لا توجد أسئلة. أضِف الأول.",
    "faq.admin.back": "العودة إلى القائمة",
    "faq.admin.question": "السؤال",
    "faq.admin.answer": "الإجابة",
    "faq.admin.category": "الفئة",
    "faq.admin.order": "الترتيب",
    "faq.admin.published": "منشور",
    "faq.admin.save": "حفظ",
    "faq.admin.saved": "تم حفظ السؤال",
    "faq.admin.confirmDelete": "حذف هذا السؤال؟",
    "faq.admin.deleted": "تم حذف السؤال",
    "faq.admin.needQuestion": "السؤال بالفرنسية إلزامي.",
    "faq.admin.statusPublished": "منشور",
    "faq.admin.statusDraft": "مخفي",
    "dash.menu.adminFaq": "الأسئلة الشائعة",
    "admin.market.title": "إدارة السوق والأسعار",
    "admin.market.tabOrigin": "أسعار المصدر",
    "admin.market.tabRetail": "أسعار التوزيع",
    "admin.market.tabBalance": "الميزان",
    "admin.market.tabSettings": "الإعدادات",
    "admin.market.addPoint": "إضافة نقطة",
    "admin.market.addSeries": "إضافة سلسلة",
    "admin.market.date": "التاريخ",
    "admin.market.price": "السعر",
    "admin.market.period": "الموسم",
    "admin.market.value": "القيمة (طن)",
    "admin.market.delete": "حذف",
    "admin.market.save": "حفظ",
    "admin.market.saved": "تم الحفظ",
    "admin.market.confirmDelete": "حذف هذه السلسلة؟",
    "admin.market.fx": "أسعار الصرف (أساس الدينار)",
    "admin.market.tndPerEur": "دينار لكل 1 يورو",
    "admin.market.tndPerUsd": "دينار لكل 1 دولار",
    "admin.market.thresholds": "مقياس الحرارة",
    "admin.market.thermoUp": "عتبة الارتفاع (%)",
    "admin.market.thermoDown": "عتبة الانخفاض (%)",
    "admin.market.thermoWeeks": "الأسابيع المحللة",
    "admin.market.comment": "تعليق المقياس",
    "admin.market.newSeriesTitle": "سلسلة جديدة",
    "admin.market.currency": "العملة",
    "admin.market.source": "المصدر",
    "source.auto_eu": "تلقائي (الاتحاد الأوروبي)",
    "source.auto_world": "تلقائي (عالمي)",
    "source.manual": "يدوي (المشرف)",
    "market.lastUpdate": "آخر تحديث",
    "market.attribution": "المصدر: المفوضية الأوروبية (بوابة بيانات الأغذية الزراعية) وFRED.",
    "market.worldIndex": "السعر العالمي المرجعي (FRED)",
    "market.worldIndexDesc": "المؤشر العالمي الشهري لسعر زيت الزيتون.",
    "admin.market.tabFeeds": "التدفقات التلقائية",
    "admin.market.feedStatus": "حالة التدفقات التلقائية",
    "admin.market.syncNow": "مزامنة الآن",
    "admin.market.syncing": "جارٍ المزامنة…",
    "admin.market.syncDone": "اكتملت المزامنة",
    "admin.market.lastSuccess": "آخر نجاح",
    "admin.market.lastError": "آخر خطأ",
    "admin.market.feedEu": "المفوضية الأوروبية (أسعار المصدر)",
    "admin.market.feedWorld": "FRED (المؤشر العالمي)",
    "admin.market.feedNote": "تبقى الأسعار التونسية وأسعار العلامات التجارية للموزعين يدوية.",

    "how.heading": "كيف يعمل",
    "how.subtitle": "ثلاث خطوات بسيطة لإتمام معاملاتك.",
    "how.step1.title": "انشر",
    "how.step1.desc": "البائعون: أنشئوا عرضكم سائبًا أو معبأً مع الكمية والجودة والسعر.",
    "how.step2.title": "تفاوض",
    "how.step2.desc": "استقبل العروض، تواصل مع المشترين وعدّل شروطك.",
    "how.step3.title": "أبرم",
    "how.step3.desc": "أكّد المعاملة ونظّم اللوجستيك والتصدير بثقة تامة.",

    "cta.heading": "جاهز لتطوير نشاطك في الزيتون؟",
    "cta.subtitle": "انضم إلى مجتمع مهنيي زيت الزيتون في تونس.",
    "cta.button": "أنشئ حسابًا مجانيًا",

    "footer.about": "EvooTunisia هي سوق B2B مخصصة لبيع وشراء زيت الزيتون التونسي بالجملة، سائبًا ومعبأً، للسوق المحلي والتصدير.",
    "footer.marketplace": "السوق",
    "footer.company": "الشركة",
    "footer.legal": "قانوني",
    "directory.subtitle": "دليل المعاصر الموثّقة، في تونس وللتصدير.",
    "directory.search": "ابحث عن معصرة أو مدينة...",
    "directory.tunisia": "تونس",
    "directory.export": "التصدير (بلدان أخرى)",
    "directory.allRegions": "الكل",
    "directory.allVarieties": "كل الأصناف",
    "directory.filterVariety": "الصنف",
    "directory.organicOnly": "بيولوجي فقط",
    "directory.viewProfile": "عرض البطاقة",
    "directory.viewLots": "عرض لوطاتها",
    "directory.lotsAvailable": "{n} لوط(ات) للبيع",
    "directory.exportTo": "يصدّر إلى",
    "directory.allCountries": "كل البلدان",
    "directory.selectGovernorate": "الولاية",
    "directory.exportOpen": "منفتح على التصدير",
    "directory.exportMarkets": "أسواق التصدير",
    "dirprofile.exportOpen": "منفتح على التصدير",
    "dirprofile.exportMarkets": "أسواق التصدير",
    "dirprofile.exportMarketsHelp": "أضف البلدان التي تصدّر إليها.",
    "dirprofile.addMarket": "أضف بلداً...",
    "directory.noResults": "لا توجد معصرة تطابق بحثك.",
    "directory.varieties": "أصناف الزيتون",
    "directory.certifications": "الشهادات",
    "directory.contact": "معلومات الاتصال",
    "directory.country": "البلد",
    "directory.about": "نبذة",
    "directory.back": "العودة إلى الدليل",
    "directory.verified": "موثّقة",
    "directory.results": "{n} معصرة",
    "dash.menu.directoryProfile": "بطاقتي في الدليل",
    "dirprofile.title": "بطاقتي في الدليل",
    "dirprofile.intro": "أثرِ واجهتك العامة في دليل المعاصر.",
    "dirprofile.visible": "ظاهرة في الدليل",
    "dirprofile.visibleHelp": "عطّل لإخفاء بطاقتك عن العموم.",
    "dirprofile.description": "الوصف",
    "dirprofile.varieties": "أصناف الزيتون",
    "dirprofile.varietiesHelp": "افصل بفواصل (شتوي، شملالي...).",
    "dirprofile.capacity": "الطاقة (طن/سنة)",
    "dirprofile.certifications": "الشهادات",
    "dirprofile.certHelp": "افصل بفواصل (بيو الاتحاد الأوروبي، IGP...).",
    "dirprofile.organic": "معتمدة بيولوجياً",
    "dirprofile.city": "المدينة",
    "dirprofile.country": "البلد",
    "dirprofile.contactEmail": "بريد الاتصال",
    "dirprofile.photos": "الصور",
    "dirprofile.addPhoto": "إضافة صورة",
    "dirprofile.logo": "شعار المعصرة",
    "dirprofile.logoHelp": "يظهر على عروض الأسعار PDF. PNG/JPG/WEBP، يفضّل خلفية فاتحة.",
    "dirprofile.addLogo": "إضافة شعار",
    "dirprofile.replaceLogo": "استبدال",
    "dirprofile.save": "حفظ بطاقتي",
    "dirprofile.saved": "تم تحديث البطاقة",
    "dirprofile.locked": "يجب توثيق شركتك كبائع لتظهر في الدليل.",
    "footer.about.link": "من نحن",
    "footer.contact": "اتصل بنا",
    "footer.cgu": "الشروط العامة",
    "footer.privacy": "سياسة الخصوصية",
    "footer.cookies": "إدارة الكوكيز",
    "footer.rights": "جميع الحقوق محفوظة.",
    "footer.newsletter": "ابقَ على اطّلاع بالأسعار والعروض الجديدة.",
    "footer.newsletter.placeholder": "بريدك المهني",
    "footer.newsletter.button": "اشترك",

    "currency.label": "العملة",
    "common.comingSoon": "قريبًا",
    "common.comingSoon.desc": "هذا القسم جزء من الهيكل الأساسي وسيُفعّل في مرحلة لاحقة.",
    "common.backHome": "العودة إلى الرئيسية",

    "login.title": "تسجيل الدخول",
    "login.subtitle": "ادخل إلى مساحتك المهنية.",
    "login.email": "البريد الإلكتروني",
    "login.password": "كلمة المرور",
    "login.button": "دخول",
    "login.noAccount": "ليس لديك حساب؟",
    "login.demo": "واجهة تجريبية — المصادقة غير مفعّلة.",

    "register.title": "إنشاء حساب",
    "register.subtitle": "انضم إلى السوق في دقائق.",
    "register.company": "اسم الشركة",
    "register.role": "أنت",
    "register.role.buyer": "مشترٍ",
    "register.role.seller": "بائع",
    "register.role.broker": "وسيط",
    "usertype.label": "نوع المستخدم",
    "usertype.placeholder": "— اختر واحدًا —",
    "usertype.producer": "منتج / معصرة زيت",
    "usertype.packer": "مشترٍ / معبِّئ",
    "usertype.distributor": "موزّع",
    "usertype.broker": "وسيط",
    "usertype.other": "أخرى",
    "usertype.hint": "يمكن تعديله في أي وقت من «شركتي».",
    "usertype.sellNote": "يمكن لهذا النوع نشر عروض البيع (بعد التحقق من الحساب).",
    "usertype.buyOnlyNote": "يمكن لهذا النوع الشراء والتفاوض.",
    "usertype.current": "نوع المستخدم",
    "usertype.required": "يرجى اختيار نوع المستخدم",
    "register.country": "البلد",
    "taxid.matricule_fiscal": "المعرّف الجبائي",
    "taxid.cif_nif": "CIF / NIF",
    "taxid.siren_siret": "SIREN / SIRET",
    "taxid.partita_iva": "Partita IVA",
    "taxid.nif_nipc": "NIF / NIPC",
    "taxid.afm": "AFM",
    "taxid.ice": "ICE / المعرّف الجبائي",
    "taxid.generic": "رقم التعريف الجبائي / السجل التجاري",
    "taxid.vat": "رقم الأداء على القيمة المضافة داخل الاتحاد",
    "taxid.vatOptional": "(اختياري)",
    "taxid.format": "الصيغة",
    "taxid.invalid": "صيغة المعرّف غير صحيحة لهذا البلد",
    "taxid.err.matricule_fiscal": "المعرّف الجبائي غير صحيح. الصيغة المطلوبة: 7 أرقام + حرف مفتاح، مع لواحق المؤسسة اختيارية (مثال: 1234567A/P/M/000).",
    "taxid.err.cif_nif": "CIF/NIF غير صحيح. الصيغة المطلوبة: 8 إلى 10 حروف/أرقام (مثال: B12345678).",
    "taxid.err.siren_siret": "SIREN / SIRET غير صحيح. الصيغة المطلوبة: 9 أرقام (SIREN) أو 14 رقمًا (SIRET) (مثال: 123456789).",
    "taxid.err.partita_iva": "Partita IVA غير صحيح. الصيغة المطلوبة: 11 رقمًا (مثال: 12345678901).",
    "taxid.err.nif_nipc": "NIF / NIPC غير صحيح. الصيغة المطلوبة: 9 أرقام (مثال: 123456789).",
    "taxid.err.afm": "AFM غير صحيح. الصيغة المطلوبة: 9 أرقام (مثال: 123456789).",
    "taxid.err.ice": "ICE غير صحيح. الصيغة المطلوبة: 7 إلى 15 رقمًا (مثال: 001234567000012).",
    "taxid.err.generic": "معرّف الشركة غير صحيح. أدخل 4 حروف/أرقام على الأقل.",
    "consent.before": "أوافق على ",
    "consent.terms": "شروط الخدمة",
    "consent.mid": " و",
    "consent.privacy": "سياسة حماية البيانات",
    "consent.required": "يجب قبول الشروط للمتابعة",
    "kyc.doc.companyDocDyn": "وثيقة رسمية للشركة ({id})",
    "company.usertype.saved": "تم تحديث نوع المستخدم",
    "register.button": "إنشاء حسابي",
    "register.hasAccount": "لديك حساب بالفعل؟",

    "page.market.title": "السوق",
    "page.prices.title": "الأسعار وتحليل السوق",
    "page.directory.title": "دليل المعاصر",
    "page.tools.title": "أدوات",
    "tools.hub.subtitle": "أدوات عملية لشراء وبيع وتصدير زيت الزيتون التونسي.",
    "tools.open": "فتح",
    "tools.backTools": "العودة إلى الأدوات",
    "tools.calc.title": "حاسبة التكاليف",
    "tools.calc.desc": "احسب سعر التكلفة والسعر النهائي (إنكوترمز، اللوجستيك، دينار/يورو/دولار).",
    "tools.calc.basic": "أساسية",
    "tools.calc.advanced": "متقدمة",
    "tools.calc.inputCurrency": "عملة الإدخال",
    "tools.calc.pricePerKg": "السعر لكل كغ",
    "tools.calc.quantity": "الكمية",
    "tools.calc.incoterm": "إنكوترمز",
    "tools.calc.transport": "النقل",
    "tools.calc.insurance": "التأمين",
    "tools.calc.customs": "الجمارك / التصدير",
    "tools.calc.handling": "المناولة",
    "tools.calc.financing": "التكاليف المالية",
    "tools.calc.otherCosts": "تكاليف أخرى",
    "tools.calc.marginPct": "الهامش",
    "tools.calc.density": "الكثافة (كغ/ل)",
    "tools.calc.results": "النتائج",
    "tools.calc.goodsValue": "قيمة البضاعة",
    "tools.calc.totalLogistics": "إجمالي اللوجستيك",
    "tools.calc.totalCost": "التكلفة الإجمالية",
    "tools.calc.costPerKg": "سعر التكلفة / كغ",
    "tools.calc.costPerL": "سعر التكلفة / ل",
    "tools.calc.sellingPrice": "سعر البيع المقترح / كغ",
    "tools.calc.conversion": "التحويل",
    "tools.calc.densityNote": "تحويل كغ إلى ل بكثافة افتراضية 0.916 كغ/ل (قابلة للتعديل في الوضع المتقدم).",
    "tools.calc.incotermNote": "أدخل التكاليف اللوجستية التي تتحملها حسب الإنكوترمز المختار.",
    "tools.alerts.title": "تنبيهات السوق",
    "tools.alerts.desc": "احصل على إشعار بالبريد الإلكتروني عند توفر عروض جديدة أو تغير الأسعار.",
    "tools.alerts.doubleOptin": "تأكيد مزدوج: بعد التسجيل، انقر على الرابط المرسل إلى بريدك لتفعيل التنبيه.",
    "tools.alerts.newLots": "تنبيه العروض الجديدة",
    "tools.alerts.newLotsDesc": "احصل على بريد إلكتروني بمجرد توفر عرض يطابق معاييرك.",
    "tools.alerts.priceMove": "تنبيه حركة الأسعار",
    "tools.alerts.priceMoveDesc": "احصل على بريد عندما تتغير الأسعار بما يتجاوز الحد الذي تحدده.",
    "tools.alerts.email": "البريد الإلكتروني المهني",
    "tools.alerts.market": "السوق",
    "tools.alerts.quality": "الجودة",
    "tools.alerts.packaging": "التعليب",
    "tools.alerts.governorate": "الولاية / المنشأ",
    "tools.alerts.minQty": "الكمية الدنيا",
    "tools.alerts.maxPrice": "السعر الأقصى (دينار)",
    "tools.alerts.threshold": "عتبة التغير (%)",
    "tools.alerts.thresholdNote": "سيتم إشعارك عندما يتجاوز تغير السوق هذه العتبة.",
    "tools.alerts.subscribe": "اشترك",
    "tools.alerts.checkEmail": "تحقق من بريدك الإلكتروني لتأكيد اشتراكك.",
    "tools.alerts.confirmedMsg": "تم تأكيد تنبيهك وتفعيله.",
    "tools.alerts.invalidMsg": "رابط التأكيد غير صالح أو منتهي الصلاحية.",
    "tools.alerts.unsubMsg": "تم إلغاء اشتراكك في هذا التنبيه.",
    "tools.packaging.title": "التعليب في عبوات بريك / حسب الطلب",
    "tools.packaging.desc": "اطلب عرض سعر للتعليب (بريك، زجاج، PET) أو العلامة البيضاء.",
    "tools.packaging.intro": "صف حاجتك للتعليب: ستتصل بك معصرة أو شركة تعليب شريكة بعرض سعر.",
    "tools.packaging.company": "الشركة",
    "tools.packaging.contact": "جهة الاتصال",
    "tools.packaging.email": "البريد الإلكتروني",
    "tools.packaging.phone": "الهاتف",
    "tools.packaging.type": "نوع العبوة",
    "tools.packaging.volume": "الحجم",
    "tools.packaging.quantity": "الكمية (وحدات)",
    "tools.packaging.whiteLabel": "العلامة البيضاء",
    "tools.packaging.message": "رسالة",
    "tools.packaging.submit": "اطلب عرض سعر",
    "tools.packaging.success": "تم إرسال الطلب",
    "tools.packaging.successDesc": "تم تسجيل طلب عرض السعر بنجاح. سنتصل بك قريبًا.",
    "tools.inspection.title": "التفتيش والتحاليل",
    "tools.inspection.desc": "اعتمِد وحلّل عيّناتك لدى مخابر معترف بها.",
    "tools.inspection.intro": "اعثر على مخابر وهيئات تفتيش لإجراء التحاليل الفيزيوكيميائية والحسية لعيّنات زيت الزيتون، واطلب التواصل.",
    "tools.inspection.tunisia": "مخابر في تونس",
    "tools.inspection.international": "مراجع دولية",
    "tools.inspection.coiYes": "معتمد لدى COI",
    "tools.inspection.coiToVerify": "اعتماد يجب التحقق منه",
    "tools.inspection.coiNote": "يجب التحقق من الاعتمادات في القائمة الرسمية لـ COI.",
    "tools.inspection.coiLink": "القائمة الرسمية لمخابر COI",
    "tools.inspection.website": "الموقع الإلكتروني",
    "tools.inspection.requestLink": "اطلب التواصل",
    "tools.inspection.disclaimer": "هذه الهيئات مراجع في القطاع وليست شركاء لـ EvooTunisia.",
    "tools.inspection.formTitle": "طلب التواصل",
    "tools.inspection.formDesc": "حدد احتياجاتك من التحاليل؛ نوجّهك إلى المخبر المناسب.",
    "tools.inspection.lab": "المخبر المطلوب",
    "tools.inspection.noPreference": "بدون تفضيل",
    "tools.inspection.lotRef": "مرجع العيّنة",
    "tools.inspection.analyses": "التحاليل المطلوبة",
    "tools.inspection.analysesPlaceholder": "الحموضة، البيروكسيدات، K270، اختبار حسي…",
    "tools.inspection.submit": "إرسال الطلب",
    "tools.inspection.success": "تم إرسال الطلب",
    "tools.inspection.successDesc": "تم تسجيل طلب التواصل بنجاح. سنعود إليك قريبًا.",
    "dash.menu.adminTools": "الأدوات والطلبات",
    "admin.tools.title": "الأدوات والطلبات",
    "admin.tools.tabAlerts": "التنبيهات",
    "admin.tools.tabQuotes": "عروض التعليب",
    "admin.tools.tabLeads": "طلبات التفتيش",
    "admin.tools.tabLabs": "المخابر",
    "admin.tools.noData": "لا توجد بيانات حاليًا.",
    "admin.tools.rowHint": "انقر لعرض التفاصيل",
    "admin.tools.alertDetail": "تفاصيل الاشتراك",
    "admin.tools.quoteDetail": "تفاصيل طلب عرض السعر",
    "admin.tools.leadDetail": "تفاصيل طلب الفحص",
    "admin.tools.frequency": "التكرار",
    "admin.tools.freqInstant": "فوري",
    "admin.tools.freqWeekly": "أسبوعي",
    "admin.tools.createdAt": "أُنشئ في",
    "admin.tools.confirmedAt": "تم التأكيد في",
    "admin.tools.sendHistory": "سجل الإرسال",
    "admin.tools.lastSent": "آخر إرسال",
    "admin.tools.lastDigest": "آخر ملخص",
    "admin.tools.never": "أبداً",
    "admin.tools.confirmManually": "تأكيد يدوي",
    "admin.tools.resendConfirmation": "إعادة إرسال التأكيد",
    "admin.tools.unsubscribe": "حذف / إلغاء الاشتراك",
    "admin.tools.confirmDeleteAlert": "حذف هذا الاشتراك نهائياً؟",
    "admin.tools.alertConfirmed": "تم تأكيد الاشتراك",
    "admin.tools.confirmationResent": "تمت إعادة إرسال بريد التأكيد",
    "admin.tools.alertDeleted": "تم حذف الاشتراك",
    "admin.tools.phone": "الهاتف",
    "admin.tools.message": "الرسالة",
    "admin.tools.thread": "سلسلة المحادثة",
    "admin.tools.noThread": "لا توجد مراسلات بعد.",
    "admin.tools.requestedLab": "المختبر المطلوب",
    "admin.tools.requestedAnalyses": "التحاليل المطلوبة",
    "admin.tools.concernedLot": "العرض المعني",
    "admin.tools.note": "ملاحظة داخلية",
    "admin.tools.notePlaceholder": "ملاحظة داخلية (تظهر للإدارة فقط)…",
    "admin.tools.saveNote": "حفظ الملاحظة",
    "admin.tools.contactByEmail": "التواصل عبر البريد",
    "admin.tools.callContact": "اتصال",
    "admin.tools.criteria": "المعايير",
    "admin.tools.status": "الحالة",
    "admin.tools.date": "التاريخ",
    "admin.tools.confirmed": "مؤكد",
    "admin.tools.pending": "قيد الانتظار",
    "admin.tools.newLab": "مخبر جديد",
    "admin.tools.labName": "اسم المخبر",
    "admin.tools.messages": "الرسائل",
    "request.status.new": "جديد",
    "request.status.in_progress": "قيد المعالجة",
    "request.status.closed": "مغلق",
    "quotes.title": "طلبات عروض الأسعار",
    "quotes.empty": "لا توجد طلبات عروض أسعار حاليًا.",
    "quotes.backList": "العودة إلى القائمة",
    "quotes.noMessages": "لا توجد رسائل. أرسل أول رد.",
    "quotes.replyPlaceholder": "اكتب ردك…",
    "quotes.replied": "تم إرسال الرد.",
    "quotes.sent": "تم إرسال الرسالة.",
    "quotes.threadTitle": "متابعة طلب عرض السعر",
    "quotes.threadSubtitle": "تواصل مع المعاصر التي تردّ على طلبك.",
    "quotes.notFound": "الطلب غير موجود أو انتهت صلاحية الرابط.",
    "quotes.waitingReplies": "في انتظار ردود المعاصر…",
    "quote.emit": "إصدار عرض سعر",
    "quote.newQuote": "عرض سعر مُنظَّم جديد",
    "quote.currency": "العملة",
    "quote.vatMode": "نمط ض.ق.م",
    "quote.vatGlobal": "ض.ق.م إجمالية",
    "quote.vatPerLine": "ض.ق.م لكل سطر",
    "quote.vatRate": "نسبة ض.ق.م (%)",
    "quote.lines": "بنود العرض",
    "quote.lineDesc": "البيان",
    "quote.lineQty": "الكمية",
    "quote.lineUnit": "الوحدة",
    "quote.lineUnitPrice": "سعر الوحدة دون ض.ق.م",
    "quote.lineVat": "ض.ق.م %",
    "quote.lineTotal": "المجموع دون ض.ق.م",
    "quote.addLine": "إضافة سطر",
    "quote.delivery": "التسليم / الأجل",
    "quote.deliveryPh": "مثال: خلال 3 أسابيع، تسليم صفاقس",
    "quote.incoterm": "إنكوترم",
    "quote.validity": "الصلاحية (أيام)",
    "quote.notes": "ملاحظات / شروط",
    "quote.attachments": "المرفقات",
    "quote.addAttachment": "إرفاق ملف",
    "quote.attachmentHint": "PDF, JPG, PNG, WEBP · بحد أقصى 15 ميغا",
    "quote.subtotal": "المجموع دون ض.ق.م",
    "quote.vat": "ض.ق.م",
    "quote.total": "المجموع مع ض.ق.م",
    "quote.send": "إرسال العرض",
    "quote.sent": "تم إرسال العرض.",
    "quote.cancel": "إلغاء",
    "quote.confirm": "تأكيد",
    "quote.byMill": "عرض من",
    "quote.issuedDate": "صادر في",
    "quote.validityLabel": "الصلاحية",
    "quote.days": "أيام",
    "quote.downloadPdf": "تنزيل PDF",
    "quote.accept": "قبول",
    "quote.refuse": "رفض",
    "quote.revise": "طلب مراجعة",
    "quote.reviseComment": "حدّد التغييرات المطلوبة…",
    "quote.refuseComment": "السبب (اختياري)…",
    "quote.confirmAccept": "تأكيد قبول هذا العرض؟ سيتم إنشاء ملف PDF للتأكيد.",
    "quote.actionDone": "تم تسجيل ردّك.",
    "quote.needLine": "أضف سطرًا صالحًا واحدًا على الأقل.",
    "quote.acceptedLock": "تم قبول عرض. العروض الأخرى مغلقة.",
    "quote.status.sent": "قيد الانتظار",
    "quote.status.accepted": "مقبول",
    "quote.status.refused": "مرفوض",
    "quote.status.revision_requested": "مطلوب مراجعة",
    "quote.sys.accepted": "قَبِل العرض",
    "quote.sys.refused": "رفض العرض",
    "quote.sys.revision_requested": "طلب مراجعة العرض",
    "quote.commentLabel": "تعليق",
    "quote.compare.title": "مقارنة العروض",
    "quote.compare.provider": "المزوّد",
    "quote.compare.delay": "الأجل",
    "quote.compare.status": "الحالة",
    "quote.compare.open": "فتح",
    "quote.compare.sortTotal": "الإجمالي",
    "quote.compare.sortDelay": "الأجل",
    "quote.compare.multiCurrency": "عملات مختلفة — قارن مع مراعاة عملة كل عرض.",
    "tools.alerts.frequency": "التكرار",
    "tools.alerts.freq.instant": "فوري",
    "tools.alerts.freq.weekly": "ملخص أسبوعي",
    "tools.alerts.freq.instantNote": "بريد إلكتروني عند كل عرض جديد مطابق.",
    "tools.alerts.freq.weeklyNote": "بريد إلكتروني واحد مجمّع كل أسبوع.",
    "tools.calc.incotermCompare": "مقارن الإنكوترمز",
    "tools.calc.incotermCompareDesc": "التكلفة المقدّرة حسب الإنكوترمز، انطلاقًا من التكاليف المُدخلة.",
    "tools.calc.incotermCompareNote": "تقدير إرشادي: تختلف التكاليف المُدرجة حسب الاتفاق التجاري الفعلي.",
    "tools.calc.selected": "محدد",
    "confirm.loading": "جارٍ التأكيد…",
    "confirm.ok.title": "تم تأكيد تنبيهك ✅",
    "confirm.ok.desc": "تم! ستتلقى الآن إشعاراتنا عبر البريد الإلكتروني وفقًا لمعاييرك.",
    "confirm.already.title": "التنبيه مؤكَّد مسبقًا",
    "confirm.already.desc": "هذا التنبيه كان مفعّلًا بالفعل. لا حاجة لأي إجراء إضافي.",
    "confirm.invalid.title": "رابط غير صالح",
    "confirm.invalid.desc": "رابط التأكيد هذا غير صالح. يمكنك إعادة التسجيل أدناه.",
    "confirm.expired.title": "انتهت صلاحية الرابط",
    "confirm.expired.desc": "انتهت صلاحية رابط التأكيد. يرجى إعادة التسجيل لتلقّي تنبيهاتك.",
    "confirm.error.title": "حدث خطأ",
    "confirm.error.desc": "تعذّر تأكيد تنبيهك حاليًا. أعد المحاولة لاحقًا أو أعد التسجيل.",
    "confirm.resubscribe": "إعادة التسجيل",
    "confirm.browseMarket": "استكشف السوق",
    "tools.alerts.alreadySubscribed": "هذا العنوان مشترك بالفعل في التنبيهات.",
    "tools.alerts.managePrefs": "إدارة تفضيلات التنبيه",
    "tools.alerts.manageLinkSent": "تم إرسال رابط آمن إلى بريدك الإلكتروني.",
    "tools.alerts.alreadyPending": "تم إرسال بريد تأكيد إليك من قبل.",
    "tools.alerts.resendConfirm": "إعادة إرسال بريد التأكيد",
    "tools.alerts.resent": "تمت إعادة إرسال بريد التأكيد.",
    "manage.title": "إدارة تنبيهاتي",
    "manage.subtitle": "عدّل معاييرك أو تكرارك أو ألغِ الاشتراك.",
    "manage.forEmail": "أنت تدير تنبيهات:",
    "manage.none": "لا توجد تنبيهات لهذا العنوان.",
    "manage.save": "حفظ",
    "manage.saved": "تم حفظ التفضيلات.",
    "manage.unsubscribe": "إلغاء الاشتراك",
    "manage.unsubscribed": "تم إلغاء اشتراكك في هذا التنبيه.",
    "manage.confirmUnsub": "سيؤدي إلغاء الاشتراك إلى حذف هذا التنبيه وبريدك المرتبط نهائيًا. هل تريد المتابعة؟",
    "manage.consumed": "تم حفظ تفضيلاتك. هذا الرابط ذو الاستخدام الواحد أصبح مستخدمًا الآن. لإجراء تغييرات أخرى، اطلب رابطًا جديدًا.",
    "manage.requestNew": "الحصول على رابط جديد",
    "manage.active": "مفعّل",
    "manage.paused": "متوقّف",
    "manage.invalid.title": "رابط غير صالح",
    "manage.invalid.desc": "رابط الإدارة هذا غير صالح. اطلب رابطًا جديدًا من صفحة التسجيل في التنبيهات.",
    "manage.expired.title": "انتهت صلاحية الرابط",
    "manage.expired.desc": "انتهت صلاحية رابط الإدارة. اطلب رابطًا جديدًا من صفحة التسجيل في التنبيهات.",
    "page.blog.title": "المدونة والأخبار",

    "directory.capacity": "الطاقة",
    "directory.system": "النظام",
    "directory.certifications": "الشهادات",
    "blog.readMore": "اقرأ المقال",
    "blog.subtitle": "تحليلات السوق، زراعة الزيتون، الجودة والتصدير — المنصة الإعلامية B2B لقطاع زيت الزيتون التونسي.",
    "blog.type.all": "الكل",
    "blog.type.article": "مقالات",
    "blog.type.market": "نبض السوق",
    "blog.cat.all": "كل الفئات",
    "blog.cat.marche": "السوق والأسعار",
    "blog.cat.oleiculture": "زراعة الزيتون",
    "blog.cat.qualite": "الجودة",
    "blog.cat.export": "التصدير",
    "blog.cat.recettes": "وصفات واستعمالات",
    "blog.cat.reglementation": "التشريعات",
    "blog.empty": "لا توجد مقالات حاليًا. عد قريبًا!",
    "blog.linkCopied": "تم نسخ الرابط",
    "blog.notFound": "المقال غير موجود.",
    "blog.backToBlog": "العودة إلى المدونة",
    "blog.share": "مشاركة",
    "blog.aiPublicNotice": "حُرِّر هذا المقال بمساعدة الذكاء الاصطناعي وراجعته هيئة التحرير.",
    "blog.related": "اقرأ أيضًا",
    "blog.admin.title": "المدونة والمحتوى",
    "blog.admin.new": "مقال جديد",
    "blog.admin.empty": "لا توجد مقالات. أنشئ أول محتوى لك.",
    "blog.admin.confirmDelete": "حذف هذا المقال نهائيًا؟",
    "blog.admin.deleted": "تم حذف المقال",
    "blog.admin.needContent": "أضف عنوانًا أو محتوى بلغة واحدة على الأقل.",
    "blog.admin.saved": "تم حفظ المقال",
    "blog.admin.status.draft": "مسودة",
    "blog.admin.status.published": "منشور",
    "blog.admin.backList": "العودة إلى القائمة",
    "blog.admin.langContent": "المحتوى",
    "blog.admin.fTitle": "العنوان",
    "blog.admin.fSlug": "الرابط (Slug)",
    "blog.admin.fExcerpt": "المقتطف",
    "blog.admin.fContent": "المحتوى (Markdown)",
    "blog.admin.contentPlaceholder": "اكتب مقالك بصيغة Markdown…",
    "blog.admin.seo": "تحسين محركات البحث (SEO)",
    "blog.admin.metaTitle": "عنوان الميتا",
    "blog.admin.metaDesc": "وصف الميتا",
    "blog.admin.settings": "الإعدادات",
    "blog.admin.category": "الفئة",
    "blog.admin.type": "نوع المحتوى",
    "blog.admin.author": "الكاتب",
    "blog.admin.cover": "صورة الغلاف",
    "blog.admin.coverUpload": "رفع صورة",
    "blog.admin.coverUploading": "جارٍ الرفع…",
    "blog.admin.coverOr": "أو ألصق رابط صورة",
    "blog.admin.coverRemove": "إزالة",
    "blog.admin.coverHint": "JPG أو PNG أو WEBP — بحد أقصى 15 ميغابايت. استخدم صورًا حقيقية (أشجار زيتون، معاصر).",
    "blog.admin.currentStatus": "الحالة الحالية",
    "blog.admin.saveDraft": "حفظ المسودة",
    "blog.admin.publish": "نشر",
    "blog.admin.write": "كتابة",
    "blog.admin.preview": "معاينة",
    "blog.ai.title": "مولّد المقالات (ذكاء اصطناعي)",
    "blog.ai.subject": "موضوع المقال",
    "blog.ai.langs": "اللغات المراد توليدها",
    "blog.ai.tone": "الأسلوب",
    "blog.ai.length": "الطول",
    "blog.ai.len.court": "قصير",
    "blog.ai.len.moyen": "متوسط",
    "blog.ai.len.long": "طويل",
    "blog.ai.type": "نوع المحتوى",
    "blog.ai.keywords": "كلمات مفتاحية SEO (اختياري)",
    "blog.ai.sourceData": "بيانات مصدرية (اختياري)",
    "blog.ai.sourcePlaceholder": "ألصق هنا أرقامًا/حقائق لاستخدامها كما هي (لن يخترع الذكاء الاصطناعي شيئًا).",
    "blog.ai.warning": "قد يخطئ الذكاء الاصطناعي. راجِع وتحقق من الحقائق قبل النشر.",
    "blog.ai.generate": "توليد المسودة",
    "blog.ai.translateBtn": "ترجمة إلى اللغات الأخرى",
    "blog.ai.needSubject": "أدخل موضوعًا.",
    "blog.ai.done": "تم توليد المسودة",
    "blog.ai.failed": "فشل التوليد. أعد المحاولة.",
    "blog.ai.needSource": "اكتب المحتوى أولًا بلغة المصدر.",
    "blog.ai.translated": "تم توليد الترجمات",
    "dash.menu.adminBlog": "المدونة",

    "nav.dashboard": "لوحة التحكم",
    "auth.logout": "تسجيل الخروج",
    "auth.error": "حدث خطأ. حاول مرة أخرى.",
    "badge.verified": "موثّق",
    "common.loading": "جارٍ التحميل…",
    "common.optional": "(اختياري)",
    "common.save": "حفظ",
    "common.cancel": "إلغاء",

    "register.name": "اسم الممثل",
    "register.matricule": "المعرّف الجبائي",
    "register.address": "العنوان",
    "register.governorate": "الولاية",
    "register.phone": "الهاتف",
    "register.website": "الموقع الإلكتروني",
    "register.section.account": "بيانات الدخول",
    "register.section.company": "شركتك",
    "register.free": "التسجيل مجاني 100٪ — دون أي دفع.",

    "dash.welcome": "مرحبًا، {name}",
    "dash.subtitle": "أدر نشاطك على EvooTunisia.",
    "dash.menu.overview": "نظرة عامة",
    "dash.menu.lots": "عروضي",
    "dash.menu.offers": "طلباتي",
    "dash.menu.messages": "الرسائل",
    "dash.menu.company": "شركتي",
    "dash.menu.verification": "التوثيق",
    "dash.menu.settings": "الإعدادات",
    "dash.verify.cta": "وثّق حسابي",
    "dash.verify.banner": "حسابك غير موثّق بعد. وثّقه للحصول على الشارة وإبراز عروضك.",
    "dash.card.status": "حالة الحساب",
    "dash.card.role": "نوع الحساب",
    "dash.card.company": "الشركة",

    "company.title": "شركتي",
    "company.subtitle": "معلومات الشركة المرتبطة بحسابك.",
    "company.saved": "تم تحديث الشركة.",
    "company.matriculeLocked": "لا يمكن تعديل المعرّف الجبائي.",

    "kyc.title": "توثيق الحساب",
    "kyc.subtitle": "حمّل مستنداتك للحصول على شارة «موثّق».",
    "kyc.status.unverified": "غير موثّق",
    "kyc.status.pending": "قيد الانتظار",
    "kyc.status.verified": "موثّق",
    "kyc.status.rejected": "مرفوض",
    "kyc.doc.company_doc": "وثيقة رسمية للشركة (السجل / المعرّف الجبائي)",
    "kyc.doc.link_proof": "إثبات العلاقة بالشركة",
    "kyc.doc.id_document": "هوية الممثل",
    "kyc.doc.bank_rib": "معرّف بنكي / شهادة بنكية",
    "kyc.upload": "تحميل",
    "kyc.replace": "استبدال",
    "kyc.uploaded": "تم التحميل",
    "kyc.view": "عرض",
    "kyc.submit": "إرسال للتوثيق",
    "kyc.submitted": "تم إرسال المستندات. التوثيق قيد الانتظار.",
    "kyc.secure": "مستنداتك مشفّرة ولا تُنشر للعموم أبدًا.",
    "kyc.sellerNote": "بصفتك بائعًا، يلزم تقديم معرّف بنكي / شهادة بنكية.",
    "kyc.pendingNote": "مستنداتك قيد المراجعة من قبل فريقنا.",
    "kyc.verifiedNote": "تهانينا! تم توثيق حسابك.",
    "kyc.rejectedNote": "تم رفض التوثيق. يُرجى إعادة إرسال مستندات صالحة.",

    "settings.title": "الإعدادات",
    "settings.email": "البريد الإلكتروني",
    "settings.role": "نوع الحساب",
    "settings.notifications": "الإشعارات",
    "settings.notifyQuotes": "استقبال طلبات عروض الأسعار الجديدة عبر البريد الإلكتروني",
    "settings.notifyQuotesSaved": "تم حفظ التفضيل",
    "settings.emailPrefs": "تفضيلات البريد الإلكتروني",
    "settings.emailPrefsDesc": "اختر رسائل البريد التي تريد استقبالها. يبقى جرس الإشعارات مفعّلًا دائمًا.",
    "settings.prefsSaved": "تم حفظ التفضيلات",
    "settings.pref.negotiations": "العروض والمفاوضات",
    "settings.pref.quotes": "عروض أسعار التعبئة",
    "settings.pref.verification": "قرار التوثيق (KYC)",
    "settings.pref.alerts": "تنبيهات السوق",
    "settings.pref.transactionalNote": "تُرسَل دائمًا رسائل الأمان والمعاملات (تأكيد البريد، إعادة تعيين كلمة المرور).",
    "dash.menu.deals": "سجل الصفقات",
    "deals.title": "سجل الصفقات",
    "deals.empty": "لا توجد عمليات مبرمة حتى الآن.",
    "deals.revenue": "رقم المعاملات",
    "deals.spend": "إجمالي المشتريات",
    "deals.totalCommission": "إجمالي العمولات",
    "deals.count": "عملية",
    "deals.date": "التاريخ",
    "deals.role": "الدور",
    "deals.product": "المنتج",
    "deals.counterparty": "الطرف المقابل",
    "deals.quantity": "الكمية",
    "deals.total": "المبلغ",
    "deals.commission": "العمولة",
    "deals.seller": "بيع",
    "deals.buyer": "شراء",
    "settings.soon": "ستتوفر إعدادات أخرى قريبًا.",

    "auth.google": "المتابعة عبر Google",
    "auth.or": "أو",
    "auth.connecting": "جارٍ الاتصال…",
    "profile.title": "أكمل ملفك",
    "profile.subtitle": "خطوة أخيرة: أدخل بيانات شركتك للوصول إلى السوق.",
    "profile.submit": "إنهاء",
    "profile.welcome": "مرحبًا {name}! اختر نوع حسابك وشركتك.",

    "quality.premium_bio": "ممتاز / عضوي",
    "quality.grignon": "فيتورة",
    "incoterm.label": "إنكوترم",
    "common.close": "إغلاق",
    "common.all": "الكل",

    "vrac.publish": "أضف عرضًا",
    "vrac.filters": "المرشّحات",
    "vrac.filter.quality": "الجودة",
    "vrac.filter.qty": "الكمية (كغ)",
    "vrac.filter.acidityMax": "أقصى حموضة (º)",
    "vrac.filter.governorate": "الولاية",
    "vrac.filter.price": "السعر (د.ت/كغ)",
    "vrac.filter.incoterm": "إنكوترم",
    "vrac.filter.min": "الأدنى",
    "vrac.filter.max": "الأقصى",
    "vrac.filter.reset": "إعادة ضبط",
    "vrac.sort": "ترتيب",
    "vrac.sort.recent": "الأحدث",
    "vrac.sort.price_asc": "السعر تصاعدي",
    "vrac.sort.price_desc": "السعر تنازلي",
    "vrac.sort.qty_desc": "الكمية",
    "vrac.empty": "لا توجد عروض مطابقة لبحثك.",
    "vrac.results": "{n} عرض",

    "lot.acidity": "الحموضة",
    "lot.peroxides": "مؤشر البيروكسيد",
    "lot.k270": "K270",
    "lot.polyphenols": "البوليفينول",
    "lot.panel": "اختبار التذوق",
    "lot.incoterm": "إنكوترم",
    "lot.origin": "المنشأ",
    "lot.availability": "التوفّر",
    "lot.description": "الوصف",
    "lot.documents": "التحاليل والوثائق",
    "lot.characteristics": "الخصائص",
    "lot.seller": "البائع",
    "lot.makeOffer": "تقديم عرض",
    "lot.contact": "اتصال",
    "lot.notFound": "العرض غير موجود",
    "lot.perKg": "/ كغ",
    "lot.back": "العودة إلى السوق",

    "offer.subtitle": "ابدأ مفاوضة خاصة مع البائع.",
    "offer.title": "تقديم عرض",
    "offer.price": "السعر المقترح",
    "offer.quantity": "الكمية",
    "offer.message": "رسالة",
    "offer.send": "إرسال العرض",
    "offer.sent": "تم إرسال العرض!",

    "lotform.new": "عرض سائب جديد",
    "lotform.edit": "تعديل العرض",
    "lotform.title": "عنوان العرض",
    "lotform.variety": "الصنف",
    "lotform.acidity": "الحموضة (º)",
    "lotform.peroxides": "مؤشر البيروكسيد",
    "lotform.k270": "K270",
    "lotform.polyphenols": "البوليفينول",
    "lotform.panel": "اختبار التذوق",
    "lotform.governorate": "ولاية المنشأ",
    "lotform.country": "بلد المنشأ",
    "lotform.availability": "التوفّر",
    "lotform.photos": "الصور",
    "lotform.docs": "التحاليل (PDF)",
    "lotform.addFiles": "إضافة ملفات",
    "lotform.uploading": "جارٍ الإرسال…",
    "lotform.created": "تم نشر العرض!",
    "lotform.updated": "تم تحديث العرض",

    "mylots.new": "أضف عرضًا",
    "mylots.empty": "لم تنشر أي عرض بعد.",
    "mylots.notVerifiedTitle": "حساب غير موثّق",
    "mylots.notVerified": "يمكن للبائعين الموثّقين فقط نشر العروض.",
    "mylots.markSold": "وسم كمُباع",
    "mylots.reactivate": "إعادة التفعيل",
    "mylots.withdraw": "سحب",
    "mylots.edit": "تعديل",
    "status.available": "متاح",
    "status.sold": "مُباع",
    "status.withdrawn": "مسحوب",

    "myoffers.empty": "لا توجد عروض حاليًا.",
    "myoffers.sent": "مُرسلة",
    "myoffers.received": "واردة",

    "req.publish": "نشر طلب",
    "req.new": "طلب شراء جديد",
    "req.quality": "الجودة المطلوبة",
    "req.quantity": "الكمية (كغ)",
    "req.targetPrice": "السعر المستهدف (د.ت/كغ)",
    "req.origin": "المنشأ المطلوب",
    "req.description": "تفاصيل",
    "req.submit": "نشر الطلب",
    "req.created": "تم نشر الطلب!",
    "req.empty": "لا توجد طلبات شراء حاليًا.",
    "req.looking": "يبحث عن",
    "req.buyerNote": "انشر ما تبحث عنه لتلقّي العروض.",

    "cond.market": "سوق المعبأ",
    "cond.publish": "أضف عرضًا معبأً",
    "cond.units": "وحدة",
    "cond.format": "الحجم",
    "cond.minOrder": "الحد الأدنى للطلب",
    "cond.brand": "العلامة",
    "cond.whiteLabel": "علامة بيضاء",
    "cond.whiteLabelBadge": "علامة بيضاء",
    "cond.perUnit": "/ وحدة",
    "cond.filter.packaging": "نوع التعبئة",
    "cond.filter.price": "السعر (د.ت/وحدة)",
    "cond.filter.volume": "الحجم",
    "packaging.verre": "زجاج",
    "packaging.pet": "بلاستيك PET",
    "packaging.bidon_metal": "صفيحة معدنية",
    "packaging.brik": "بريك",
    "packaging.canette": "علبة",
    "packaging.monodose": "جرعة مفردة",
    "packaging.dosettes": "كبسولات / لآلئ",
    "lotform.market": "نوع السوق",
    "lotform.packaging": "نوع التعبئة",
    "lotform.volume": "الحجم لكل وحدة (مل)",
    "lotform.units": "عدد الوحدات",
    "lotform.minOrder": "الحد الأدنى للطلب (وحدات)",
    "lotform.brand": "العلامة / الملصق",
    "lotform.whiteLabel": "علامة بيضاء متاحة",
    "lotform.pricePerUnit": "السعر لكل وحدة (د.ت)",
    "alert.title": "تنبيهات العروض المعبأة الجديدة",
    "alert.cta": "استقبل التنبيهات",
    "alert.subtitle": "احصل على إشعارات بالبريد حسب معاييرك.",
    "alert.email": "بريدك الإلكتروني",
    "alert.quality": "الجودة (اختياري)",
    "alert.packaging": "التعبئة (اختياري)",
    "alert.governorate": "المنشأ (اختياري)",
    "alert.maxPrice": "أقصى سعر للوحدة (اختياري)",
    "alert.submit": "تفعيل التنبيهات",
    "alert.created": "أوشكت على الانتهاء! تحقق من بريدك لتأكيد التنبيه.",
    "alert.note": "سيُفعّل إرسال البريد قريبًا.",

    "nego.center": "الرسائل والمفاوضات",
    "nego.empty": "لا توجد محادثات حاليًا.",
    "nego.selectConv": "اختر محادثة",
    "nego.you": "أنت",
    "nego.buyer": "المشتري",
    "nego.seller": "البائع",
    "nego.counter": "عرض مضاد",
    "nego.accept": "قبول",
    "nego.refuse": "رفض",
    "nego.send": "إرسال",
    "nego.message": "رسالة",
    "nego.messagePlaceholder": "اكتب رسالة…",
    "nego.price": "السعر",
    "nego.quantity": "الكمية",
    "nego.makeCounter": "تقديم عرض مضاد",
    "nego.status.pending": "قيد الانتظار",
    "nego.status.countered": "تم الرد بعرض",
    "nego.status.accepted": "مقبول",
    "nego.status.refused": "مرفوض",
    "nego.status.expired": "منتهٍ",
    "nego.awaiting": "بانتظار ردّك",
    "nego.concluded": "تمّت الصفقة",
    "nego.closedUnavailable": "العرض غير متوفّر",
    "nego.downloadQuote": "تنزيل تأكيد عرض السعر (PDF)",
    "nego.lotUnavailableMsg": "هذا العرض لم يعد متوفّرًا.",
    "nego.summary": "الملخّص",
    "nego.finalQty": "الكمية",
    "nego.finalPrice": "سعر الوحدة",
    "nego.total": "المبلغ الإجمالي",
    "nego.commBuyer": "عمولة المشتري",
    "nego.commSeller": "عمولة البائع",
    "nego.export": "عملية تصدير (دولية)",
    "nego.transportNote": "المنصة لا تتكفّل بالنقل. اللوجستيك على عاتق الطرفين حسب الإنكوترم المتفق عليه.",
    "nego.offerLine": "عرض: {qty} × {price}",
    "nego.tabActive": "المفاوضات النشطة",
    "nego.tabConcluded": "المنجزة / المؤرشفة",
    "nego.emptyActive": "لا توجد مفاوضات نشطة.",
    "nego.emptyConcluded": "لا توجد صفقات منجزة.",
    "nego.lotLabel": "اللوط",
    "nego.offerStatus": "حالة العرض",
    "admin.commission.title": "جدول العمولات",
    "admin.commission.vracNatB": "سائب محلي — المشتري (%)",
    "admin.commission.vracNatS": "سائب محلي — البائع (%)",
    "admin.commission.vracExpB": "سائب تصدير — المشتري (%)",
    "admin.commission.vracExpS": "سائب تصدير — البائع (%)",
    "admin.commission.condB": "معبأ — المشتري (%)",
    "admin.commission.condS": "معبأ — البائع (%)",
    "admin.commission.saved": "تم حفظ الجدول.",
    "emailconf.checkTitle": "تحقّق من بريدك الإلكتروني",
    "emailconf.checkDesc": "أرسلنا رابط تأكيد إلى {email}. انقر عليه لتفعيل حسابك ثم سجّل الدخول.",
    "emailconf.spamHelp": "لم تستلم البريد؟ تحقّق من مجلد الرسائل غير المرغوب فيها (spam) ثم انقر على «إعادة إرسال بريد التأكيد».",
    "emailconf.resend": "إعادة إرسال بريد التأكيد",
    "emailconf.resent": "تمت إعادة إرسال بريد التأكيد.",
    "emailconf.loginBlockedTitle": "أكّد عنوان بريدك الإلكتروني",
    "emailconf.loginBlockedDesc": "لم يتم تأكيد بريدك الإلكتروني بعد. انقر على الرابط الذي أرسلناه إليك للدخول إلى حسابك.",
    "emailconf.confirming": "جارٍ التأكيد…",
    "emailconf.confirmedTitle": "تم تأكيد البريد الإلكتروني",
    "emailconf.confirmedDesc": "تم تأكيد بريدك الإلكتروني. يمكنك الآن تسجيل الدخول.",
    "emailconf.invalidTitle": "رابط غير صالح",
    "emailconf.invalidDesc": "رابط التأكيد هذا غير صالح. أدخل بريدك الإلكتروني لتلقّي رابط جديد.",
    "emailconf.expiredTitle": "انتهت صلاحية الرابط",
    "emailconf.expiredDesc": "انتهت صلاحية رابط التأكيد هذا. أدخل بريدك الإلكتروني لتلقّي رابط جديد.",
    "emailconf.goLogin": "الذهاب إلى تسجيل الدخول",
    "emailconf.emailPlaceholder": "عنوان بريدك الإلكتروني",
    "emailconf.notKyc": "تأكيد البريد الإلكتروني منفصل عن التحقق من وثائق شركتك (KYC).",
    "emailconf.backToLogin": "العودة إلى تسجيل الدخول",
    "notif.title": "الإشعارات",
    "notif.empty": "لا توجد إشعارات.",
    "notif.markAll": "تحديد الكل كمقروء",
    "myquotes.title": "طلبات عروض الأسعار الخاصة بي",
    "myquotes.subtitle": "تابع الطلبات التي أرسلتها وعروض الأسعار المستلمة.",
    "myquotes.empty": "لم ترسل أي طلب عرض سعر بعد.",
    "myquotes.new": "طلب جديد",
    "myquotes.responsesCount": "{n} عرض سعر مستلم",
    "verifygate.title": "التحقق مطلوب",
    "verifygate.desc": "يجب التحقق من حسابك (KYC) لإتمام أي عملية. يمكنك متابعة التصفح وطلب العروض والتفاوض، لكن الإتمام يتطلب حسابًا موثّقًا.",
    "verifygate.counterparty": "الطرف الآخر لم يتم التحقق منه بعد. سيكون الإتمام ممكنًا بعد توثيق الحسابين.",
    "verifygate.cta": "إكمال التحقق",
    "verifygate.later": "لاحقًا",
    "packaging.loggedInNote": "تم إرسال الطلب باسم {company}. سيظهر في «طلبات عروض الأسعار الخاصة بي».",
    "packaging.viewMyQuotes": "عرض طلبات عروض الأسعار الخاصة بي",
    "cookie.title": "نحن نحترم خصوصيتك",
    "cookie.message": "نستخدم ملفات تعريف ارتباط ضرورية لعمل الموقع، وبموافقتك، ملفات لقياس الجمهور والتسويق. يمكنك القبول أو الرفض أو تخصيص اختياراتك.",
    "cookie.policy": "سياسة ملفات تعريف الارتباط",
    "cookie.accept": "قبول الكل",
    "cookie.reject": "رفض الكل",
    "cookie.manage": "تخصيص",
    "cookie.save": "حفظ اختياراتي",
    "cookie.essential": "ملفات ضرورية",
    "cookie.essentialDesc": "ضرورية لعمل الموقع (مفعّلة دائمًا).",
    "cookie.analytics": "قياس الجمهور",
    "cookie.analyticsDesc": "تساعدنا على فهم كيفية استخدام الموقع.",
    "cookie.marketing": "التسويق",
    "cookie.marketingDesc": "تخصيص المحتوى والإعلانات.",
    "admin.treasury.title": "خزينة العمولات",
    "admin.treasury.subtitle": "المفوتر مقابل المحصّل شهريًا. التحصيل يدوي عبر التحويل البنكي (حالة «مدفوعة» يعتمدها المشرف).",
    "admin.treasury.runReminders": "إرسال التذكيرات",
    "admin.treasury.remindersSent": "تم إرسال {n} تذكير(ات) دفع",
    "admin.treasury.remindersError": "فشل إرسال التذكيرات",
    "admin.treasury.billed": "المفوتر",
    "admin.treasury.collected": "المحصّل",
    "admin.treasury.outstanding": "قيد الانتظار",
    "admin.treasury.overdue": "متأخرة",
    "admin.treasury.invoices": "فواتير",
    "admin.treasury.paid": "مدفوعة",
    "admin.treasury.awaiting": "قيد الاعتماد",
    "admin.treasury.issued": "صادرة",
    "admin.treasury.month": "الشهر",
    "admin.treasury.noData": "لا توجد فواتير حتى الآن.",
    "pricedigest.badge": "مجاني · أسبوعي",
    "pricedigest.title": "استلم أسعار السوق كل أسبوع",
    "pricedigest.desc": "بريد إلكتروني أسبوعي يتضمّن أسعار زيت الزيتون عند المصدر في تونس واتجاه السوق. يمكن إلغاء الاشتراك بنقرة واحدة.",
    "pricedigest.subscribe": "أشترك",
    "pricedigest.consent": "أوافق على استلام هذا البريد الأسبوعي وعلى",
    "pricedigest.privacy": "سياسة حماية البيانات",
    "pricedigest.consentRequired": "يُرجى الموافقة للمتابعة.",
    "pricedigest.optinNote": "تأكيد مزدوج: ستستلم بريدًا إلكترونيًا لتأكيد اشتراكك.",
    "dash.menu.adminInvoices": "الفواتير",
    "admin.invoices.title": "الفواتير (الكل)",
    "admin.invoices.allStatuses": "كل الحالات",
    "admin.invoices.period": "الفترة (شهر)",
    "admin.invoices.search": "بحث",
    "admin.invoices.searchPlaceholder": "رقم الفاتورة، العملية، الشركة…",
    "admin.invoices.count": "فواتير",
    "admin.invoices.empty": "لا توجد فواتير مطابقة لهذه المرشحات.",
    "admin.invoices.export": "تصدير",
    "admin.invoices.exportCsv": "CSV (.csv)",
    "admin.invoices.exportExcel": "Excel (.xlsx)",
    "admin.invoices.exportError": "فشل التصدير.",
    "admin.digest.title": "النشرة الأسبوعية للأسعار",
    "admin.digest.subtitle": "معاينة واختبار البريد الإلكتروني المُرسَل تلقائيًا كل يوم اثنين إلى المشتركين المؤكدين.",
    "admin.digest.subscribers": "مشترك مؤكد",
    "admin.digest.preview": "معاينة",
    "admin.digest.previewTitle": "معاينة نشرة الأسعار",
    "admin.digest.testEmail": "بريد إلكتروني للاختبار",
    "admin.digest.sendTest": "إرسال اختبار",
    "admin.digest.testSent": "تم إرسال بريد الاختبار إلى {email}",
    "admin.digest.testError": "فشل إرسال الاختبار.",
    "admin.digest.emailRequired": "يُرجى إدخال بريد إلكتروني.",
    "admin.digest.unavailable": "لا تتوفر بيانات أسعار لإنشاء النشرة.",
  },

  en: {
    "brand.tagline": "B2B marketplace for Tunisian olive oil",
    "nav.home": "Home",
    "nav.market": "Market",
    "nav.market.bulk": "Bulk",
    "nav.market.packaged": "Packaged",
    "nav.market.requests": "Requests",
    "nav.prices": "Prices",
    "nav.directory": "Mills directory",
    "nav.tools": "Tools",
    "nav.blog": "Blog",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.menu": "Menu",
    "nav.language": "Language",
    "nav.currency": "Currency",
    "seo.home.title": "B2B wholesale olive oil marketplace in Tunisia",
    "seo.home.desc": "EvooTunisia connects producers, mills and buyers of bulk olive oil. Negotiate bulk and packaged lots, track market prices and find verified mills.",
    "seo.market.vrac.title": "Bulk olive oil — Wholesale market",
    "seo.market.vrac.desc": "Buy and sell bulk olive oil (extra virgin, virgin, lampante). Verified lots, filters by quality, acidity, price and region.",
    "seo.market.conditionne.title": "Packaged olive oil — Wholesale",
    "seo.market.conditionne.desc": "Source packaged olive oil in bulk: bottles, cans and custom packaging from verified Tunisian suppliers.",
    "seo.market.demandes.title": "Bulk olive oil buying requests",
    "seo.market.demandes.desc": "Browse olive oil buying requests posted by buyers and respond with your wholesale offers.",
    "seo.prices.title": "Olive oil prices in Tunisia — Rates & trends",
    "seo.prices.desc": "Track wholesale olive oil prices in Tunisia: current and historical rates and market trends by quality.",
    "seo.directory.title": "Directory of Tunisian olive oil mills",
    "seo.directory.desc": "Discover olive oil mills in Tunisia: contact details, certifications, varieties and production capacities.",
    "seo.tools.title": "Tools for olive oil professionals",
    "seo.tools.desc": "Landed-cost calculator, market alerts, packaging quotes and inspection labs for olive oil professionals.",
    "seo.tools.calculator.title": "Landed-cost calculator",
    "seo.tools.calculator.desc": "Estimate your landed cost and margin on bulk olive oil, including transport, packaging and commission.",
    "seo.tools.alerts.title": "Market alerts — olive oil",
    "seo.tools.alerts.desc": "Get an email alert as soon as an olive oil lot matches your price, quality and volume criteria.",
    "seo.tools.packaging.title": "Packaging quotes — olive oil",
    "seo.tools.packaging.desc": "Request packaging quotes (bottles, cans, labels) from verified Tunisian packers.",
    "seo.tools.inspection.title": "Inspection & analysis labs",
    "seo.tools.inspection.desc": "Find labs to inspect and analyse olive oil quality before shipment.",
    "seo.blog.title": "Olive oil blog & news",
    "seo.blog.desc": "Market analysis, guides and news about Tunisian olive oil, multilingual and regularly updated.",
    "seo.faq.title": "Frequently asked questions",
    "seo.faq.desc": "Answers to common questions about buying and selling bulk olive oil on EvooTunisia.",

    "hero.badge": "Origin Tunisia · Bulk & Packaged · Export",
    "hero.title": "Buy and sell Tunisian olive oil wholesale",
    "hero.subtitle": "The marketplace connecting mills, cooperatives, producers and brokers with buyers and importers. Direct deals, transparent prices, traceable quality.",
    "hero.cta.primary": "Explore the market",
    "hero.cta.secondary": "Post a lot",
    "hero.stat.lots": "Lots for sale",
    "hero.stat.mills": "Listed mills",
    "hero.stat.regions": "Regions covered",
    "hero.stat.members": "Active members",

    "value.heading": "Why EvooTunisia",
    "value.subtitle": "A tool built for olive-oil professionals, from the mill to export.",
    "value.direct.title": "Direct matching",
    "value.direct.desc": "Negotiate without intermediaries between verified sellers and buyers.",
    "value.verified.title": "Verified players",
    "value.verified.desc": "Mills, cooperatives and brokers with profiles and certifications.",
    "value.transparency.title": "Transparent prices",
    "value.transparency.desc": "Track prices by region and quality, updated continuously.",
    "value.export.title": "Export-ready",
    "value.export.desc": "Traceability, acidity and compliance for international markets.",

    "lots.heading": "Recent lots for sale",
    "lots.subtitle": "A selection of offers posted by our sellers across Tunisia.",
    "lots.viewAll": "View the full market",
    "lots.quantity": "Quantity",
    "lots.acidity": "Acidity",
    "lots.view": "View lot",
    "lots.organic": "Organic",
    "lots.perUnit": "/ {unit}",
    "type.vrac": "Bulk",
    "type.conditionne": "Packaged",
    "quality.extra_vierge": "Extra virgin",
    "quality.vierge": "Virgin",
    "quality.lampante": "Lampante",
    "quality.bio": "Organic",

    "prices.heading": "Market prices",
    "prices.subtitle": "Indicative olive-oil prices by region and quality.",
    "prices.region": "Region",
    "prices.quality": "Quality",
    "prices.price": "Price",
    "prices.change": "Change",
    "prices.viewAll": "View all prices",
    "prices.updated": "Updated today",
    "market.hub.subtitle": "Origin quotations, retail prices, market thermometer and balance.",
    "market.tab.origin": "Origin prices",
    "market.tab.retail": "Packaged / retail prices",
    "market.tab.thermo": "Market thermometer",
    "market.tab.balance": "Market balance",
    "market.origin.title": "Bulk olive oil origin prices",
    "market.origin.desc": "Quotations by producing country and quality. Tunisia in TND/kg, international in EUR/kg.",
    "market.retail.title": "Packaged / retail prices",
    "market.retail.desc": "Tracking of private-label brands in supermarkets (Tunisia).",
    "market.thermo.title": "Market thermometer",
    "market.thermo.desc": "Synthetic trend from the latest price variations.",
    "market.balance.title": "Market balance (Tunisia)",
    "market.balance.desc": "Production, stocks, exports and consumption volumes.",
    "market.country": "Country",
    "market.source": "Source",
    "market.quality": "Quality",
    "market.retailer": "Retailer",
    "market.brand": "Brand",
    "market.format": "Format",
    "market.latest": "Latest price",
    "market.change": "Change",
    "market.evolution": "Evolution",
    "market.displayCurrency": "Display currency",
    "market.fxNote": "FX rate as of {date}",
    "market.updated": "Updated",
    "market.noData": "No data available.",
    "market.thermo.up": "Rising",
    "market.thermo.stable": "Stable",
    "market.thermo.down": "Falling",
    "market.thermo.basis": "Average change {pct}% over the last {weeks} weeks ({count} series)",
    "market.thermo.thresholds": "Thresholds: rising ≥ {up}% · falling ≤ {down}%",
    "market.thermo.comment": "Analyst comment",
    "market.season": "Season",
    "market.value": "Volume (t)",
    "metric.production": "Production",
    "metric.exports": "Exports",
    "metric.stocks": "Stocks",
    "metric.consumption": "Consumption",
    "metric.imports": "Imports",
    "country.tunisia": "Tunisia",
    "country.spain": "Spain",
    "country.italy": "Italy",
    "country.greece": "Greece",
    "country.portugal": "Portugal",
    "country.turkey": "Turkey",
    "country.morocco": "Morocco",
    "dash.menu.admin": "Administration",
    "dash.menu.adminMarket": "Market & Prices",
    "dash.menu.adminOverview": "Overview",
    "dash.menu.adminUsers": "Users & companies",
    "dash.menu.adminLots": "Lots moderation",
    "dash.menu.adminSettings": "Settings",
    "admin.overview.title": "Overview",
    "admin.overview.users": "Users",
    "admin.overview.usersVerified": "verified",
    "admin.overview.emailUnconfirmed": "email unconfirmed",
    "admin.overview.companies": "Verified companies",
    "admin.overview.pending": "pending",
    "admin.overview.lotsActive": "Active lots",
    "admin.overview.deals": "Closed deals",
    "admin.overview.volume": "Traded volume",
    "admin.overview.commissions": "commissions",
    "admin.overview.quotesOpen": "Open quotes",
    "admin.overview.byType": "Users by type",
    "admin.overview.monthly": "Monthly activity",
    "admin.overview.noData": "No data yet.",
    "admin.users.title": "Users & companies",
    "admin.users.tabKyc": "KYC verifications",
    "admin.users.tabAll": "All users",
    "admin.users.pendingKyc": "Pending verifications",
    "admin.users.noPending": "No pending verifications.",
    "admin.users.history": "History",
    "admin.users.review": "Review",
    "admin.users.approve": "Approve",
    "admin.users.reject": "Reject",
    "admin.users.rejectReason": "Rejection reason",
    "admin.users.docs": "KYC documents",
    "admin.users.viewDoc": "Open",
    "admin.users.noDocs": "No documents submitted.",
    "admin.users.decisionSaved": "Decision saved",
    "admin.users.search": "Search a user…",
    "admin.users.name": "Name",
    "admin.users.email": "Email",
    "admin.users.type": "Type",
    "admin.users.emailConfirmed": "Email confirmed",
    "admin.users.confirmed": "Confirmed",
    "admin.users.notConfirmed": "Not confirmed",
    "admin.users.confirmEmail": "Confirm",
    "admin.users.confirmDone": "Email confirmed",
    "admin.users.actions": "Actions",
    "admin.users.company": "Company",
    "admin.users.export": "Export",
    "admin.users.exportDone": "Exported {count} user(s)",
    "admin.users.contact": "Name (contact)",
    "admin.users.filters": "Filters",
    "admin.users.all": "All",
    "admin.users.filterKyc": "KYC verification",
    "admin.users.filterCountry": "Country",
    "admin.users.filterGov": "Governorate",
    "admin.users.kycVerified": "Verified",
    "admin.users.kycPending": "Pending",
    "admin.users.kycUnverified": "Unverified",
    "admin.users.kycRejected": "Rejected",
    "admin.users.showDeleted": "Show deleted accounts",
    "admin.users.resetFilters": "Reset filters",
    "admin.users.noResults": "No user matches the filters.",
    "admin.userdetail.back": "Back to list",
    "admin.userdetail.identity": "Identity",
    "admin.userdetail.company": "Company",
    "admin.userdetail.activity": "Activity",
    "admin.userdetail.kyc": "KYC documents",
    "admin.userdetail.notes": "Internal notes",
    "admin.userdetail.actions": "Admin actions",
    "admin.userdetail.role": "Role",
    "admin.userdetail.type": "Type",
    "admin.userdetail.status": "Status",
    "admin.userdetail.lang": "Language",
    "admin.userdetail.registered": "Registered on",
    "admin.userdetail.consent": "Consent",
    "admin.userdetail.emailConfirmed": "Email confirmed",
    "admin.userdetail.lots": "Published lots",
    "admin.userdetail.negotiations": "Negotiations",
    "admin.userdetail.deals": "Closed deals",
    "admin.userdetail.requests": "Purchase requests",
    "admin.userdetail.quotes": "Quotes",
    "admin.userdetail.noCompany": "No company linked.",
    "admin.userdetail.noKyc": "No KYC document submitted.",
    "admin.userdetail.noNotes": "No internal notes.",
    "admin.userdetail.verifStatus": "Verification",
    "admin.userdetail.suspend": "Suspend",
    "admin.userdetail.reactivate": "Reactivate",
    "admin.userdetail.suspendReason": "Suspension reason",
    "admin.userdetail.suspendConfirm": "Suspend account",
    "admin.userdetail.suspendedBadge": "Suspended",
    "admin.userdetail.activeBadge": "Active",
    "admin.userdetail.deletedBadge": "Deleted",
    "admin.userdetail.suspendedInfo": "Account suspended:",
    "admin.userdetail.confirmEmail": "Confirm email",
    "admin.userdetail.resendConfirm": "Resend link",
    "admin.userdetail.changeType": "Change user type",
    "admin.userdetail.saveType": "Save",
    "admin.userdetail.addNote": "Add note",
    "admin.userdetail.notePlaceholder": "Write an internal note…",
    "admin.userdetail.delete": "Delete account",
    "admin.userdetail.deleteTitle": "Delete this user",
    "admin.userdetail.softDelete": "Standard delete (anonymize)",
    "admin.userdetail.softDeleteDesc": "Anonymizes personal data and keeps transactional history (GDPR/INPDP compliance). Recommended.",
    "admin.userdetail.hardDelete": "Permanent delete",
    "admin.userdetail.hardDeleteDesc": "Fully erases the account. Only for accounts with no activity (spam / fake accounts).",
    "admin.userdetail.hardDeleteBlocked": "Not possible: this account has activity on the platform.",
    "admin.userdetail.deleteConfirm": "Confirm deletion",
    "admin.userdetail.deleted": "Account deleted",
    "admin.userdetail.suspended": "Account suspended",
    "admin.userdetail.reactivated": "Account reactivated",
    "admin.userdetail.typeChanged": "Type updated",
    "admin.userdetail.noteAdded": "Note added",
    "admin.userdetail.confirmed": "Email confirmed",
    "admin.userdetail.resent": "Confirmation link resent",
    "admin.userdetail.cancel": "Cancel",
    "admin.userdetail.yes": "Yes",
    "admin.userdetail.no": "No",
    "admin.userdetail.accountState": "Account state",
    "admin.userdetail.lastLogin": "Last login",
    "admin.userdetail.never": "Never",
    "admin.userdetail.invoices": "Invoices",
    "admin.userdetail.invoicesEmpty": "No invoices yet.",
    "admin.userdetail.invoicesSoon": "Billing will be available once invoice generation ships (Phase 10).",
    "statement.title": "Account statement",
    "statement.billed": "Total billed",
    "statement.paid": "Total paid",
    "statement.unpaid": "Outstanding balance",
    "statement.empty": "No invoices yet.",
    "invoice.number": "Invoice No.",
    "invoice.party": "Role",
    "invoice.buyer": "Buyer",
    "invoice.seller": "Seller",
    "invoice.base": "Net base",
    "invoice.rate": "Commission rate",
    "invoice.ht": "Net amount",
    "invoice.vat": "VAT",
    "invoice.ttc": "Total incl. tax",
    "invoice.date": "Issue date",
    "invoice.dueDate": "Due date",
    "invoice.status": "Status",
    "invoice.viewPdf": "View PDF",
    "invoice.proof": "Proof",
    "invoice.noProof": "No proof available.",
    "invoice.paymentRef": "Payment reference (transfer no.)",
    "invoice.status.issued": "Issued",
    "invoice.status.awaiting_payment": "Awaiting payment",
    "invoice.status.paid": "Paid",
    "invoice.status.cancelled": "Cancelled",
    "invoice.myTitle": "My invoices",
    "invoice.mySubtitle": "Commission invoices on your concluded operations.",
    "invoice.myEmpty": "No invoices yet.",
    "invoice.myEmptyHint": "Commission invoices are generated when a bulk operation is concluded. Packaged goods carry no commission.",
    "invoice.payTitle": "Payment by bank transfer",
    "invoice.payHint": "Transfer the total incl. tax, then upload your proof below. The administrator will validate receipt of payment.",
    "invoice.uploadProof": "Upload proof",
    "invoice.proofHint": "PDF, JPG or PNG — 10 MB max.",
    "invoice.proofSent": "Proof uploaded. Awaiting administrator validation.",
    "invoice.awaitingValidation": "Awaiting admin validation",
    "invoice.paidOn": "Paid on",
    "admin.billing.title": "Billing & bank details",
    "admin.billing.desc": "Issuer details and bank account shown on commission invoices.",
    "admin.billing.issuerLegal": "Issuer legal name",
    "admin.billing.taxId": "Tax ID",
    "admin.billing.address": "Address",
    "admin.billing.email": "Email",
    "admin.billing.phone": "Phone",
    "admin.billing.bankName": "Bank",
    "admin.billing.rib": "RIB",
    "admin.billing.iban": "IBAN",
    "admin.billing.swift": "SWIFT/BIC",
    "admin.billing.vatRate": "VAT rate (%)",
    "admin.billing.paymentTerms": "Payment terms (days)",
    "admin.billing.exportExempt": "VAT exemption on export",
    "admin.billing.exportNote": "Export VAT note",
    "invoice.bankName": "Bank",
    "invoice.rib": "RIB",
    "invoice.iban": "IBAN",
    "invoice.swift": "SWIFT/BIC",
    "admin.userdetail.viewListing": "View lot listing",
    "admin.userdetail.openThread": "Open full thread",
    "admin.userdetail.parties": "Parties",
    "admin.userdetail.lot": "Lot",
    "admin.userdetail.quantity": "Quantity",
    "admin.userdetail.unitPrice": "Unit price",
    "admin.userdetail.total": "Total amount",
    "admin.userdetail.thread": "Exchange history",
    "admin.userdetail.offer": "Offer",
    "admin.userdetail.counter": "Counter-offer",
    "admin.userdetail.message": "Message",
    "admin.userdetail.systemEvent": "Event",
    "admin.userdetail.quality": "Quality",
    "admin.userdetail.targetPrice": "Target price",
    "admin.userdetail.governorate": "Governorate",
    "admin.userdetail.packaging": "Packaging",
    "admin.userdetail.volume": "Volume",
    "admin.userdetail.units": "Units",
    "admin.userdetail.whiteLabel": "White label",
    "admin.userdetail.contact": "Contact",
    "admin.userdetail.desc": "Description",
    "admin.userdetail.concludedAt": "Concluded on",
    "admin.userdetail.export": "Export",
    "admin.userdetail.national": "Domestic",
    "admin.userdetail.rowClickHint": "Click for details",
    "admin.userdetail.detailNotFound": "Detail unavailable.",
    "common.reference": "Reference",
    "deals.operationRef": "Operation ref",
    "deals.lotRef": "Lot ref",
    "market.searchPlaceholder": "Title or reference…",
    "dash.menu.adminOps": "Operations",
    "admin.lots.openFiche": "Open lot fiche",
    "admin.users.openFiche": "Open fiche",
    "adminlot.back": "Back to lots",
    "adminlot.publicView": "Public view",
    "adminlot.specs": "Specifications",
    "adminlot.price": "Price",
    "adminlot.remaining": "Remaining quantity",
    "adminlot.sold": "Sold quantity",
    "adminlot.negotiations": "Negotiations & offers",
    "adminlot.noNegos": "No negotiation on this lot.",
    "adminlot.offers": "Offers",
    "adminlot.seller": "Seller",
    "admindeals.title": "Concluded operations",
    "admindeals.search": "Operation/lot ref or party…",
    "admindeals.none": "No concluded operation.",
    "admindeals.parties": "Parties (buyer ← seller)",
    "geo.subdiv.governorate": "Governorate",
    "geo.subdiv.muhafazah": "Governorate",
    "geo.subdiv.emirate": "Emirate",
    "geo.subdiv.municipality": "Municipality",
    "geo.subdiv.district": "District",
    "geo.subdiv.wilaya": "Province (Wilaya)",
    "geo.subdiv.canton": "Canton",
    "geo.subdiv.provinceTerr": "Province / Territory",
    "geo.subdiv.province": "Province",
    "geo.subdiv.state": "State",
    "geo.subdiv.region": "Region",
    "geo.subdiv.provincia": "Province",
    "geo.subdiv.distrito": "District",
    "geo.subdiv.land": "State / Region",
    "geo.subdiv.county": "County",
    "geo.subdiv.generic": "Region / State / Province",
    "geo.subdiv.select": "Select…",
    "geo.subdiv.freeholder": "Region / State / Province",
    "geo.search": "Search…",
    "geo.empty": "No results",
    "geo.city": "City",
    "geo.city.select": "Select a city",
    "geo.city.freeholder": "City",
    "geo.city.notListed": "My city isn't listed",
    "geo.city.backToList": "Back to list",
    "phone.invalid": "Invalid phone number",
    "login.forgot": "Forgot password?",
    "login.suspended": "Your account has been suspended. Contact the administrator for more information.",
    "pwreset.forgotTitle": "Forgot password",
    "pwreset.forgotSubtitle": "Enter your email address to receive a reset link.",
    "pwreset.email": "Email address",
    "pwreset.sendLink": "Send link",
    "pwreset.sentTitle": "Check your inbox",
    "pwreset.sentDesc": "If an account is associated with this address, you'll receive a link to reset your password. The link expires in 1 hour.",
    "pwreset.backToLogin": "Back to login",
    "pwreset.resetTitle": "New password",
    "pwreset.resetSubtitle": "Choose a new password for your account.",
    "pwreset.newPassword": "New password",
    "pwreset.confirmPassword": "Confirm password",
    "pwreset.minLength": "8 characters minimum",
    "pwreset.mismatch": "Passwords do not match.",
    "pwreset.save": "Reset password",
    "pwreset.successTitle": "Password reset",
    "pwreset.successDesc": "Your password has been updated. You can now log in.",
    "pwreset.goLogin": "Log in",
    "pwreset.invalidTitle": "Invalid or expired link",
    "pwreset.invalidDesc": "This reset link is no longer valid (expired, already used or incorrect). Request a new one.",
    "pwreset.requestNew": "Request a new link",
    "pwreset.spamHelp": "Can't find the email? Check your spam folder. Hotmail/Outlook emails may take a few minutes.",
    "admin.lots.title": "Lots moderation",
    "admin.lots.all": "All",
    "admin.lots.available": "Available",
    "admin.lots.sold": "Sold",
    "admin.lots.withdrawn": "Withdrawn",
    "admin.lots.search": "Search a lot…",
    "admin.lots.lot": "Lot",
    "admin.lots.seller": "Seller",
    "admin.lots.type": "Type",
    "admin.lots.qty": "Quantity",
    "admin.lots.statusCol": "Status",
    "admin.lots.actions": "Actions",
    "admin.lots.vrac": "Bulk",
    "admin.lots.conditionne": "Packaged",
    "admin.lots.withdraw": "Withdraw",
    "admin.lots.restore": "Restore",
    "admin.lots.statusChanged": "Status updated",
    "admin.lots.none": "No lots.",
    "admin.lots.confirmWithdraw": "Withdraw this lot from the market?",
    "admin.settings.title": "Settings",
    "admin.settings.commission": "Commission schedule",
    "admin.settings.commissionDesc": "Rates applied to each closed deal (in %).",
    "admin.settings.vracNational": "Bulk national",
    "admin.settings.vracExport": "Bulk export",
    "admin.settings.conditionne": "Packaged",
    "admin.settings.buyer": "Buyer",
    "admin.settings.seller": "Seller",
    "admin.settings.pctNote": "Percent values (e.g. 0.2 = 0.2%).",
    "admin.settings.save": "Save",
    "admin.settings.saved": "Saved",
    "admin.settings.platform": "Platform",
    "admin.settings.logo": "Platform logo (PDF)",
    "admin.settings.logoDesc": "Logo shown on quote PDFs and documents.",
    "admin.settings.logoUpload": "Upload",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "contact.title": "Contact us",
    "contact.subtitle": "Have a question? Write to us and we'll reply quickly.",
    "contact.intro": "Fill in the form below and our team will get back to you as soon as possible.",
    "contact.name": "Full name",
    "contact.email": "Email",
    "contact.company": "Company",
    "contact.phone": "Phone",
    "contact.subject": "Subject",
    "contact.subjectPlaceholder": "Choose a subject",
    "contact.message": "Message",
    "contact.cat.general": "General question",
    "contact.cat.sell": "Sell olive oil",
    "contact.cat.buy": "Buy olive oil",
    "contact.cat.partnership": "Partnership",
    "contact.cat.press": "Press",
    "contact.cat.other": "Other",
    "contact.consentPre": "I agree that my information will be processed in accordance with the ",
    "contact.privacyLink": "privacy policy",
    "contact.submit": "Send message",
    "contact.sending": "Sending…",
    "contact.success": "Message sent",
    "contact.successDesc": "Thank you for contacting us. We will reply as soon as possible.",
    "admin.contact.title": "Contact messages",
    "admin.contact.subjectCol": "Subject",
    "admin.contact.detail": "Message detail",
    "dash.menu.adminContact": "Contact messages",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Everything you need to know to buy and sell bulk olive oil on EvooTunisia.",
    "faq.empty": "No questions yet.",
    "faq.moreHelp": "Can't find your answer? Create an account and contact us from your dashboard.",
    "faq.cta": "Create a free account",
    "faq.admin.title": "FAQ management",
    "faq.admin.new": "New question",
    "faq.admin.empty": "No questions. Add the first one.",
    "faq.admin.back": "Back to list",
    "faq.admin.question": "Question",
    "faq.admin.answer": "Answer",
    "faq.admin.category": "Category",
    "faq.admin.order": "Order",
    "faq.admin.published": "Published",
    "faq.admin.save": "Save",
    "faq.admin.saved": "Question saved",
    "faq.admin.confirmDelete": "Delete this question?",
    "faq.admin.deleted": "Question deleted",
    "faq.admin.needQuestion": "The French question is required.",
    "faq.admin.statusPublished": "Published",
    "faq.admin.statusDraft": "Hidden",
    "dash.menu.adminFaq": "FAQ",
    "admin.market.title": "Market & Prices management",
    "admin.market.tabOrigin": "Origin prices",
    "admin.market.tabRetail": "Retail prices",
    "admin.market.tabBalance": "Balance",
    "admin.market.tabSettings": "Settings",
    "admin.market.addPoint": "Add point",
    "admin.market.addSeries": "Add series",
    "admin.market.date": "Date",
    "admin.market.price": "Price",
    "admin.market.period": "Season",
    "admin.market.value": "Value (t)",
    "admin.market.delete": "Delete",
    "admin.market.save": "Save",
    "admin.market.saved": "Saved",
    "admin.market.confirmDelete": "Delete this series?",
    "admin.market.fx": "FX rates (TND base)",
    "admin.market.tndPerEur": "TND per 1 EUR",
    "admin.market.tndPerUsd": "TND per 1 USD",
    "admin.market.thresholds": "Thermometer",
    "admin.market.thermoUp": "Rising threshold (%)",
    "admin.market.thermoDown": "Falling threshold (%)",
    "admin.market.thermoWeeks": "Weeks analysed",
    "admin.market.comment": "Thermometer comment",
    "admin.market.newSeriesTitle": "New series",
    "admin.market.currency": "Currency",
    "admin.market.source": "Source",
    "source.auto_eu": "auto (EU)",
    "source.auto_world": "auto (world)",
    "source.manual": "manual (admin)",
    "market.lastUpdate": "Last update",
    "market.attribution": "Source: European Commission (Agri-food Data Portal) & FRED.",
    "market.worldIndex": "World reference price (FRED)",
    "market.worldIndexDesc": "Monthly global olive oil price index.",
    "admin.market.tabFeeds": "Automatic feeds",
    "admin.market.feedStatus": "Automatic feeds status",
    "admin.market.syncNow": "Sync now",
    "admin.market.syncing": "Syncing…",
    "admin.market.syncDone": "Sync completed",
    "admin.market.lastSuccess": "Last success",
    "admin.market.lastError": "Last error",
    "admin.market.feedEu": "European Commission (origin prices)",
    "admin.market.feedWorld": "FRED (world index)",
    "admin.market.feedNote": "Tunisian and private-label prices remain manual.",

    "how.heading": "How it works",
    "how.subtitle": "Three simple steps to close your deals.",
    "how.step1.title": "Publish",
    "how.step1.desc": "Sellers: create your bulk or packaged lot with quantity, quality and price.",
    "how.step2.title": "Negotiate",
    "how.step2.desc": "Receive offers, chat with buyers and adjust your terms.",
    "how.step3.title": "Close",
    "how.step3.desc": "Confirm the deal, arrange logistics and export with confidence.",

    "cta.heading": "Ready to grow your olive-oil business?",
    "cta.subtitle": "Join the community of olive-oil professionals in Tunisia.",
    "cta.button": "Create a free account",

    "footer.about": "EvooTunisia is the B2B marketplace dedicated to wholesale buying and selling of Tunisian olive oil, from bulk to packaged, for local markets and export.",
    "footer.marketplace": "Marketplace",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.about.link": "About",
    "footer.contact": "Contact",
    "footer.cgu": "Terms of Service",
    "footer.privacy": "Privacy Policy",
    "footer.cookies": "Cookie settings",
    "footer.rights": "All rights reserved.",
    "footer.newsletter": "Stay informed about prices and new lots.",
    "footer.newsletter.placeholder": "Your business email",
    "footer.newsletter.button": "Subscribe",

    "currency.label": "Currency",
    "common.comingSoon": "Coming soon",
    "common.comingSoon.desc": "This section is part of the foundation and will be activated in a future step.",
    "common.backHome": "Back to home",

    "login.title": "Log in",
    "login.subtitle": "Access your professional workspace.",
    "login.email": "Email",
    "login.password": "Password",
    "login.button": "Log in",
    "login.noAccount": "No account yet?",
    "login.demo": "Demo interface — authentication is not active.",

    "register.title": "Create an account",
    "register.subtitle": "Join the marketplace in a few minutes.",
    "register.company": "Company name",
    "register.role": "You are",
    "register.role.buyer": "Buyer",
    "register.role.seller": "Seller",
    "register.role.broker": "Broker",
    "usertype.label": "User type",
    "usertype.placeholder": "— Choose one —",
    "usertype.producer": "Producer / Oil mill",
    "usertype.packer": "Buyer / Packer",
    "usertype.distributor": "Distributor",
    "usertype.broker": "Broker",
    "usertype.other": "Other",
    "usertype.hint": "You can change it anytime from “My company”.",
    "usertype.sellNote": "This type can publish lots (after account verification).",
    "usertype.buyOnlyNote": "This type can buy and negotiate.",
    "usertype.current": "User type",
    "usertype.required": "Please choose a user type",
    "register.country": "Country",
    "taxid.matricule_fiscal": "Tax ID (Matricule Fiscal)",
    "taxid.cif_nif": "CIF / NIF",
    "taxid.siren_siret": "SIREN / SIRET",
    "taxid.partita_iva": "Partita IVA",
    "taxid.nif_nipc": "NIF / NIPC",
    "taxid.afm": "AFM",
    "taxid.ice": "ICE / Tax ID",
    "taxid.generic": "Tax identification / trade register number",
    "taxid.vat": "Intra-EU VAT number",
    "taxid.vatOptional": "(optional)",
    "taxid.format": "Format",
    "taxid.invalid": "Invalid identifier format for this country",
    "taxid.err.matricule_fiscal": "Invalid Matricule Fiscal. Expected format: 7 digits + key letter, optional establishment suffixes (e.g. 1234567A/P/M/000).",
    "taxid.err.cif_nif": "Invalid CIF/NIF. Expected format: 8 to 10 alphanumeric characters (e.g. B12345678).",
    "taxid.err.siren_siret": "Invalid SIREN / SIRET. Expected format: 9 digits (SIREN) or 14 digits (SIRET) (e.g. 123456789).",
    "taxid.err.partita_iva": "Invalid Partita IVA. Expected format: 11 digits (e.g. 12345678901).",
    "taxid.err.nif_nipc": "Invalid NIF / NIPC. Expected format: 9 digits (e.g. 123456789).",
    "taxid.err.afm": "Invalid AFM. Expected format: 9 digits (e.g. 123456789).",
    "taxid.err.ice": "Invalid ICE. Expected format: 7 to 15 digits (e.g. 001234567000012).",
    "taxid.err.generic": "Invalid company identifier. Enter at least 4 alphanumeric characters.",
    "consent.before": "I accept the ",
    "consent.terms": "terms of service",
    "consent.mid": " and the ",
    "consent.privacy": "data protection policy",
    "consent.required": "You must accept the terms to continue",
    "kyc.doc.companyDocDyn": "Official company document ({id})",
    "company.usertype.saved": "User type updated",
    "register.button": "Create my account",
    "register.hasAccount": "Already registered?",

    "page.market.title": "The market",
    "page.prices.title": "Prices & market analysis",
    "page.directory.title": "Mills directory",
    "page.tools.title": "Tools",
    "tools.hub.subtitle": "Practical tools to buy, sell and export Tunisian olive oil.",
    "tools.open": "Open",
    "tools.backTools": "Back to tools",
    "tools.calc.title": "Cost calculator",
    "tools.calc.desc": "Estimate your landed cost and price (Incoterm, logistics, TND/EUR/USD).",
    "tools.calc.basic": "Basic",
    "tools.calc.advanced": "Advanced",
    "tools.calc.inputCurrency": "Input currency",
    "tools.calc.pricePerKg": "Price per kg",
    "tools.calc.quantity": "Quantity",
    "tools.calc.incoterm": "Incoterm",
    "tools.calc.transport": "Transport",
    "tools.calc.insurance": "Insurance",
    "tools.calc.customs": "Customs / export",
    "tools.calc.handling": "Handling",
    "tools.calc.financing": "Financing costs",
    "tools.calc.otherCosts": "Other costs",
    "tools.calc.marginPct": "Margin",
    "tools.calc.density": "Density (kg/L)",
    "tools.calc.results": "Results",
    "tools.calc.goodsValue": "Goods value",
    "tools.calc.totalLogistics": "Total logistics",
    "tools.calc.totalCost": "Total cost",
    "tools.calc.costPerKg": "Cost per kg",
    "tools.calc.costPerL": "Cost per L",
    "tools.calc.sellingPrice": "Suggested selling price / kg",
    "tools.calc.conversion": "Conversion",
    "tools.calc.densityNote": "kg → L conversion uses a default density of 0.916 kg/L (editable in advanced mode).",
    "tools.calc.incotermNote": "Enter the logistics costs you bear according to the chosen Incoterm.",
    "tools.alerts.title": "Market alerts",
    "tools.alerts.desc": "Get notified by email of new lots and price movements.",
    "tools.alerts.doubleOptin": "Double opt-in: after subscribing, click the link sent to your email to activate your alert.",
    "tools.alerts.newLots": "New lots alert",
    "tools.alerts.newLotsDesc": "Get an email as soon as a lot matches your criteria.",
    "tools.alerts.priceMove": "Price movement alert",
    "tools.alerts.priceMoveDesc": "Get an email when prices move beyond your threshold.",
    "tools.alerts.email": "Business email",
    "tools.alerts.market": "Market",
    "tools.alerts.quality": "Quality",
    "tools.alerts.packaging": "Packaging",
    "tools.alerts.governorate": "Governorate / origin",
    "tools.alerts.minQty": "Minimum quantity",
    "tools.alerts.maxPrice": "Max price (TND)",
    "tools.alerts.threshold": "Change threshold (%)",
    "tools.alerts.thresholdNote": "You will be notified when the market change exceeds this threshold.",
    "tools.alerts.subscribe": "Subscribe",
    "tools.alerts.checkEmail": "Check your inbox to confirm your subscription.",
    "tools.alerts.confirmedMsg": "Your alert is confirmed and active.",
    "tools.alerts.invalidMsg": "Invalid or expired confirmation link.",
    "tools.alerts.unsubMsg": "You have unsubscribed from this alert.",
    "tools.packaging.title": "Brik / contract packaging",
    "tools.packaging.desc": "Request a packaging quote (Brik, glass, PET) or private label.",
    "tools.packaging.intro": "Describe your packaging needs: a mill or partner packer will get back to you with a quote.",
    "tools.packaging.company": "Company",
    "tools.packaging.contact": "Contact",
    "tools.packaging.email": "Email",
    "tools.packaging.phone": "Phone",
    "tools.packaging.type": "Packaging type",
    "tools.packaging.volume": "Volume",
    "tools.packaging.quantity": "Quantity (units)",
    "tools.packaging.whiteLabel": "Private label",
    "tools.packaging.message": "Message",
    "tools.packaging.submit": "Request a quote",
    "tools.packaging.success": "Request sent",
    "tools.packaging.successDesc": "Your quote request has been recorded. We will get back to you shortly.",
    "tools.inspection.title": "Inspection & analysis",
    "tools.inspection.desc": "Certify and analyze your lots with recognized laboratories.",
    "tools.inspection.intro": "Find laboratories and inspection bodies for physico-chemical and sensory analysis of your olive oil lots, and request an introduction.",
    "tools.inspection.tunisia": "Laboratories in Tunisia",
    "tools.inspection.international": "International references",
    "tools.inspection.coiYes": "IOC approved",
    "tools.inspection.coiToVerify": "Approval to verify",
    "tools.inspection.coiNote": "Approvals to be verified against the official IOC list.",
    "tools.inspection.coiLink": "Official IOC laboratories list",
    "tools.inspection.website": "Website",
    "tools.inspection.requestLink": "Request an introduction",
    "tools.inspection.disclaimer": "These bodies are industry references and are not partners of EvooTunisia.",
    "tools.inspection.formTitle": "Introduction request",
    "tools.inspection.formDesc": "Tell us your analysis needs; we point you to the right lab.",
    "tools.inspection.lab": "Preferred laboratory",
    "tools.inspection.noPreference": "No preference",
    "tools.inspection.lotRef": "Lot reference",
    "tools.inspection.analyses": "Requested analyses",
    "tools.inspection.analysesPlaceholder": "Acidity, peroxides, K270, panel test…",
    "tools.inspection.submit": "Send request",
    "tools.inspection.success": "Request sent",
    "tools.inspection.successDesc": "Your introduction request has been recorded. We will get back to you shortly.",
    "dash.menu.adminTools": "Tools & requests",
    "admin.tools.title": "Tools & requests",
    "admin.tools.tabAlerts": "Alerts",
    "admin.tools.tabQuotes": "Packaging quotes",
    "admin.tools.tabLeads": "Inspection requests",
    "admin.tools.tabLabs": "Laboratories",
    "admin.tools.noData": "No data yet.",
    "admin.tools.rowHint": "Click for details",
    "admin.tools.alertDetail": "Subscription detail",
    "admin.tools.quoteDetail": "Quote request detail",
    "admin.tools.leadDetail": "Inspection request detail",
    "admin.tools.frequency": "Frequency",
    "admin.tools.freqInstant": "Instant",
    "admin.tools.freqWeekly": "Weekly",
    "admin.tools.createdAt": "Created on",
    "admin.tools.confirmedAt": "Confirmed on",
    "admin.tools.sendHistory": "Send history",
    "admin.tools.lastSent": "Last sent",
    "admin.tools.lastDigest": "Last digest",
    "admin.tools.never": "Never",
    "admin.tools.confirmManually": "Confirm manually",
    "admin.tools.resendConfirmation": "Resend confirmation",
    "admin.tools.unsubscribe": "Delete / unsubscribe",
    "admin.tools.confirmDeleteAlert": "Permanently delete this subscription?",
    "admin.tools.alertConfirmed": "Subscription confirmed",
    "admin.tools.confirmationResent": "Confirmation email resent",
    "admin.tools.alertDeleted": "Subscription deleted",
    "admin.tools.phone": "Phone",
    "admin.tools.message": "Message",
    "admin.tools.thread": "Discussion thread",
    "admin.tools.noThread": "No exchange yet.",
    "admin.tools.requestedLab": "Requested lab",
    "admin.tools.requestedAnalyses": "Requested analyses",
    "admin.tools.concernedLot": "Concerned lot",
    "admin.tools.note": "Internal note",
    "admin.tools.notePlaceholder": "Internal note (admin only)…",
    "admin.tools.saveNote": "Save note",
    "admin.tools.contactByEmail": "Contact by email",
    "admin.tools.callContact": "Call",
    "admin.tools.criteria": "Criteria",
    "admin.tools.status": "Status",
    "admin.tools.date": "Date",
    "admin.tools.confirmed": "Confirmed",
    "admin.tools.pending": "Pending",
    "admin.tools.newLab": "New laboratory",
    "admin.tools.labName": "Laboratory name",
    "admin.tools.messages": "Messages",
    "request.status.new": "New",
    "request.status.in_progress": "In progress",
    "request.status.closed": "Closed",
    "quotes.title": "Quote requests",
    "quotes.empty": "No quote requests yet.",
    "quotes.backList": "Back to list",
    "quotes.noMessages": "No messages yet. Send a first reply.",
    "quotes.replyPlaceholder": "Write your reply…",
    "quotes.replied": "Reply sent.",
    "quotes.sent": "Message sent.",
    "quotes.threadTitle": "Track your quote request",
    "quotes.threadSubtitle": "Chat with the mills responding to your request.",
    "quotes.notFound": "Request not found or link expired.",
    "quotes.waitingReplies": "Waiting for mills to reply…",
    "quote.emit": "Issue a quote",
    "quote.newQuote": "New structured quote",
    "quote.currency": "Currency",
    "quote.vatMode": "VAT mode",
    "quote.vatGlobal": "Global VAT",
    "quote.vatPerLine": "Per-line VAT",
    "quote.vatRate": "VAT rate (%)",
    "quote.lines": "Quote lines",
    "quote.lineDesc": "Description",
    "quote.lineQty": "Qty",
    "quote.lineUnit": "Unit",
    "quote.lineUnitPrice": "Unit price (excl.)",
    "quote.lineVat": "VAT %",
    "quote.lineTotal": "Total (excl.)",
    "quote.addLine": "Add a line",
    "quote.delivery": "Delivery / lead time",
    "quote.deliveryPh": "e.g. within 3 weeks, free Sfax",
    "quote.incoterm": "Incoterm",
    "quote.validity": "Validity (days)",
    "quote.notes": "Notes / terms",
    "quote.attachments": "Attachments",
    "quote.addAttachment": "Attach a file",
    "quote.attachmentHint": "PDF, JPG, PNG, WEBP · max 15 MB",
    "quote.subtotal": "Subtotal (excl.)",
    "quote.vat": "VAT",
    "quote.total": "Total (incl.)",
    "quote.send": "Send quote",
    "quote.sent": "Quote sent.",
    "quote.cancel": "Cancel",
    "quote.confirm": "Confirm",
    "quote.byMill": "Quote from",
    "quote.issuedDate": "issued",
    "quote.validityLabel": "Validity",
    "quote.days": "days",
    "quote.downloadPdf": "Download PDF",
    "quote.accept": "Accept",
    "quote.refuse": "Decline",
    "quote.revise": "Request revision",
    "quote.reviseComment": "Specify the requested changes…",
    "quote.refuseComment": "Reason (optional)…",
    "quote.confirmAccept": "Accept this quote? A confirmation PDF will be generated.",
    "quote.actionDone": "Response recorded.",
    "quote.needLine": "Add at least one valid line.",
    "quote.acceptedLock": "A quote has been accepted. Other quotes are closed.",
    "quote.status.sent": "Pending",
    "quote.status.accepted": "Accepted",
    "quote.status.refused": "Declined",
    "quote.status.revision_requested": "Revision requested",
    "quote.sys.accepted": "accepted the quote",
    "quote.sys.refused": "declined the quote",
    "quote.sys.revision_requested": "requested a revision of the quote",
    "quote.commentLabel": "Comment",
    "quote.compare.title": "Quote comparison",
    "quote.compare.provider": "Provider",
    "quote.compare.delay": "Lead time",
    "quote.compare.status": "Status",
    "quote.compare.open": "Open",
    "quote.compare.sortTotal": "Total",
    "quote.compare.sortDelay": "Lead time",
    "quote.compare.multiCurrency": "Different currencies — compare with each quote's currency in mind.",
    "tools.alerts.frequency": "Frequency",
    "tools.alerts.freq.instant": "Instant",
    "tools.alerts.freq.weekly": "Weekly digest",
    "tools.alerts.freq.instantNote": "One email for each matching new lot.",
    "tools.alerts.freq.weeklyNote": "A single grouped email each week.",
    "tools.calc.incotermCompare": "Incoterm comparator",
    "tools.calc.incotermCompareDesc": "Estimated landed cost by Incoterm, based on the costs you entered.",
    "tools.calc.incotermCompareNote": "Indicative estimate: included costs vary by the actual trade agreement.",
    "tools.calc.selected": "selected",
    "confirm.loading": "Confirming…",
    "confirm.ok.title": "Your alert is confirmed ✅",
    "confirm.ok.desc": "All set! You'll now receive our email notifications based on your criteria.",
    "confirm.already.title": "Alert already confirmed",
    "confirm.already.desc": "This alert was already active. Nothing more to do.",
    "confirm.invalid.title": "Invalid link",
    "confirm.invalid.desc": "This confirmation link is not valid. You can re-subscribe below.",
    "confirm.expired.title": "Link expired",
    "confirm.expired.desc": "This confirmation link has expired. Please re-subscribe to receive your alerts.",
    "confirm.error.title": "Something went wrong",
    "confirm.error.desc": "We couldn't confirm your alert right now. Try again later or re-subscribe.",
    "confirm.resubscribe": "Re-subscribe",
    "confirm.browseMarket": "Browse the market",
    "tools.alerts.alreadySubscribed": "This address is already subscribed to alerts.",
    "tools.alerts.managePrefs": "Manage my alert preferences",
    "tools.alerts.manageLinkSent": "A secure link has been emailed to you.",
    "tools.alerts.alreadyPending": "A confirmation email has already been sent to you.",
    "tools.alerts.resendConfirm": "Resend confirmation email",
    "tools.alerts.resent": "Confirmation email resent.",
    "manage.title": "Manage my alerts",
    "manage.subtitle": "Edit your criteria, frequency, or unsubscribe.",
    "manage.forEmail": "You are managing alerts for:",
    "manage.none": "No alerts for this address.",
    "manage.save": "Save",
    "manage.saved": "Preferences saved.",
    "manage.unsubscribe": "Unsubscribe",
    "manage.unsubscribed": "You have unsubscribed from this alert.",
    "manage.confirmUnsub": "Unsubscribing will permanently delete this alert and your associated email. Continue?",
    "manage.consumed": "Your preferences were saved. This single-use link is now used. For further changes, request a new link.",
    "manage.requestNew": "Get a new link",
    "manage.active": "Active",
    "manage.paused": "Paused",
    "manage.invalid.title": "Invalid link",
    "manage.invalid.desc": "This management link is not valid. Request a new one from the alerts signup page.",
    "manage.expired.title": "Link expired",
    "manage.expired.desc": "This management link has expired. Request a new one from the alerts signup page.",
    "page.blog.title": "Blog & News",

    "directory.capacity": "Capacity",
    "directory.subtitle": "The directory of verified mills, in Tunisia and for export.",
    "directory.search": "Search a mill, a city...",
    "directory.tunisia": "Tunisia",
    "directory.export": "Export (other countries)",
    "directory.allRegions": "All",
    "directory.allVarieties": "All varieties",
    "directory.filterVariety": "Variety",
    "directory.organicOnly": "Organic only",
    "directory.viewProfile": "View profile",
    "directory.viewLots": "View its lots",
    "directory.lotsAvailable": "{n} lot(s) on sale",
    "directory.exportTo": "Exports to",
    "directory.allCountries": "All countries",
    "directory.selectGovernorate": "Governorate",
    "directory.exportOpen": "Open to export",
    "directory.exportMarkets": "Export markets",
    "dirprofile.exportOpen": "Open to export",
    "dirprofile.exportMarkets": "Export markets",
    "dirprofile.exportMarketsHelp": "Add the countries you export to.",
    "dirprofile.addMarket": "Add a country...",
    "directory.noResults": "No mill matches your search.",
    "directory.varieties": "Olive varieties",
    "directory.certifications": "Certifications",
    "directory.contact": "Contact",
    "directory.country": "Country",
    "directory.about": "About",
    "directory.back": "Back to directory",
    "directory.verified": "Verified",
    "directory.results": "{n} mill(s)",
    "dash.menu.directoryProfile": "My directory profile",
    "dirprofile.title": "My directory profile",
    "dirprofile.intro": "Enrich your public showcase in the mills directory.",
    "dirprofile.visible": "Visible in the directory",
    "dirprofile.visibleHelp": "Disable to hide your profile from the public.",
    "dirprofile.description": "Description",
    "dirprofile.varieties": "Olive varieties",
    "dirprofile.varietiesHelp": "Separate with commas (Chetoui, Chemlali...).",
    "dirprofile.capacity": "Capacity (tons/year)",
    "dirprofile.certifications": "Certifications",
    "dirprofile.certHelp": "Separate with commas (Organic EU, PGI...).",
    "dirprofile.organic": "Organic certified",
    "dirprofile.city": "City",
    "dirprofile.country": "Country",
    "dirprofile.contactEmail": "Contact email",
    "dirprofile.photos": "Photos",
    "dirprofile.addPhoto": "Add a photo",
    "dirprofile.save": "Save my profile",
    "dirprofile.saved": "Profile updated",
    "dirprofile.locked": "Your company must be verified as a seller to appear in the directory.",
    "directory.system": "System",
    "directory.certifications": "Certifications",
    "blog.readMore": "Read article",
    "blog.subtitle": "Market analysis, olive growing, quality and export — the B2B media hub for Tunisia's olive oil industry.",
    "blog.type.all": "All",
    "blog.type.article": "Articles",
    "blog.type.market": "Market update",
    "blog.cat.all": "All categories",
    "blog.cat.marche": "Market & prices",
    "blog.cat.oleiculture": "Olive growing",
    "blog.cat.qualite": "Quality",
    "blog.cat.export": "Export",
    "blog.cat.recettes": "Recipes & uses",
    "blog.cat.reglementation": "Regulation",
    "blog.empty": "No articles yet. Check back soon!",
    "blog.linkCopied": "Link copied to clipboard",
    "blog.notFound": "Article not found.",
    "blog.backToBlog": "Back to blog",
    "blog.share": "Share",
    "blog.aiPublicNotice": "This article was drafted with AI assistance and reviewed by our editorial team.",
    "blog.related": "Related reading",
    "blog.admin.title": "Blog & content",
    "blog.admin.new": "New article",
    "blog.admin.empty": "No articles. Create your first piece.",
    "blog.admin.confirmDelete": "Permanently delete this article?",
    "blog.admin.deleted": "Article deleted",
    "blog.admin.needContent": "Add at least a title or content in one language.",
    "blog.admin.saved": "Article saved",
    "blog.admin.status.draft": "Draft",
    "blog.admin.status.published": "Published",
    "blog.admin.backList": "Back to list",
    "blog.admin.langContent": "Content",
    "blog.admin.fTitle": "Title",
    "blog.admin.fSlug": "Slug (URL)",
    "blog.admin.fExcerpt": "Excerpt",
    "blog.admin.fContent": "Content (Markdown)",
    "blog.admin.contentPlaceholder": "Write your article in Markdown…",
    "blog.admin.seo": "SEO",
    "blog.admin.metaTitle": "Meta title",
    "blog.admin.metaDesc": "Meta description",
    "blog.admin.settings": "Settings",
    "blog.admin.category": "Category",
    "blog.admin.type": "Content type",
    "blog.admin.author": "Author",
    "blog.admin.cover": "Cover image",
    "blog.admin.coverUpload": "Upload image",
    "blog.admin.coverUploading": "Uploading…",
    "blog.admin.coverOr": "or paste an image URL",
    "blog.admin.coverRemove": "Remove",
    "blog.admin.coverHint": "JPG, PNG or WEBP — max 15 MB. Use real photos (olive trees, mills).",
    "blog.admin.currentStatus": "Current status",
    "blog.admin.saveDraft": "Save draft",
    "blog.admin.publish": "Publish",
    "blog.admin.write": "Write",
    "blog.admin.preview": "Preview",
    "blog.ai.title": "Article generator (AI)",
    "blog.ai.subject": "Article subject",
    "blog.ai.langs": "Languages to generate",
    "blog.ai.tone": "Tone",
    "blog.ai.length": "Length",
    "blog.ai.len.court": "Short",
    "blog.ai.len.moyen": "Medium",
    "blog.ai.len.long": "Long",
    "blog.ai.type": "Content type",
    "blog.ai.keywords": "SEO keywords (optional)",
    "blog.ai.sourceData": "Source data (optional)",
    "blog.ai.sourcePlaceholder": "Paste figures/facts to use as-is (the AI won't make anything up).",
    "blog.ai.warning": "AI can be wrong. Review and fact-check before publishing.",
    "blog.ai.generate": "Generate draft",
    "blog.ai.translateBtn": "Translate to other languages",
    "blog.ai.needSubject": "Enter a subject.",
    "blog.ai.done": "Draft generated",
    "blog.ai.failed": "Generation failed. Try again.",
    "blog.ai.needSource": "Write the content in the source language first.",
    "blog.ai.translated": "Translations generated",
    "dash.menu.adminBlog": "Blog",

    "nav.dashboard": "Dashboard",
    "auth.logout": "Log out",
    "auth.error": "Something went wrong. Please try again.",
    "badge.verified": "Verified",
    "common.loading": "Loading…",
    "common.optional": "(optional)",
    "common.save": "Save",
    "common.cancel": "Cancel",

    "register.name": "Representative name",
    "register.matricule": "Tax ID (matricule fiscal)",
    "register.address": "Address",
    "register.governorate": "Governorate",
    "register.phone": "Phone",
    "register.website": "Website",
    "register.section.account": "Your credentials",
    "register.section.company": "Your company",
    "register.free": "Registration is 100% free — no payment required.",

    "dash.welcome": "Welcome, {name}",
    "dash.subtitle": "Manage your activity on EvooTunisia.",
    "dash.menu.overview": "Overview",
    "dash.menu.lots": "My lots",
    "dash.menu.offers": "My offers",
    "dash.menu.messages": "Messages",
    "dash.menu.company": "My company",
    "dash.menu.verification": "Verification",
    "dash.menu.settings": "Settings",
    "dash.verify.cta": "Verify my account",
    "dash.verify.banner": "Your account is not verified yet. Verify it to earn the badge and prioritize your lots.",
    "dash.card.status": "Account status",
    "dash.card.role": "Account type",
    "dash.card.company": "Company",

    "company.title": "My company",
    "company.subtitle": "Details of your linked company.",
    "company.saved": "Company updated.",
    "company.matriculeLocked": "The tax ID cannot be changed.",

    "kyc.title": "Account verification",
    "kyc.subtitle": "Upload your documents to earn the “Verified” badge.",
    "kyc.status.unverified": "Not verified",
    "kyc.status.pending": "Pending",
    "kyc.status.verified": "Verified",
    "kyc.status.rejected": "Rejected",
    "kyc.doc.company_doc": "Official company document (business license / tax ID)",
    "kyc.doc.link_proof": "Proof of link with the company",
    "kyc.doc.id_document": "Representative's ID document",
    "kyc.doc.bank_rib": "Bank details / bank certificate",
    "kyc.upload": "Upload",
    "kyc.replace": "Replace",
    "kyc.uploaded": "Uploaded",
    "kyc.view": "View",
    "kyc.submit": "Submit for verification",
    "kyc.submitted": "Documents submitted. Verification pending.",
    "kyc.secure": "Your documents are encrypted and never made public.",
    "kyc.sellerNote": "As a seller, bank details / a bank certificate are required.",
    "kyc.pendingNote": "Your documents are being reviewed by our team.",
    "kyc.verifiedNote": "Congratulations! Your account is verified.",
    "kyc.rejectedNote": "Your verification was rejected. Please re-submit valid documents.",

    "settings.title": "Settings",
    "settings.email": "Email",
    "settings.role": "Account type",
    "settings.notifications": "Notifications",
    "settings.notifyQuotes": "Receive new quote requests by email",
    "settings.notifyQuotesSaved": "Preference saved",
    "settings.emailPrefs": "Email preferences",
    "settings.emailPrefsDesc": "Choose which emails you want to receive. The notification bell always stays on.",
    "settings.prefsSaved": "Preferences saved",
    "settings.pref.negotiations": "Offers & negotiations",
    "settings.pref.quotes": "Packaging quotes",
    "settings.pref.verification": "Verification decision (KYC)",
    "settings.pref.alerts": "Market alerts",
    "settings.pref.transactionalNote": "Security and transactional emails (email confirmation, password reset) are always sent.",
    "dash.menu.deals": "Deal history",
    "deals.title": "Deal history",
    "deals.empty": "No concluded deals yet.",
    "deals.revenue": "Revenue",
    "deals.spend": "Total purchases",
    "deals.totalCommission": "Total commissions",
    "deals.count": "deals",
    "deals.date": "Date",
    "deals.role": "Role",
    "deals.product": "Product",
    "deals.counterparty": "Counterparty",
    "deals.quantity": "Quantity",
    "deals.total": "Amount",
    "deals.commission": "Commission",
    "deals.seller": "Sale",
    "deals.buyer": "Purchase",
    "settings.soon": "More settings are coming soon.",

    "auth.google": "Continue with Google",
    "auth.or": "or",
    "auth.connecting": "Signing you in…",
    "profile.title": "Complete your profile",
    "profile.subtitle": "One last step: add your company to access the marketplace.",
    "profile.submit": "Finish",
    "profile.welcome": "Welcome {name}! Choose your account type and company.",

    "quality.premium_bio": "Premium / Organic",
    "quality.grignon": "Pomace",
    "incoterm.label": "Incoterm",
    "common.close": "Close",
    "common.all": "All",

    "vrac.publish": "Post a lot",
    "vrac.filters": "Filters",
    "vrac.filter.quality": "Quality",
    "vrac.filter.qty": "Quantity (kg)",
    "vrac.filter.acidityMax": "Max acidity (º)",
    "vrac.filter.governorate": "Governorate",
    "vrac.filter.price": "Price (TND/kg)",
    "vrac.filter.incoterm": "Incoterm",
    "vrac.filter.min": "Min",
    "vrac.filter.max": "Max",
    "vrac.filter.reset": "Reset",
    "vrac.sort": "Sort",
    "vrac.sort.recent": "Most recent",
    "vrac.sort.price_asc": "Price ascending",
    "vrac.sort.price_desc": "Price descending",
    "vrac.sort.qty_desc": "Quantity",
    "vrac.empty": "No lot matches your search.",
    "vrac.results": "{n} lot(s)",

    "lot.acidity": "Acidity",
    "lot.peroxides": "Peroxide value",
    "lot.k270": "K270",
    "lot.polyphenols": "Polyphenols",
    "lot.panel": "Panel test",
    "lot.incoterm": "Incoterm",
    "lot.origin": "Origin",
    "lot.availability": "Availability",
    "lot.description": "Description",
    "lot.documents": "Analyses & documents",
    "lot.characteristics": "Characteristics",
    "lot.seller": "Seller",
    "lot.makeOffer": "Make an offer",
    "lot.contact": "Contact",
    "lot.notFound": "Lot not found",
    "lot.perKg": "/ kg",
    "lot.back": "Back to market",
    "offer.subtitle": "Start a private negotiation with the seller.",

    "offer.title": "Make an offer",
    "offer.price": "Offered price",
    "offer.quantity": "Quantity",
    "offer.message": "Message",
    "offer.send": "Send offer",
    "offer.sent": "Offer sent!",

    "lotform.new": "New bulk lot",
    "lotform.edit": "Edit lot",
    "lotform.title": "Lot title",
    "lotform.variety": "Variety",
    "lotform.acidity": "Acidity (º)",
    "lotform.peroxides": "Peroxide value",
    "lotform.k270": "K270",
    "lotform.polyphenols": "Polyphenols",
    "lotform.panel": "Panel test",
    "lotform.governorate": "Origin governorate",
    "lotform.country": "Origin country",
    "lotform.availability": "Availability",
    "lotform.photos": "Photos",
    "lotform.docs": "Analyses (PDF)",
    "lotform.addFiles": "Add files",
    "lotform.uploading": "Uploading…",
    "lotform.created": "Lot published!",
    "lotform.updated": "Lot updated",

    "mylots.new": "Post a lot",
    "mylots.empty": "You haven't posted any lot yet.",
    "mylots.notVerifiedTitle": "Account not verified",
    "mylots.notVerified": "Only verified sellers can post lots.",
    "mylots.markSold": "Mark as sold",
    "mylots.reactivate": "Reactivate",
    "mylots.withdraw": "Withdraw",
    "mylots.edit": "Edit",
    "status.available": "Available",
    "status.sold": "Sold",
    "status.withdrawn": "Withdrawn",

    "myoffers.empty": "No offers yet.",
    "myoffers.sent": "Sent",
    "myoffers.received": "Received",

    "req.publish": "Post a request",
    "req.new": "New purchase request",
    "req.quality": "Quality sought",
    "req.quantity": "Quantity (kg)",
    "req.targetPrice": "Target price (TND/kg)",
    "req.origin": "Preferred origin",
    "req.description": "Details",
    "req.submit": "Post request",
    "req.created": "Request posted!",
    "req.empty": "No purchase requests yet.",
    "req.looking": "looking for",
    "req.buyerNote": "Post what you're looking for to receive offers.",

    "cond.market": "Packaged market",
    "cond.publish": "Post a packaged lot",
    "cond.units": "units",
    "cond.format": "Format",
    "cond.minOrder": "Minimum order",
    "cond.brand": "Brand",
    "cond.whiteLabel": "White label",
    "cond.whiteLabelBadge": "White label",
    "cond.perUnit": "/ unit",
    "cond.filter.packaging": "Packaging type",
    "cond.filter.price": "Price (TND/unit)",
    "cond.filter.volume": "Format (volume)",
    "packaging.verre": "Glass",
    "packaging.pet": "PET",
    "packaging.bidon_metal": "Metal can",
    "packaging.brik": "Brik",
    "packaging.canette": "Can",
    "packaging.monodose": "Single-dose",
    "packaging.dosettes": "Pods / pearls",
    "lotform.market": "Market type",
    "lotform.packaging": "Packaging type",
    "lotform.volume": "Volume per unit (ml)",
    "lotform.units": "Number of units",
    "lotform.minOrder": "Minimum order (units)",
    "lotform.brand": "Brand / label",
    "lotform.whiteLabel": "White label available",
    "lotform.pricePerUnit": "Price per unit (TND)",
    "alert.title": "New packaged-lot alerts",
    "alert.cta": "Get alerts",
    "alert.subtitle": "Get notified by email based on your criteria.",
    "alert.email": "Your email",
    "alert.quality": "Quality (optional)",
    "alert.packaging": "Packaging (optional)",
    "alert.governorate": "Origin (optional)",
    "alert.maxPrice": "Max price per unit (optional)",
    "alert.submit": "Enable alerts",
    "alert.created": "Almost done! Check your email to confirm your alert.",
    "alert.note": "Email delivery will be enabled soon.",

    "nego.center": "Messages & negotiations",
    "nego.empty": "No conversations yet.",
    "nego.selectConv": "Select a conversation",
    "nego.you": "You",
    "nego.buyer": "Buyer",
    "nego.seller": "Seller",
    "nego.counter": "Counter-offer",
    "nego.accept": "Accept",
    "nego.refuse": "Decline",
    "nego.send": "Send",
    "nego.message": "Message",
    "nego.messagePlaceholder": "Write a message…",
    "nego.price": "Price",
    "nego.quantity": "Quantity",
    "nego.makeCounter": "Make a counter-offer",
    "nego.status.pending": "Pending",
    "nego.status.countered": "Countered",
    "nego.status.accepted": "Accepted",
    "nego.status.refused": "Declined",
    "nego.status.expired": "Expired",
    "nego.awaiting": "Awaiting your response",
    "nego.concluded": "Deal concluded",
    "nego.closedUnavailable": "Lot unavailable",
    "nego.downloadQuote": "Download quote confirmation (PDF)",
    "nego.lotUnavailableMsg": "This lot is no longer available.",
    "nego.summary": "Summary",
    "nego.finalQty": "Quantity",
    "nego.finalPrice": "Unit price",
    "nego.total": "Total amount",
    "nego.commBuyer": "Buyer commission",
    "nego.commSeller": "Seller commission",
    "nego.export": "Export deal (international)",
    "nego.transportNote": "The platform does not handle transport. Logistics are arranged by the parties per the agreed Incoterm.",
    "nego.offerLine": "Offer: {qty} × {price}",
    "nego.tabActive": "Active negotiations",
    "nego.tabConcluded": "Concluded / Archived",
    "nego.emptyActive": "No active negotiations.",
    "nego.emptyConcluded": "No concluded deals.",
    "nego.lotLabel": "Lot",
    "nego.offerStatus": "Offer status",
    "admin.commission.title": "Commission schedule",
    "admin.commission.vracNatB": "Bulk domestic — buyer (%)",
    "admin.commission.vracNatS": "Bulk domestic — seller (%)",
    "admin.commission.vracExpB": "Bulk export — buyer (%)",
    "admin.commission.vracExpS": "Bulk export — seller (%)",
    "admin.commission.condB": "Packaged — buyer (%)",
    "admin.commission.condS": "Packaged — seller (%)",
    "admin.commission.saved": "Schedule saved.",
    "emailconf.checkTitle": "Check your email",
    "emailconf.checkDesc": "We've sent a confirmation link to {email}. Click it to activate your account, then sign in.",
    "emailconf.spamHelp": "Didn't get the email? Please check your spam / junk folder, then click \"Resend confirmation email\".",
    "emailconf.resend": "Resend confirmation email",
    "emailconf.resent": "Confirmation email resent.",
    "emailconf.loginBlockedTitle": "Confirm your email address",
    "emailconf.loginBlockedDesc": "Your email address isn't confirmed yet. Click the link we emailed you to access your account.",
    "emailconf.confirming": "Confirming…",
    "emailconf.confirmedTitle": "Email confirmed",
    "emailconf.confirmedDesc": "Your email address is confirmed. You can now sign in.",
    "emailconf.invalidTitle": "Invalid link",
    "emailconf.invalidDesc": "This confirmation link is invalid. Enter your email to receive a new link.",
    "emailconf.expiredTitle": "Link expired",
    "emailconf.expiredDesc": "This confirmation link has expired. Enter your email to receive a new link.",
    "emailconf.goLogin": "Go to sign in",
    "emailconf.emailPlaceholder": "Your email address",
    "emailconf.notKyc": "Email confirmation is separate from your company's document (KYC) verification.",
    "emailconf.backToLogin": "Back to sign in",
    "notif.title": "Notifications",
    "notif.empty": "No notifications.",
    "notif.markAll": "Mark all as read",
    "myquotes.title": "My quote requests",
    "myquotes.subtitle": "Track the requests you sent and the quotes you received.",
    "myquotes.empty": "You haven't sent any quote request yet.",
    "myquotes.new": "New request",
    "myquotes.responsesCount": "{n} quote(s) received",
    "verifygate.title": "Verification required",
    "verifygate.desc": "Your account must be verified (KYC) to conclude an operation. You can keep browsing, requesting quotes and negotiating, but concluding requires a verified account.",
    "verifygate.counterparty": "The other party isn't verified yet. Concluding will be possible once both accounts are verified.",
    "verifygate.cta": "Complete verification",
    "verifygate.later": "Later",
    "packaging.loggedInNote": "Request sent as {company}. It will appear under \"My quote requests\".",
    "packaging.viewMyQuotes": "View my quote requests",
    "cookie.title": "We respect your privacy",
    "cookie.message": "We use cookies that are essential for the site to work and, with your consent, analytics and marketing cookies. You can accept, reject or customize your choices.",
    "cookie.policy": "Cookie policy",
    "cookie.accept": "Accept all",
    "cookie.reject": "Reject all",
    "cookie.manage": "Customize",
    "cookie.save": "Save my choices",
    "cookie.essential": "Essential cookies",
    "cookie.essentialDesc": "Required for the site to work (always on).",
    "cookie.analytics": "Analytics",
    "cookie.analyticsDesc": "Help us understand how the site is used.",
    "cookie.marketing": "Marketing",
    "cookie.marketingDesc": "Personalization of content and ads.",
    "admin.treasury.title": "Commission treasury",
    "admin.treasury.subtitle": "Billed vs collected per month. Manual settlement by bank transfer (the \"Paid\" status is validated by an admin).",
    "admin.treasury.runReminders": "Send reminders",
    "admin.treasury.remindersSent": "{n} payment reminder(s) sent",
    "admin.treasury.remindersError": "Failed to send reminders",
    "admin.treasury.billed": "Billed",
    "admin.treasury.collected": "Collected",
    "admin.treasury.outstanding": "Outstanding",
    "admin.treasury.overdue": "Overdue",
    "admin.treasury.invoices": "invoices",
    "admin.treasury.paid": "paid",
    "admin.treasury.awaiting": "in review",
    "admin.treasury.issued": "issued",
    "admin.treasury.month": "Month",
    "admin.treasury.noData": "No invoices yet.",
    "pricedigest.badge": "Free · Weekly",
    "pricedigest.title": "Get market prices every week",
    "pricedigest.desc": "One email per week with olive oil prices at origin in Tunisia and the market trend. Unsubscribe in one click.",
    "pricedigest.subscribe": "Subscribe",
    "pricedigest.consent": "I agree to receive this weekly email and to the",
    "pricedigest.privacy": "data protection policy",
    "pricedigest.consentRequired": "Please accept to continue.",
    "pricedigest.optinNote": "Double opt-in: you'll receive an email to confirm your subscription.",
    "dash.menu.adminInvoices": "Invoices",
    "admin.invoices.title": "Invoices (all)",
    "admin.invoices.allStatuses": "All statuses",
    "admin.invoices.period": "Period (month)",
    "admin.invoices.search": "Search",
    "admin.invoices.searchPlaceholder": "Invoice no., operation, company…",
    "admin.invoices.count": "Invoices",
    "admin.invoices.empty": "No invoices match these filters.",
    "admin.invoices.export": "Export",
    "admin.invoices.exportCsv": "CSV (.csv)",
    "admin.invoices.exportExcel": "Excel (.xlsx)",
    "admin.invoices.exportError": "Export failed.",
    "admin.digest.title": "Weekly price digest",
    "admin.digest.subtitle": "Preview and test the email sent automatically every Monday to confirmed subscribers.",
    "admin.digest.subscribers": "confirmed subscribers",
    "admin.digest.preview": "Preview",
    "admin.digest.previewTitle": "Price digest preview",
    "admin.digest.testEmail": "Test email",
    "admin.digest.sendTest": "Send a test",
    "admin.digest.testSent": "Test email sent to {email}",
    "admin.digest.testError": "Failed to send the test.",
    "admin.digest.emailRequired": "Please enter an email.",
    "admin.digest.unavailable": "No price data available to generate the digest.",
  },

  es: {
    "brand.tagline": "Marketplace B2B de aceite de oliva tunecino",
    "nav.home": "Inicio",
    "nav.market": "Mercado",
    "nav.market.bulk": "A granel",
    "nav.market.packaged": "Envasado",
    "nav.market.requests": "Solicitudes",
    "nav.prices": "Precios",
    "nav.directory": "Directorio de almazaras",
    "nav.tools": "Herramientas",
    "nav.blog": "Blog",
    "nav.login": "Iniciar sesión",
    "nav.register": "Registrarse",
    "nav.menu": "Menú",
    "nav.language": "Idioma",
    "nav.currency": "Moneda",
    "seo.home.title": "Marketplace B2B de aceite de oliva al por mayor en Túnez",
    "seo.home.desc": "EvooTunisia conecta a productores, almazaras y compradores de aceite de oliva a granel. Negocia granel y envasado, sigue los precios del mercado y encuentra almazaras verificadas.",
    "seo.market.vrac.title": "Aceite de oliva a granel — Mercado mayorista",
    "seo.market.vrac.desc": "Compra y vende aceite de oliva a granel (virgen extra, virgen, lampante). Lotes verificados y filtros por calidad, acidez, precio y región.",
    "seo.market.conditionne.title": "Aceite de oliva envasado — Venta al por mayor",
    "seo.market.conditionne.desc": "Encuentra aceite de oliva envasado al por mayor: botellas, bidones y envases personalizados de proveedores tunecinos verificados.",
    "seo.market.demandes.title": "Solicitudes de compra de aceite de oliva",
    "seo.market.demandes.desc": "Consulta las solicitudes de compra de aceite de oliva publicadas por compradores y responde con tus ofertas al por mayor.",
    "seo.prices.title": "Precios del aceite de oliva en Túnez — Cotizaciones y tendencias",
    "seo.prices.desc": "Sigue los precios del aceite de oliva al por mayor en Túnez: cotizaciones actuales, históricas y tendencias del mercado por calidad.",
    "seo.directory.title": "Directorio de almazaras tunecinas",
    "seo.directory.desc": "Descubre las almazaras de aceite de oliva en Túnez: contacto, certificaciones, variedades y capacidades de producción.",
    "seo.tools.title": "Herramientas para profesionales del aceite de oliva",
    "seo.tools.desc": "Calculadora de coste, alertas de mercado, presupuestos de envasado y laboratorios de inspección para profesionales del aceite de oliva.",
    "seo.tools.calculator.title": "Calculadora de coste",
    "seo.tools.calculator.desc": "Estima tu coste y margen sobre el aceite de oliva a granel, incluyendo transporte, envasado y comisión.",
    "seo.tools.alerts.title": "Alertas de mercado — aceite de oliva",
    "seo.tools.alerts.desc": "Recibe una alerta por correo en cuanto un lote de aceite de oliva coincida con tus criterios de precio, calidad y volumen.",
    "seo.tools.packaging.title": "Presupuestos de envasado — aceite de oliva",
    "seo.tools.packaging.desc": "Solicita presupuestos de envasado (botellas, bidones, etiquetas) a envasadores tunecinos verificados.",
    "seo.tools.inspection.title": "Laboratorios de inspección y análisis",
    "seo.tools.inspection.desc": "Encuentra laboratorios para inspeccionar y analizar la calidad del aceite de oliva antes del envío.",
    "seo.blog.title": "Blog y noticias del aceite de oliva",
    "seo.blog.desc": "Análisis de mercado, guías y noticias sobre el aceite de oliva tunecino, multilingüe y actualizado regularmente.",
    "seo.faq.title": "Preguntas frecuentes",
    "seo.faq.desc": "Respuestas a preguntas frecuentes sobre la compra y venta de aceite de oliva al por mayor en EvooTunisia.",

    "hero.badge": "Origen Túnez · Granel y Envasado · Exportación",
    "hero.title": "Compra y vende aceite de oliva tunecino al por mayor",
    "hero.subtitle": "El marketplace que conecta almazaras, cooperativas, productores y corredores con compradores e importadores. Transacciones directas, precios transparentes, calidad trazable.",
    "hero.cta.primary": "Explorar el mercado",
    "hero.cta.secondary": "Publicar un lote",
    "hero.stat.lots": "Lotes en venta",
    "hero.stat.mills": "Almazaras registradas",
    "hero.stat.regions": "Regiones cubiertas",
    "hero.stat.members": "Miembros activos",

    "value.heading": "Por qué EvooTunisia",
    "value.subtitle": "Una herramienta pensada para los profesionales del sector oleícola, del molino a la exportación.",
    "value.direct.title": "Contacto directo",
    "value.direct.desc": "Negocia sin intermediarios entre vendedores y compradores verificados.",
    "value.verified.title": "Actores verificados",
    "value.verified.desc": "Almazaras, cooperativas y corredores con perfiles y certificaciones.",
    "value.transparency.title": "Precios transparentes",
    "value.transparency.desc": "Sigue las cotizaciones por región y calidad, actualizadas continuamente.",
    "value.export.title": "Orientado a la exportación",
    "value.export.desc": "Trazabilidad, acidez y conformidad para los mercados internacionales.",

    "lots.heading": "Lotes recientes en venta",
    "lots.subtitle": "Una selección de ofertas publicadas por nuestros vendedores en toda Túnez.",
    "lots.viewAll": "Ver todo el mercado",
    "lots.quantity": "Cantidad",
    "lots.acidity": "Acidez",
    "lots.view": "Ver lote",
    "lots.organic": "Ecológico",
    "lots.perUnit": "/ {unit}",
    "type.vrac": "A granel",
    "type.conditionne": "Envasado",
    "quality.extra_vierge": "Virgen extra",
    "quality.vierge": "Virgen",
    "quality.lampante": "Lampante",
    "quality.bio": "Ecológico",

    "prices.heading": "Precios de mercado",
    "prices.subtitle": "Precios indicativos del aceite de oliva por región y calidad.",
    "prices.region": "Región",
    "prices.quality": "Calidad",
    "prices.price": "Precio",
    "prices.change": "Variación",
    "prices.viewAll": "Ver todos los precios",
    "prices.updated": "Actualizado hoy",
    "market.hub.subtitle": "Cotizaciones a origen, precios en supermercado, termómetro y balance de mercado.",
    "market.tab.origin": "Precios a origen",
    "market.tab.retail": "Precios envasado / GD",
    "market.tab.thermo": "Termómetro del mercado",
    "market.tab.balance": "Balance de mercado",
    "market.origin.title": "Precios del granel a origen",
    "market.origin.desc": "Cotizaciones por país productor y calidad. Túnez en TND/kg, internacional en EUR/kg.",
    "market.retail.title": "Precios envasado / gran distribución",
    "market.retail.desc": "Seguimiento de marcas de distribuidor en supermercados (Túnez).",
    "market.thermo.title": "Termómetro del mercado",
    "market.thermo.desc": "Tendencia sintética a partir de las últimas variaciones.",
    "market.balance.title": "Balance de mercado (Túnez)",
    "market.balance.desc": "Volúmenes de producción, existencias, exportaciones y consumo.",
    "market.country": "País",
    "market.quality": "Calidad",
    "market.source": "Fuente",
    "market.retailer": "Enseña",
    "market.brand": "Marca",
    "market.format": "Formato",
    "market.latest": "Último precio",
    "market.change": "Variación",
    "market.evolution": "Evolución",
    "market.displayCurrency": "Moneda de visualización",
    "market.fxNote": "Tipo de cambio del {date}",
    "market.updated": "Actualizado",
    "market.noData": "Sin datos disponibles.",
    "market.thermo.up": "Alza",
    "market.thermo.stable": "Estable",
    "market.thermo.down": "Baja",
    "market.thermo.basis": "Variación media {pct}% sobre las últimas {weeks} semanas ({count} series)",
    "market.thermo.thresholds": "Umbrales: alza ≥ {up}% · baja ≤ {down}%",
    "market.thermo.comment": "Comentario del analista",
    "market.season": "Campaña",
    "market.value": "Volumen (t)",
    "metric.production": "Producción",
    "metric.exports": "Exportaciones",
    "metric.stocks": "Existencias",
    "metric.consumption": "Consumo",
    "metric.imports": "Importaciones",
    "country.tunisia": "Túnez",
    "country.spain": "España",
    "country.italy": "Italia",
    "country.greece": "Grecia",
    "country.portugal": "Portugal",
    "country.turkey": "Turquía",
    "country.morocco": "Marruecos",
    "dash.menu.admin": "Administración",
    "dash.menu.adminMarket": "Mercado y Precios",
    "dash.menu.adminOverview": "Resumen",
    "dash.menu.adminUsers": "Usuarios y empresas",
    "dash.menu.adminLots": "Moderación de lotes",
    "dash.menu.adminSettings": "Ajustes",
    "admin.overview.title": "Resumen",
    "admin.overview.users": "Usuarios",
    "admin.overview.usersVerified": "verificados",
    "admin.overview.emailUnconfirmed": "email sin confirmar",
    "admin.overview.companies": "Empresas verificadas",
    "admin.overview.pending": "pendientes",
    "admin.overview.lotsActive": "Lotes activos",
    "admin.overview.deals": "Operaciones cerradas",
    "admin.overview.volume": "Volumen negociado",
    "admin.overview.commissions": "comisiones",
    "admin.overview.quotesOpen": "Presupuestos en curso",
    "admin.overview.byType": "Usuarios por tipo",
    "admin.overview.monthly": "Actividad mensual",
    "admin.overview.noData": "Aún no hay datos.",
    "admin.users.title": "Usuarios y empresas",
    "admin.users.tabKyc": "Verificaciones KYC",
    "admin.users.tabAll": "Todos los usuarios",
    "admin.users.pendingKyc": "Verificaciones pendientes",
    "admin.users.noPending": "No hay verificaciones pendientes.",
    "admin.users.history": "Historial",
    "admin.users.review": "Revisar",
    "admin.users.approve": "Aprobar",
    "admin.users.reject": "Rechazar",
    "admin.users.rejectReason": "Motivo del rechazo",
    "admin.users.docs": "Documentos KYC",
    "admin.users.viewDoc": "Abrir",
    "admin.users.noDocs": "No se han enviado documentos.",
    "admin.users.decisionSaved": "Decisión guardada",
    "admin.users.search": "Buscar un usuario…",
    "admin.users.name": "Nombre",
    "admin.users.email": "Correo",
    "admin.users.type": "Tipo",
    "admin.users.emailConfirmed": "Correo confirmado",
    "admin.users.confirmed": "Confirmado",
    "admin.users.notConfirmed": "Sin confirmar",
    "admin.users.confirmEmail": "Confirmar",
    "admin.users.confirmDone": "Correo confirmado",
    "admin.users.actions": "Acciones",
    "admin.users.company": "Empresa",
    "admin.users.export": "Exportar",
    "admin.users.exportDone": "Exportados {count} usuario(s)",
    "admin.users.contact": "Nombre (contacto)",
    "admin.users.filters": "Filtros",
    "admin.users.all": "Todos",
    "admin.users.filterKyc": "Verificación KYC",
    "admin.users.filterCountry": "País",
    "admin.users.filterGov": "Gobernación",
    "admin.users.kycVerified": "Verificado",
    "admin.users.kycPending": "Pendiente",
    "admin.users.kycUnverified": "No verificado",
    "admin.users.kycRejected": "Rechazado",
    "admin.users.showDeleted": "Mostrar cuentas eliminadas",
    "admin.users.resetFilters": "Restablecer filtros",
    "admin.users.noResults": "Ningún usuario coincide con los filtros.",
    "admin.userdetail.back": "Volver a la lista",
    "admin.userdetail.identity": "Identidad",
    "admin.userdetail.company": "Empresa",
    "admin.userdetail.activity": "Actividad",
    "admin.userdetail.kyc": "Documentos KYC",
    "admin.userdetail.notes": "Notas internas",
    "admin.userdetail.actions": "Acciones administrativas",
    "admin.userdetail.role": "Rol",
    "admin.userdetail.type": "Tipo",
    "admin.userdetail.status": "Estado",
    "admin.userdetail.lang": "Idioma",
    "admin.userdetail.registered": "Registrado el",
    "admin.userdetail.consent": "Consentimiento",
    "admin.userdetail.emailConfirmed": "Correo confirmado",
    "admin.userdetail.lots": "Lotes publicados",
    "admin.userdetail.negotiations": "Negociaciones",
    "admin.userdetail.deals": "Acuerdos cerrados",
    "admin.userdetail.requests": "Solicitudes de compra",
    "admin.userdetail.quotes": "Presupuestos",
    "admin.userdetail.noCompany": "Ninguna empresa vinculada.",
    "admin.userdetail.noKyc": "No se ha enviado ningún documento KYC.",
    "admin.userdetail.noNotes": "Sin notas internas.",
    "admin.userdetail.verifStatus": "Verificación",
    "admin.userdetail.suspend": "Suspender",
    "admin.userdetail.reactivate": "Reactivar",
    "admin.userdetail.suspendReason": "Motivo de la suspensión",
    "admin.userdetail.suspendConfirm": "Suspender la cuenta",
    "admin.userdetail.suspendedBadge": "Suspendida",
    "admin.userdetail.activeBadge": "Activa",
    "admin.userdetail.deletedBadge": "Eliminada",
    "admin.userdetail.suspendedInfo": "Cuenta suspendida:",
    "admin.userdetail.confirmEmail": "Confirmar correo",
    "admin.userdetail.resendConfirm": "Reenviar enlace",
    "admin.userdetail.changeType": "Cambiar tipo de usuario",
    "admin.userdetail.saveType": "Guardar",
    "admin.userdetail.addNote": "Añadir nota",
    "admin.userdetail.notePlaceholder": "Escribe una nota interna…",
    "admin.userdetail.delete": "Eliminar la cuenta",
    "admin.userdetail.deleteTitle": "Eliminar este usuario",
    "admin.userdetail.softDelete": "Eliminación estándar (anonimizar)",
    "admin.userdetail.softDeleteDesc": "Anonimiza los datos personales y conserva el historial transaccional (cumplimiento INPDP/RGPD). Recomendado.",
    "admin.userdetail.hardDelete": "Eliminación permanente",
    "admin.userdetail.hardDeleteDesc": "Borra por completo la cuenta. Solo para cuentas sin actividad (spam / cuentas falsas).",
    "admin.userdetail.hardDeleteBlocked": "No es posible: esta cuenta tiene actividad en la plataforma.",
    "admin.userdetail.deleteConfirm": "Confirmar eliminación",
    "admin.userdetail.deleted": "Cuenta eliminada",
    "admin.userdetail.suspended": "Cuenta suspendida",
    "admin.userdetail.reactivated": "Cuenta reactivada",
    "admin.userdetail.typeChanged": "Tipo actualizado",
    "admin.userdetail.noteAdded": "Nota añadida",
    "admin.userdetail.confirmed": "Correo confirmado",
    "admin.userdetail.resent": "Enlace de confirmación reenviado",
    "admin.userdetail.cancel": "Cancelar",
    "admin.userdetail.yes": "Sí",
    "admin.userdetail.no": "No",
    "admin.userdetail.accountState": "Estado de la cuenta",
    "admin.userdetail.lastLogin": "Última conexión",
    "admin.userdetail.never": "Nunca",
    "admin.userdetail.invoices": "Facturas",
    "admin.userdetail.invoicesEmpty": "Aún no hay facturas.",
    "admin.userdetail.invoicesSoon": "La facturación estará disponible con la generación de facturas (Fase 10).",
    "statement.title": "Estado de cuenta",
    "statement.billed": "Total facturado",
    "statement.paid": "Total pagado",
    "statement.unpaid": "Saldo pendiente",
    "statement.empty": "Aún no hay facturas.",
    "invoice.number": "N.º de factura",
    "invoice.party": "Rol",
    "invoice.buyer": "Comprador",
    "invoice.seller": "Vendedor",
    "invoice.base": "Base neta",
    "invoice.rate": "Tasa de comisión",
    "invoice.ht": "Importe neto",
    "invoice.vat": "IVA",
    "invoice.ttc": "Total con IVA",
    "invoice.date": "Fecha de emisión",
    "invoice.dueDate": "Vencimiento",
    "invoice.status": "Estado",
    "invoice.viewPdf": "Ver PDF",
    "invoice.proof": "Justificante",
    "invoice.noProof": "No hay justificante disponible.",
    "invoice.paymentRef": "Referencia de pago (n.º de transferencia)",
    "invoice.status.issued": "Emitida",
    "invoice.status.awaiting_payment": "Pendiente de pago",
    "invoice.status.paid": "Pagada",
    "invoice.status.cancelled": "Anulada",
    "invoice.myTitle": "Mis facturas",
    "invoice.mySubtitle": "Facturas de comisión sobre sus operaciones concluidas.",
    "invoice.myEmpty": "Aún no hay facturas.",
    "invoice.myEmptyHint": "Las facturas de comisión se generan al concluir una operación a granel. El envasado no tiene comisión.",
    "invoice.payTitle": "Pago por transferencia bancaria",
    "invoice.payHint": "Transfiera el total con IVA y luego suba su justificante abajo. El administrador validará la recepción del pago.",
    "invoice.uploadProof": "Subir justificante",
    "invoice.proofHint": "PDF, JPG o PNG — 10 MB máx.",
    "invoice.proofSent": "Justificante subido. Pendiente de validación del administrador.",
    "invoice.awaitingValidation": "Pendiente de validación del administrador",
    "invoice.paidOn": "Pagada el",
    "admin.billing.title": "Facturación y datos bancarios",
    "admin.billing.desc": "Datos del emisor y cuenta bancaria mostrados en las facturas de comisión.",
    "admin.billing.issuerLegal": "Razón social del emisor",
    "admin.billing.taxId": "NIF",
    "admin.billing.address": "Dirección",
    "admin.billing.email": "Correo electrónico",
    "admin.billing.phone": "Teléfono",
    "admin.billing.bankName": "Banco",
    "admin.billing.rib": "RIB",
    "admin.billing.iban": "IBAN",
    "admin.billing.swift": "SWIFT/BIC",
    "admin.billing.vatRate": "Tasa de IVA (%)",
    "admin.billing.paymentTerms": "Plazo de pago (días)",
    "admin.billing.exportExempt": "Exención de IVA en exportación",
    "admin.billing.exportNote": "Nota de IVA de exportación",
    "invoice.bankName": "Banco",
    "invoice.rib": "RIB",
    "invoice.iban": "IBAN",
    "invoice.swift": "SWIFT/BIC",
    "admin.userdetail.viewListing": "Ver la ficha del lote",
    "admin.userdetail.openThread": "Abrir el hilo completo",
    "admin.userdetail.parties": "Partes",
    "admin.userdetail.lot": "Lote",
    "admin.userdetail.quantity": "Cantidad",
    "admin.userdetail.unitPrice": "Precio unitario",
    "admin.userdetail.total": "Importe total",
    "admin.userdetail.thread": "Historial de intercambios",
    "admin.userdetail.offer": "Oferta",
    "admin.userdetail.counter": "Contraoferta",
    "admin.userdetail.message": "Mensaje",
    "admin.userdetail.systemEvent": "Evento",
    "admin.userdetail.quality": "Calidad",
    "admin.userdetail.targetPrice": "Precio objetivo",
    "admin.userdetail.governorate": "Gobernación",
    "admin.userdetail.packaging": "Envasado",
    "admin.userdetail.volume": "Volumen",
    "admin.userdetail.units": "Unidades",
    "admin.userdetail.whiteLabel": "Marca blanca",
    "admin.userdetail.contact": "Contacto",
    "admin.userdetail.desc": "Descripción",
    "admin.userdetail.concludedAt": "Concluido el",
    "admin.userdetail.export": "Exportación",
    "admin.userdetail.national": "Nacional",
    "admin.userdetail.rowClickHint": "Haga clic para ver el detalle",
    "admin.userdetail.detailNotFound": "Detalle no disponible.",
    "common.reference": "Referencia",
    "deals.operationRef": "Ref. operación",
    "deals.lotRef": "Ref. lote",
    "market.searchPlaceholder": "Título o referencia…",
    "dash.menu.adminOps": "Operaciones",
    "admin.lots.openFiche": "Abrir ficha del lote",
    "admin.users.openFiche": "Abrir ficha",
    "adminlot.back": "Volver a los lotes",
    "adminlot.publicView": "Vista pública",
    "adminlot.specs": "Características",
    "adminlot.price": "Precio",
    "adminlot.remaining": "Cantidad restante",
    "adminlot.sold": "Cantidad vendida",
    "adminlot.negotiations": "Negociaciones y ofertas",
    "adminlot.noNegos": "Sin negociación en este lote.",
    "adminlot.offers": "Ofertas",
    "adminlot.seller": "Vendedor",
    "admindeals.title": "Operaciones concluidas",
    "admindeals.search": "Ref. operación/lote o parte…",
    "admindeals.none": "Sin operaciones concluidas.",
    "admindeals.parties": "Partes (comprador ← vendedor)",
    "geo.subdiv.governorate": "Gobernación",
    "geo.subdiv.muhafazah": "Gobernación",
    "geo.subdiv.emirate": "Emirato",
    "geo.subdiv.municipality": "Municipio",
    "geo.subdiv.district": "Distrito",
    "geo.subdiv.wilaya": "Provincia (Wilaya)",
    "geo.subdiv.canton": "Cantón",
    "geo.subdiv.provinceTerr": "Provincia / Territorio",
    "geo.subdiv.province": "Provincia",
    "geo.subdiv.state": "Estado",
    "geo.subdiv.region": "Región",
    "geo.subdiv.provincia": "Provincia",
    "geo.subdiv.distrito": "Distrito",
    "geo.subdiv.land": "Estado / Región",
    "geo.subdiv.county": "Condado",
    "geo.subdiv.generic": "Región / Estado / Provincia",
    "geo.subdiv.select": "Seleccionar…",
    "geo.subdiv.freeholder": "Región / Estado / Provincia",
    "geo.search": "Buscar…",
    "geo.empty": "Sin resultados",
    "geo.city": "Ciudad",
    "geo.city.select": "Seleccionar una ciudad",
    "geo.city.freeholder": "Ciudad",
    "geo.city.notListed": "Mi ciudad no está en la lista",
    "geo.city.backToList": "Volver a la lista",
    "phone.invalid": "Número de teléfono no válido",
    "login.forgot": "¿Olvidó su contraseña?",
    "login.suspended": "Su cuenta ha sido suspendida. Contacte con el administrador para más información.",
    "pwreset.forgotTitle": "Contraseña olvidada",
    "pwreset.forgotSubtitle": "Introduzca su correo electrónico para recibir un enlace de restablecimiento.",
    "pwreset.email": "Correo electrónico",
    "pwreset.sendLink": "Enviar enlace",
    "pwreset.sentTitle": "Revise su correo",
    "pwreset.sentDesc": "Si hay una cuenta asociada a esta dirección, recibirá un enlace para restablecer su contraseña. El enlace caduca en 1 hora.",
    "pwreset.backToLogin": "Volver al inicio de sesión",
    "pwreset.resetTitle": "Nueva contraseña",
    "pwreset.resetSubtitle": "Elija una nueva contraseña para su cuenta.",
    "pwreset.newPassword": "Nueva contraseña",
    "pwreset.confirmPassword": "Confirme la contraseña",
    "pwreset.minLength": "8 caracteres mínimo",
    "pwreset.mismatch": "Las contraseñas no coinciden.",
    "pwreset.save": "Restablecer",
    "pwreset.successTitle": "Contraseña restablecida",
    "pwreset.successDesc": "Su contraseña se ha actualizado. Ya puede iniciar sesión.",
    "pwreset.goLogin": "Iniciar sesión",
    "pwreset.invalidTitle": "Enlace inválido o caducado",
    "pwreset.invalidDesc": "Este enlace de restablecimiento ya no es válido (caducado, ya usado o incorrecto). Solicite uno nuevo.",
    "pwreset.requestNew": "Solicitar un nuevo enlace",
    "pwreset.spamHelp": "¿No encuentra el correo? Revise su carpeta de spam. Los correos de Hotmail/Outlook pueden tardar unos minutos.",
    "admin.lots.title": "Moderación de lotes",
    "admin.lots.all": "Todos",
    "admin.lots.available": "Disponible",
    "admin.lots.sold": "Vendido",
    "admin.lots.withdrawn": "Retirado",
    "admin.lots.search": "Buscar un lote…",
    "admin.lots.lot": "Lote",
    "admin.lots.seller": "Vendedor",
    "admin.lots.type": "Tipo",
    "admin.lots.qty": "Cantidad",
    "admin.lots.statusCol": "Estado",
    "admin.lots.actions": "Acciones",
    "admin.lots.vrac": "Granel",
    "admin.lots.conditionne": "Envasado",
    "admin.lots.withdraw": "Retirar",
    "admin.lots.restore": "Reactivar",
    "admin.lots.statusChanged": "Estado actualizado",
    "admin.lots.none": "No hay lotes.",
    "admin.lots.confirmWithdraw": "¿Retirar este lote del mercado?",
    "admin.settings.title": "Ajustes",
    "admin.settings.commission": "Tabla de comisiones",
    "admin.settings.commissionDesc": "Tasas aplicadas a cada operación cerrada (en %).",
    "admin.settings.vracNational": "Granel nacional",
    "admin.settings.vracExport": "Granel exportación",
    "admin.settings.conditionne": "Envasado",
    "admin.settings.buyer": "Comprador",
    "admin.settings.seller": "Vendedor",
    "admin.settings.pctNote": "Valores en porcentaje (p. ej. 0,2 = 0,2 %).",
    "admin.settings.save": "Guardar",
    "admin.settings.saved": "Guardado",
    "admin.settings.platform": "Plataforma",
    "admin.settings.logo": "Logo de la plataforma (PDF)",
    "admin.settings.logoDesc": "Logo mostrado en los PDF de presupuestos y documentos.",
    "admin.settings.logoUpload": "Subir",
    "nav.faq": "FAQ",
    "nav.contact": "Contacto",
    "contact.title": "Contáctenos",
    "contact.subtitle": "¿Tiene una pregunta? Escríbanos y le responderemos rápidamente.",
    "contact.intro": "Complete el formulario a continuación y nuestro equipo le responderá lo antes posible.",
    "contact.name": "Nombre completo",
    "contact.email": "Correo electrónico",
    "contact.company": "Empresa",
    "contact.phone": "Teléfono",
    "contact.subject": "Asunto",
    "contact.subjectPlaceholder": "Elija un asunto",
    "contact.message": "Mensaje",
    "contact.cat.general": "Pregunta general",
    "contact.cat.sell": "Vender aceite de oliva",
    "contact.cat.buy": "Comprar aceite de oliva",
    "contact.cat.partnership": "Asociación",
    "contact.cat.press": "Prensa",
    "contact.cat.other": "Otro",
    "contact.consentPre": "Acepto que mis datos se traten de acuerdo con la ",
    "contact.privacyLink": "política de privacidad",
    "contact.submit": "Enviar mensaje",
    "contact.sending": "Enviando…",
    "contact.success": "Mensaje enviado",
    "contact.successDesc": "Gracias por contactarnos. Le responderemos lo antes posible.",
    "admin.contact.title": "Mensajes de contacto",
    "admin.contact.subjectCol": "Asunto",
    "admin.contact.detail": "Detalle del mensaje",
    "dash.menu.adminContact": "Mensajes de contacto",
    "faq.title": "Preguntas frecuentes",
    "faq.subtitle": "Todo lo que necesitas saber para comprar y vender aceite de oliva a granel en EvooTunisia.",
    "faq.empty": "Aún no hay preguntas.",
    "faq.moreHelp": "¿No encuentras tu respuesta? Crea una cuenta y contáctanos desde tu panel.",
    "faq.cta": "Crear una cuenta gratis",
    "faq.admin.title": "Gestión de FAQ",
    "faq.admin.new": "Nueva pregunta",
    "faq.admin.empty": "No hay preguntas. Añade la primera.",
    "faq.admin.back": "Volver a la lista",
    "faq.admin.question": "Pregunta",
    "faq.admin.answer": "Respuesta",
    "faq.admin.category": "Categoría",
    "faq.admin.order": "Orden",
    "faq.admin.published": "Publicada",
    "faq.admin.save": "Guardar",
    "faq.admin.saved": "Pregunta guardada",
    "faq.admin.confirmDelete": "¿Eliminar esta pregunta?",
    "faq.admin.deleted": "Pregunta eliminada",
    "faq.admin.needQuestion": "La pregunta en francés es obligatoria.",
    "faq.admin.statusPublished": "Publicada",
    "faq.admin.statusDraft": "Oculta",
    "dash.menu.adminFaq": "Preguntas frecuentes",
    "admin.market.title": "Gestión de Mercado y Precios",
    "admin.market.tabOrigin": "Precios a origen",
    "admin.market.tabRetail": "Precios GD",
    "admin.market.tabBalance": "Balance",
    "admin.market.tabSettings": "Ajustes",
    "admin.market.addPoint": "Añadir punto",
    "admin.market.addSeries": "Añadir serie",
    "admin.market.date": "Fecha",
    "admin.market.price": "Precio",
    "admin.market.period": "Campaña",
    "admin.market.value": "Valor (t)",
    "admin.market.delete": "Eliminar",
    "admin.market.save": "Guardar",
    "admin.market.saved": "Guardado",
    "admin.market.confirmDelete": "¿Eliminar esta serie?",
    "admin.market.fx": "Tipos de cambio (base TND)",
    "admin.market.tndPerEur": "TND por 1 EUR",
    "admin.market.tndPerUsd": "TND por 1 USD",
    "admin.market.thresholds": "Termómetro",
    "admin.market.thermoUp": "Umbral alza (%)",
    "admin.market.thermoDown": "Umbral baja (%)",
    "directory.subtitle": "El directorio de almazaras y molinos verificados, en Túnez y para exportación.",
    "directory.search": "Buscar una almazara, una ciudad...",
    "directory.exportTo": "Exporta a",
    "directory.allCountries": "Todos los países",
    "directory.selectGovernorate": "Gobernación",
    "directory.exportOpen": "Abierto a la exportación",
    "directory.exportMarkets": "Mercados de exportación",
    "dirprofile.exportOpen": "Abierto a la exportación",
    "dirprofile.exportMarkets": "Mercados de exportación",
    "dirprofile.exportMarketsHelp": "Añada los países a los que exporta.",
    "dirprofile.addMarket": "Añadir un país...",
    "directory.tunisia": "Túnez",
    "directory.export": "Exportación (otros países)",
    "directory.allRegions": "Todos",
    "directory.allVarieties": "Todas las variedades",
    "directory.filterVariety": "Variedad",
    "directory.organicOnly": "Solo ecológico",
    "directory.viewProfile": "Ver ficha",
    "directory.viewLots": "Ver sus lotes",
    "directory.lotsAvailable": "{n} lote(s) en venta",
    "directory.noResults": "Ninguna almazara coincide con su búsqueda.",
    "directory.varieties": "Variedades de aceituna",
    "directory.certifications": "Certificaciones",
    "directory.contact": "Contacto",
    "directory.country": "País",
    "directory.about": "Acerca de",
    "directory.back": "Volver al directorio",
    "directory.verified": "Verificada",
    "directory.results": "{n} almazara(s)",
    "dash.menu.directoryProfile": "Mi ficha del directorio",
    "dirprofile.title": "Mi ficha del directorio",
    "dirprofile.intro": "Enriquezca su escaparate público en el directorio de almazaras.",
    "dirprofile.visible": "Visible en el directorio",
    "dirprofile.visibleHelp": "Desactive para ocultar su ficha del público.",
    "dirprofile.description": "Descripción",
    "dirprofile.varieties": "Variedades de aceituna",
    "dirprofile.varietiesHelp": "Separe con comas (Chetoui, Chemlali...).",
    "dirprofile.capacity": "Capacidad (toneladas/año)",
    "dirprofile.certifications": "Certificaciones",
    "dirprofile.certHelp": "Separe con comas (Bio UE, IGP...).",
    "dirprofile.organic": "Certificada ecológica",
    "dirprofile.city": "Ciudad",
    "dirprofile.country": "País",
    "dirprofile.contactEmail": "Correo de contacto",
    "dirprofile.photos": "Fotos",
    "dirprofile.addPhoto": "Añadir foto",
    "dirprofile.logo": "Logo de la almazara",
    "dirprofile.logoHelp": "Se muestra en sus presupuestos PDF. PNG/JPG/WEBP, fondo claro preferible.",
    "dirprofile.addLogo": "Añadir un logo",
    "dirprofile.replaceLogo": "Reemplazar",
    "dirprofile.save": "Guardar mi ficha",
    "dirprofile.saved": "Ficha actualizada",
    "dirprofile.locked": "Su empresa debe estar verificada como vendedor para aparecer en el directorio.",
    "admin.market.thermoWeeks": "Semanas analizadas",
    "admin.market.comment": "Comentario del termómetro",
    "admin.market.newSeriesTitle": "Nueva serie",
    "admin.market.currency": "Moneda",
    "admin.market.source": "Fuente",
    "source.auto_eu": "auto (UE)",
    "source.auto_world": "auto (mundial)",
    "source.manual": "manual (admin)",
    "market.lastUpdate": "Última actualización",
    "market.attribution": "Fuente: Comisión Europea (Agri-food Data Portal) y FRED.",
    "market.worldIndex": "Precio mundial de referencia (FRED)",
    "market.worldIndexDesc": "Índice mundial mensual del precio del aceite de oliva.",
    "admin.market.tabFeeds": "Flujos automáticos",
    "admin.market.feedStatus": "Estado de los flujos automáticos",
    "admin.market.syncNow": "Sincronizar ahora",
    "admin.market.syncing": "Sincronizando…",
    "admin.market.syncDone": "Sincronización completada",
    "admin.market.lastSuccess": "Último éxito",
    "admin.market.lastError": "Último error",
    "admin.market.feedEu": "Comisión Europea (precios a origen)",
    "admin.market.feedWorld": "FRED (índice mundial)",
    "admin.market.feedNote": "Los precios tunecinos y de marcas de distribuidor siguen siendo manuales.",

    "how.heading": "Cómo funciona",
    "how.subtitle": "Tres pasos sencillos para cerrar tus transacciones.",
    "how.step1.title": "Publicar",
    "how.step1.desc": "Vendedores: crea tu lote a granel o envasado con cantidad, calidad y precio.",
    "how.step2.title": "Negociar",
    "how.step2.desc": "Recibe ofertas, dialoga con los compradores y ajusta tus condiciones.",
    "how.step3.title": "Cerrar",
    "how.step3.desc": "Valida la transacción, organiza la logística y la exportación con confianza.",

    "cta.heading": "¿Listo para hacer crecer tu negocio oleícola?",
    "cta.subtitle": "Únete a la comunidad de profesionales del aceite de oliva en Túnez.",
    "cta.button": "Crear una cuenta gratuita",

    "footer.about": "EvooTunisia es el marketplace B2B dedicado a la compraventa al por mayor de aceite de oliva tunecino, del granel al envasado, para el mercado local y la exportación.",
    "footer.marketplace": "Marketplace",
    "footer.company": "Empresa",
    "footer.legal": "Legal",
    "footer.about.link": "Acerca de",
    "footer.contact": "Contacto",
    "footer.cgu": "Condiciones de uso",
    "footer.privacy": "Política de privacidad",
    "footer.cookies": "Gestión de cookies",
    "footer.rights": "Todos los derechos reservados.",
    "footer.newsletter": "Mantente informado sobre precios y nuevos lotes.",
    "footer.newsletter.placeholder": "Tu correo profesional",
    "footer.newsletter.button": "Suscribirse",

    "currency.label": "Moneda",
    "common.comingSoon": "Próximamente",
    "common.comingSoon.desc": "Esta sección forma parte de la base y se activará en una etapa futura.",
    "common.backHome": "Volver al inicio",

    "login.title": "Iniciar sesión",
    "login.subtitle": "Accede a tu espacio profesional.",
    "login.email": "Correo electrónico",
    "login.password": "Contraseña",
    "login.button": "Entrar",
    "login.noAccount": "¿Aún no tienes cuenta?",
    "login.demo": "Interfaz de demostración — autenticación no activa.",

    "register.title": "Crear una cuenta",
    "register.subtitle": "Únete al marketplace en pocos minutos.",
    "register.company": "Nombre de la empresa",
    "register.role": "Eres",
    "register.role.buyer": "Comprador",
    "register.role.seller": "Vendedor",
    "register.role.broker": "Corredor",
    "usertype.label": "Tipo de usuario",
    "usertype.placeholder": "— Elija uno —",
    "usertype.producer": "Productor / Almazara",
    "usertype.packer": "Comprador / Envasador",
    "usertype.distributor": "Distribuidor",
    "usertype.broker": "Intermediario",
    "usertype.other": "Otro",
    "usertype.hint": "Puede cambiarlo en cualquier momento desde «Mi empresa».",
    "usertype.sellNote": "Este tipo puede publicar lotes (tras verificar la cuenta).",
    "usertype.buyOnlyNote": "Este tipo puede comprar y negociar.",
    "usertype.current": "Tipo de usuario",
    "usertype.required": "Elija un tipo de usuario",
    "register.country": "País",
    "taxid.matricule_fiscal": "Matrícula fiscal",
    "taxid.cif_nif": "CIF / NIF",
    "taxid.siren_siret": "SIREN / SIRET",
    "taxid.partita_iva": "Partita IVA",
    "taxid.nif_nipc": "NIF / NIPC",
    "taxid.afm": "AFM",
    "taxid.ice": "ICE / Identificación fiscal",
    "taxid.generic": "Número de identificación fiscal / registro mercantil",
    "taxid.vat": "Número de IVA intracomunitario",
    "taxid.vatOptional": "(opcional)",
    "taxid.format": "Formato",
    "taxid.invalid": "Formato de identificador no válido para este país",
    "taxid.err.matricule_fiscal": "Matrícula fiscal no válida. Formato esperado: 7 dígitos + letra de clave, sufijos de establecimiento opcionales (ej. 1234567A/P/M/000).",
    "taxid.err.cif_nif": "CIF/NIF no válido. Formato esperado: 8 a 10 caracteres alfanuméricos (ej. B12345678).",
    "taxid.err.siren_siret": "SIREN / SIRET no válido. Formato esperado: 9 dígitos (SIREN) o 14 dígitos (SIRET) (ej. 123456789).",
    "taxid.err.partita_iva": "Partita IVA no válida. Formato esperado: 11 dígitos (ej. 12345678901).",
    "taxid.err.nif_nipc": "NIF / NIPC no válido. Formato esperado: 9 dígitos (ej. 123456789).",
    "taxid.err.afm": "AFM no válido. Formato esperado: 9 dígitos (ej. 123456789).",
    "taxid.err.ice": "ICE no válido. Formato esperado: 7 a 15 dígitos (ej. 001234567000012).",
    "taxid.err.generic": "Identificador de empresa no válido. Introduzca al menos 4 caracteres alfanuméricos.",
    "consent.before": "Acepto los ",
    "consent.terms": "términos del servicio",
    "consent.mid": " y la ",
    "consent.privacy": "política de protección de datos",
    "consent.required": "Debe aceptar los términos para continuar",
    "kyc.doc.companyDocDyn": "Documento oficial de la empresa ({id})",
    "company.usertype.saved": "Tipo de usuario actualizado",
    "register.button": "Crear mi cuenta",
    "register.hasAccount": "¿Ya estás registrado?",

    "page.market.title": "El mercado",
    "page.prices.title": "Precios y análisis de mercado",
    "page.directory.title": "Directorio de almazaras",
    "page.tools.title": "Herramientas",
    "tools.hub.subtitle": "Herramientas prácticas para comprar, vender y exportar aceite de oliva tunecino.",
    "tools.open": "Abrir",
    "tools.backTools": "Volver a herramientas",
    "tools.calc.title": "Calculadora de costes",
    "tools.calc.desc": "Estime su coste y precio final (Incoterm, logística, TND/EUR/USD).",
    "tools.calc.basic": "Básica",
    "tools.calc.advanced": "Avanzada",
    "tools.calc.inputCurrency": "Moneda de entrada",
    "tools.calc.pricePerKg": "Precio por kg",
    "tools.calc.quantity": "Cantidad",
    "tools.calc.incoterm": "Incoterm",
    "tools.calc.transport": "Transporte",
    "tools.calc.insurance": "Seguro",
    "tools.calc.customs": "Aduana / exportación",
    "tools.calc.handling": "Manipulación",
    "tools.calc.financing": "Costes financieros",
    "tools.calc.otherCosts": "Otros costes",
    "tools.calc.marginPct": "Margen",
    "tools.calc.density": "Densidad (kg/L)",
    "tools.calc.results": "Resultados",
    "tools.calc.goodsValue": "Valor de la mercancía",
    "tools.calc.totalLogistics": "Total logística",
    "tools.calc.totalCost": "Coste total",
    "tools.calc.costPerKg": "Coste por kg",
    "tools.calc.costPerL": "Coste por L",
    "tools.calc.sellingPrice": "Precio de venta sugerido / kg",
    "tools.calc.conversion": "Conversión",
    "tools.calc.densityNote": "La conversión kg → L usa una densidad predeterminada de 0,916 kg/L (editable en modo avanzado).",
    "tools.calc.incotermNote": "Introduzca los costes logísticos a su cargo según el Incoterm elegido.",
    "tools.alerts.title": "Alertas de mercado",
    "tools.alerts.desc": "Reciba notificaciones por correo de nuevos lotes y movimientos de precios.",
    "tools.alerts.doubleOptin": "Doble confirmación: tras suscribirse, haga clic en el enlace enviado a su correo para activar la alerta.",
    "tools.alerts.newLots": "Alerta de nuevos lotes",
    "tools.alerts.newLotsDesc": "Reciba un correo en cuanto un lote coincida con sus criterios.",
    "tools.alerts.priceMove": "Alerta de movimiento de precios",
    "tools.alerts.priceMoveDesc": "Reciba un correo cuando los precios se muevan más allá de su umbral.",
    "tools.alerts.email": "Correo profesional",
    "tools.alerts.market": "Mercado",
    "tools.alerts.quality": "Calidad",
    "tools.alerts.packaging": "Envasado",
    "tools.alerts.governorate": "Gobernación / origen",
    "tools.alerts.minQty": "Cantidad mínima",
    "tools.alerts.maxPrice": "Precio máx. (TND)",
    "tools.alerts.threshold": "Umbral de variación (%)",
    "tools.alerts.thresholdNote": "Se le notificará cuando la variación del mercado supere este umbral.",
    "tools.alerts.subscribe": "Suscribirse",
    "tools.alerts.checkEmail": "Revise su correo para confirmar su suscripción.",
    "tools.alerts.confirmedMsg": "Su alerta está confirmada y activa.",
    "tools.alerts.invalidMsg": "Enlace de confirmación inválido o caducado.",
    "tools.alerts.unsubMsg": "Se ha dado de baja de esta alerta.",
    "tools.packaging.title": "Envasado en Brik / a medida",
    "tools.packaging.desc": "Solicite un presupuesto de envasado (Brik, vidrio, PET) o marca blanca.",
    "tools.packaging.intro": "Describa su necesidad de envasado: una almazara o envasador asociado le contactará con un presupuesto.",
    "tools.packaging.company": "Empresa",
    "tools.packaging.contact": "Contacto",
    "tools.packaging.email": "Correo",
    "tools.packaging.phone": "Teléfono",
    "tools.packaging.type": "Tipo de envase",
    "tools.packaging.volume": "Volumen",
    "tools.packaging.quantity": "Cantidad (unidades)",
    "tools.packaging.whiteLabel": "Marca blanca",
    "tools.packaging.message": "Mensaje",
    "tools.packaging.submit": "Solicitar presupuesto",
    "tools.packaging.success": "Solicitud enviada",
    "tools.packaging.successDesc": "Su solicitud de presupuesto se ha registrado. Le contactaremos pronto.",
    "tools.inspection.title": "Inspección y análisis",
    "tools.inspection.desc": "Certifique y analice sus lotes con laboratorios reconocidos.",
    "tools.inspection.intro": "Encuentre laboratorios y organismos de inspección para el análisis físico-químico y sensorial de sus lotes de aceite de oliva, y solicite una puesta en contacto.",
    "tools.inspection.tunisia": "Laboratorios en Túnez",
    "tools.inspection.international": "Referencias internacionales",
    "tools.inspection.coiYes": "Homologado COI",
    "tools.inspection.coiToVerify": "Homologación por verificar",
    "tools.inspection.coiNote": "Homologaciones por verificar en la lista oficial del COI.",
    "tools.inspection.coiLink": "Lista oficial de laboratorios del COI",
    "tools.inspection.website": "Sitio web",
    "tools.inspection.requestLink": "Solicitar puesta en contacto",
    "tools.inspection.disclaimer": "Estos organismos son referencias del sector y no son socios de EvooTunisia.",
    "tools.inspection.formTitle": "Solicitud de puesta en contacto",
    "tools.inspection.formDesc": "Indíquenos sus necesidades de análisis; le orientamos al laboratorio adecuado.",
    "tools.inspection.lab": "Laboratorio preferido",
    "tools.inspection.noPreference": "Sin preferencia",
    "tools.inspection.lotRef": "Referencia del lote",
    "tools.inspection.analyses": "Análisis solicitados",
    "tools.inspection.analysesPlaceholder": "Acidez, peróxidos, K270, panel test…",
    "tools.inspection.submit": "Enviar solicitud",
    "tools.inspection.success": "Solicitud enviada",
    "tools.inspection.successDesc": "Su solicitud de puesta en contacto se ha registrado. Le contactaremos pronto.",
    "dash.menu.adminTools": "Herramientas y solicitudes",
    "admin.tools.title": "Herramientas y solicitudes",
    "admin.tools.tabAlerts": "Alertas",
    "admin.tools.tabQuotes": "Presupuestos de envasado",
    "admin.tools.tabLeads": "Solicitudes de inspección",
    "admin.tools.tabLabs": "Laboratorios",
    "admin.tools.noData": "Sin datos por ahora.",
    "admin.tools.rowHint": "Haga clic para ver el detalle",
    "admin.tools.alertDetail": "Detalle de la suscripción",
    "admin.tools.quoteDetail": "Detalle de la solicitud de presupuesto",
    "admin.tools.leadDetail": "Detalle de la solicitud de inspección",
    "admin.tools.frequency": "Frecuencia",
    "admin.tools.freqInstant": "Instantánea",
    "admin.tools.freqWeekly": "Semanal",
    "admin.tools.createdAt": "Creado el",
    "admin.tools.confirmedAt": "Confirmado el",
    "admin.tools.sendHistory": "Historial de envíos",
    "admin.tools.lastSent": "Último envío",
    "admin.tools.lastDigest": "Último resumen",
    "admin.tools.never": "Nunca",
    "admin.tools.confirmManually": "Confirmar manualmente",
    "admin.tools.resendConfirmation": "Reenviar confirmación",
    "admin.tools.unsubscribe": "Eliminar / cancelar",
    "admin.tools.confirmDeleteAlert": "¿Eliminar definitivamente esta suscripción?",
    "admin.tools.alertConfirmed": "Suscripción confirmada",
    "admin.tools.confirmationResent": "Correo de confirmación reenviado",
    "admin.tools.alertDeleted": "Suscripción eliminada",
    "admin.tools.phone": "Teléfono",
    "admin.tools.message": "Mensaje",
    "admin.tools.thread": "Hilo de discusión",
    "admin.tools.noThread": "Aún no hay intercambios.",
    "admin.tools.requestedLab": "Laboratorio solicitado",
    "admin.tools.requestedAnalyses": "Análisis solicitados",
    "admin.tools.concernedLot": "Lote concernido",
    "admin.tools.note": "Nota interna",
    "admin.tools.notePlaceholder": "Nota interna (solo admin)…",
    "admin.tools.saveNote": "Guardar nota",
    "admin.tools.contactByEmail": "Contactar por correo",
    "admin.tools.callContact": "Llamar",
    "admin.tools.criteria": "Criterios",
    "admin.tools.status": "Estado",
    "admin.tools.date": "Fecha",
    "admin.tools.confirmed": "Confirmada",
    "admin.tools.pending": "Pendiente",
    "admin.tools.newLab": "Nuevo laboratorio",
    "admin.tools.labName": "Nombre del laboratorio",
    "admin.tools.messages": "Mensajes",
    "request.status.new": "Nuevo",
    "request.status.in_progress": "En curso",
    "request.status.closed": "Cerrado",
    "quotes.title": "Solicitudes de presupuesto",
    "quotes.empty": "Aún no hay solicitudes de presupuesto.",
    "quotes.backList": "Volver a la lista",
    "quotes.noMessages": "Sin mensajes. Envíe una primera respuesta.",
    "quotes.replyPlaceholder": "Escriba su respuesta…",
    "quotes.replied": "Respuesta enviada.",
    "quotes.sent": "Mensaje enviado.",
    "quotes.threadTitle": "Seguimiento de su solicitud de presupuesto",
    "quotes.threadSubtitle": "Converse con las almazaras que responden a su solicitud.",
    "quotes.notFound": "Solicitud no encontrada o enlace caducado.",
    "quotes.waitingReplies": "Esperando las respuestas de las almazaras…",
    "quote.emit": "Emitir presupuesto",
    "quote.newQuote": "Nuevo presupuesto estructurado",
    "quote.currency": "Moneda",
    "quote.vatMode": "Modo de IVA",
    "quote.vatGlobal": "IVA global",
    "quote.vatPerLine": "IVA por línea",
    "quote.vatRate": "Tipo de IVA (%)",
    "quote.lines": "Líneas del presupuesto",
    "quote.lineDesc": "Descripción",
    "quote.lineQty": "Cant.",
    "quote.lineUnit": "Unidad",
    "quote.lineUnitPrice": "Precio unit. (sin IVA)",
    "quote.lineVat": "IVA %",
    "quote.lineTotal": "Total (sin IVA)",
    "quote.addLine": "Añadir una línea",
    "quote.delivery": "Entrega / plazo",
    "quote.deliveryPh": "Ej. en 3 semanas, franco Sfax",
    "quote.incoterm": "Incoterm",
    "quote.validity": "Validez (días)",
    "quote.notes": "Notas / condiciones",
    "quote.attachments": "Adjuntos",
    "quote.addAttachment": "Adjuntar un archivo",
    "quote.attachmentHint": "PDF, JPG, PNG, WEBP · máx 15 MB",
    "quote.subtotal": "Subtotal (sin IVA)",
    "quote.vat": "IVA",
    "quote.total": "Total (con IVA)",
    "quote.send": "Enviar presupuesto",
    "quote.sent": "Presupuesto enviado.",
    "quote.cancel": "Cancelar",
    "quote.confirm": "Confirmar",
    "quote.byMill": "Presupuesto de",
    "quote.issuedDate": "emitido el",
    "quote.validityLabel": "Validez",
    "quote.days": "días",
    "quote.downloadPdf": "Descargar PDF",
    "quote.accept": "Aceptar",
    "quote.refuse": "Rechazar",
    "quote.revise": "Solicitar revisión",
    "quote.reviseComment": "Especifique los cambios solicitados…",
    "quote.refuseComment": "Motivo (opcional)…",
    "quote.confirmAccept": "¿Aceptar este presupuesto? Se generará un PDF de confirmación.",
    "quote.actionDone": "Respuesta registrada.",
    "quote.needLine": "Añada al menos una línea válida.",
    "quote.acceptedLock": "Se ha aceptado un presupuesto. Los demás están cerrados.",
    "quote.status.sent": "Pendiente",
    "quote.status.accepted": "Aceptado",
    "quote.status.refused": "Rechazado",
    "quote.status.revision_requested": "Revisión solicitada",
    "quote.sys.accepted": "aceptó el presupuesto",
    "quote.sys.refused": "rechazó el presupuesto",
    "quote.sys.revision_requested": "solicitó una revisión del presupuesto",
    "quote.commentLabel": "Comentario",
    "quote.compare.title": "Comparador de presupuestos",
    "quote.compare.provider": "Proveedor",
    "quote.compare.delay": "Plazo",
    "quote.compare.status": "Estado",
    "quote.compare.open": "Abrir",
    "quote.compare.sortTotal": "Total",
    "quote.compare.sortDelay": "Plazo",
    "quote.compare.multiCurrency": "Monedas diferentes — compare teniendo en cuenta la moneda de cada presupuesto.",
    "tools.alerts.frequency": "Frecuencia",
    "tools.alerts.freq.instant": "Instantáneo",
    "tools.alerts.freq.weekly": "Resumen semanal",
    "tools.alerts.freq.instantNote": "Un correo por cada nuevo lote coincidente.",
    "tools.alerts.freq.weeklyNote": "Un único correo agrupado cada semana.",
    "tools.calc.incotermCompare": "Comparador de Incoterms",
    "tools.calc.incotermCompareDesc": "Coste estimado según el Incoterm, a partir de los costes introducidos.",
    "tools.calc.incotermCompareNote": "Estimación indicativa: los costes incluidos varían según el acuerdo comercial real.",
    "tools.calc.selected": "seleccionado",
    "confirm.loading": "Confirmando…",
    "confirm.ok.title": "Tu alerta está confirmada ✅",
    "confirm.ok.desc": "¡Listo! A partir de ahora recibirás nuestras notificaciones por correo según tus criterios.",
    "confirm.already.title": "Alerta ya confirmada",
    "confirm.already.desc": "Esta alerta ya estaba activa. No tienes que hacer nada más.",
    "confirm.invalid.title": "Enlace no válido",
    "confirm.invalid.desc": "Este enlace de confirmación no es válido. Puedes volver a suscribirte abajo.",
    "confirm.expired.title": "Enlace caducado",
    "confirm.expired.desc": "Este enlace de confirmación ha caducado. Vuelve a suscribirte para recibir tus alertas.",
    "confirm.error.title": "Se produjo un error",
    "confirm.error.desc": "No pudimos confirmar tu alerta ahora mismo. Inténtalo más tarde o vuelve a suscribirte.",
    "confirm.resubscribe": "Volver a suscribirse",
    "confirm.browseMarket": "Explorar el mercado",
    "tools.alerts.alreadySubscribed": "Esta dirección ya está suscrita a las alertas.",
    "tools.alerts.managePrefs": "Gestionar mis preferencias de alerta",
    "tools.alerts.manageLinkSent": "Se le ha enviado un enlace seguro por correo.",
    "tools.alerts.alreadyPending": "Ya se le ha enviado un correo de confirmación.",
    "tools.alerts.resendConfirm": "Reenviar el correo de confirmación",
    "tools.alerts.resent": "Correo de confirmación reenviado.",
    "manage.title": "Gestionar mis alertas",
    "manage.subtitle": "Modifique sus criterios, su frecuencia o cancele la suscripción.",
    "manage.forEmail": "Está gestionando las alertas de:",
    "manage.none": "No hay alertas para esta dirección.",
    "manage.save": "Guardar",
    "manage.saved": "Preferencias guardadas.",
    "manage.unsubscribe": "Cancelar suscripción",
    "manage.unsubscribed": "Se ha dado de baja de esta alerta.",
    "manage.confirmUnsub": "Cancelar la suscripción eliminará permanentemente esta alerta y su correo asociado. ¿Continuar?",
    "manage.consumed": "Sus preferencias se guardaron. Este enlace de un solo uso ya está usado. Para más cambios, solicite un nuevo enlace.",
    "manage.requestNew": "Obtener un nuevo enlace",
    "manage.active": "Activa",
    "manage.paused": "En pausa",
    "manage.invalid.title": "Enlace no válido",
    "manage.invalid.desc": "Este enlace de gestión no es válido. Solicite uno nuevo desde la página de suscripción a alertas.",
    "manage.expired.title": "Enlace caducado",
    "manage.expired.desc": "Este enlace de gestión ha caducado. Solicite uno nuevo desde la página de suscripción a alertas.",
    "page.blog.title": "Blog y Noticias",

    "directory.capacity": "Capacidad",
    "directory.system": "Sistema",
    "directory.certifications": "Certificaciones",
    "blog.readMore": "Leer artículo",
    "blog.subtitle": "Análisis de mercado, olivicultura, calidad y exportación — el medio B2B del sector del aceite de oliva tunecino.",
    "blog.type.all": "Todo",
    "blog.type.article": "Artículos",
    "blog.type.market": "Panorama del mercado",
    "blog.cat.all": "Todas las categorías",
    "blog.cat.marche": "Mercado y precios",
    "blog.cat.oleiculture": "Olivicultura",
    "blog.cat.qualite": "Calidad",
    "blog.cat.export": "Exportación",
    "blog.cat.recettes": "Recetas y usos",
    "blog.cat.reglementation": "Normativa",
    "blog.empty": "Aún no hay artículos. ¡Vuelve pronto!",
    "blog.linkCopied": "Enlace copiado al portapapeles",
    "blog.notFound": "Artículo no encontrado.",
    "blog.backToBlog": "Volver al blog",
    "blog.share": "Compartir",
    "blog.aiPublicNotice": "Este artículo se redactó con ayuda de IA y fue revisado por nuestra redacción.",
    "blog.related": "Lecturas relacionadas",
    "blog.admin.title": "Blog y contenidos",
    "blog.admin.new": "Nuevo artículo",
    "blog.admin.empty": "No hay artículos. Crea tu primer contenido.",
    "blog.admin.confirmDelete": "¿Eliminar este artículo definitivamente?",
    "blog.admin.deleted": "Artículo eliminado",
    "blog.admin.needContent": "Añade al menos un título o contenido en un idioma.",
    "blog.admin.saved": "Artículo guardado",
    "blog.admin.status.draft": "Borrador",
    "blog.admin.status.published": "Publicado",
    "blog.admin.backList": "Volver a la lista",
    "blog.admin.langContent": "Contenido",
    "blog.admin.fTitle": "Título",
    "blog.admin.fSlug": "Slug (URL)",
    "blog.admin.fExcerpt": "Extracto",
    "blog.admin.fContent": "Contenido (Markdown)",
    "blog.admin.contentPlaceholder": "Escribe tu artículo en Markdown…",
    "blog.admin.seo": "SEO",
    "blog.admin.metaTitle": "Meta título",
    "blog.admin.metaDesc": "Meta descripción",
    "blog.admin.settings": "Ajustes",
    "blog.admin.category": "Categoría",
    "blog.admin.type": "Tipo de contenido",
    "blog.admin.author": "Autor",
    "blog.admin.cover": "Imagen de portada",
    "blog.admin.coverUpload": "Subir imagen",
    "blog.admin.coverUploading": "Subiendo…",
    "blog.admin.coverOr": "o pega una URL de imagen",
    "blog.admin.coverRemove": "Quitar",
    "blog.admin.coverHint": "JPG, PNG o WEBP — máx. 15 MB. Usa fotos reales (olivos, almazaras).",
    "blog.admin.currentStatus": "Estado actual",
    "blog.admin.saveDraft": "Guardar borrador",
    "blog.admin.publish": "Publicar",
    "blog.admin.write": "Escribir",
    "blog.admin.preview": "Vista previa",
    "blog.ai.title": "Generador de artículos (IA)",
    "blog.ai.subject": "Tema del artículo",
    "blog.ai.langs": "Idiomas a generar",
    "blog.ai.tone": "Tono",
    "blog.ai.length": "Longitud",
    "blog.ai.len.court": "Corto",
    "blog.ai.len.moyen": "Medio",
    "blog.ai.len.long": "Largo",
    "blog.ai.type": "Tipo de contenido",
    "blog.ai.keywords": "Palabras clave SEO (opcional)",
    "blog.ai.sourceData": "Datos de origen (opcional)",
    "blog.ai.sourcePlaceholder": "Pega cifras/datos para usar tal cual (la IA no inventará nada).",
    "blog.ai.warning": "La IA puede equivocarse. Revisa y verifica los datos antes de publicar.",
    "blog.ai.generate": "Generar borrador",
    "blog.ai.translateBtn": "Traducir a otros idiomas",
    "blog.ai.needSubject": "Introduce un tema.",
    "blog.ai.done": "Borrador generado",
    "blog.ai.failed": "La generación falló. Inténtalo de nuevo.",
    "blog.ai.needSource": "Escribe primero el contenido en el idioma de origen.",
    "blog.ai.translated": "Traducciones generadas",
    "dash.menu.adminBlog": "Blog",

    "nav.dashboard": "Panel",
    "auth.logout": "Cerrar sesión",
    "auth.error": "Algo salió mal. Inténtalo de nuevo.",
    "badge.verified": "Verificado",
    "common.loading": "Cargando…",
    "common.optional": "(opcional)",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",

    "register.name": "Nombre del representante",
    "register.matricule": "Identificación fiscal",
    "register.address": "Dirección",
    "register.governorate": "Gobernación",
    "register.phone": "Teléfono",
    "register.website": "Sitio web",
    "register.section.account": "Tus credenciales",
    "register.section.company": "Tu empresa",
    "register.free": "El registro es 100 % gratuito — sin pago.",

    "dash.welcome": "Bienvenido, {name}",
    "dash.subtitle": "Gestiona tu actividad en EvooTunisia.",
    "dash.menu.overview": "Resumen",
    "dash.menu.lots": "Mis lotes",
    "dash.menu.offers": "Mis ofertas",
    "dash.menu.messages": "Mensajes",
    "dash.menu.company": "Mi empresa",
    "dash.menu.verification": "Verificación",
    "dash.menu.settings": "Ajustes",
    "dash.verify.cta": "Verificar mi cuenta",
    "dash.verify.banner": "Tu cuenta aún no está verificada. Verifícala para obtener la insignia y priorizar tus lotes.",
    "dash.card.status": "Estado de la cuenta",
    "dash.card.role": "Tipo de cuenta",
    "dash.card.company": "Empresa",

    "company.title": "Mi empresa",
    "company.subtitle": "Datos de tu empresa vinculada.",
    "company.saved": "Empresa actualizada.",
    "company.matriculeLocked": "La identificación fiscal no se puede modificar.",

    "kyc.title": "Verificación de la cuenta",
    "kyc.subtitle": "Sube tus documentos para obtener la insignia «Verificado».",
    "kyc.status.unverified": "No verificado",
    "kyc.status.pending": "Pendiente",
    "kyc.status.verified": "Verificado",
    "kyc.status.rejected": "Rechazado",
    "kyc.doc.company_doc": "Documento oficial de la empresa (licencia / identificación fiscal)",
    "kyc.doc.link_proof": "Prueba del vínculo con la empresa",
    "kyc.doc.id_document": "Documento de identidad del representante",
    "kyc.doc.bank_rib": "Datos bancarios / certificado bancario",
    "kyc.upload": "Subir",
    "kyc.replace": "Reemplazar",
    "kyc.uploaded": "Subido",
    "kyc.view": "Ver",
    "kyc.submit": "Enviar para verificación",
    "kyc.submitted": "Documentos enviados. Verificación pendiente.",
    "kyc.secure": "Tus documentos están cifrados y nunca se hacen públicos.",
    "kyc.sellerNote": "Como vendedor, se requieren datos bancarios / un certificado bancario.",
    "kyc.pendingNote": "Nuestro equipo está revisando tus documentos.",
    "kyc.verifiedNote": "¡Enhorabuena! Tu cuenta está verificada.",
    "kyc.rejectedNote": "Tu verificación fue rechazada. Vuelve a enviar documentos válidos.",

    "settings.title": "Ajustes",
    "settings.email": "Correo electrónico",
    "settings.role": "Tipo de cuenta",
    "settings.notifications": "Notificaciones",
    "settings.notifyQuotes": "Recibir nuevas solicitudes de presupuesto por correo",
    "settings.notifyQuotesSaved": "Preferencia guardada",
    "settings.emailPrefs": "Preferencias de correo",
    "settings.emailPrefsDesc": "Elige qué correos deseas recibir. La campana de notificaciones permanece siempre activa.",
    "settings.prefsSaved": "Preferencias guardadas",
    "settings.pref.negotiations": "Ofertas y negociaciones",
    "settings.pref.quotes": "Presupuestos de envasado",
    "settings.pref.verification": "Decisión de verificación (KYC)",
    "settings.pref.alerts": "Alertas de mercado",
    "settings.pref.transactionalNote": "Los correos de seguridad y transaccionales (confirmación de correo, restablecimiento de contraseña) siempre se envían.",
    "dash.menu.deals": "Historial de operaciones",
    "deals.title": "Historial de operaciones",
    "deals.empty": "Aún no hay operaciones cerradas.",
    "deals.revenue": "Facturación",
    "deals.spend": "Total de compras",
    "deals.totalCommission": "Comisiones acumuladas",
    "deals.count": "operaciones",
    "deals.date": "Fecha",
    "deals.role": "Rol",
    "deals.product": "Producto",
    "deals.counterparty": "Contraparte",
    "deals.quantity": "Cantidad",
    "deals.total": "Importe",
    "deals.commission": "Comisión",
    "deals.seller": "Venta",
    "deals.buyer": "Compra",
    "settings.soon": "Pronto habrá más ajustes.",

    "auth.google": "Continuar con Google",
    "auth.or": "o",
    "auth.connecting": "Iniciando sesión…",
    "profile.title": "Completa tu perfil",
    "profile.subtitle": "Un último paso: añade tu empresa para acceder al marketplace.",
    "profile.submit": "Finalizar",
    "profile.welcome": "¡Bienvenido {name}! Elige tu tipo de cuenta y tu empresa.",

    "quality.premium_bio": "Premium / Ecológico",
    "quality.grignon": "Orujo",
    "incoterm.label": "Incoterm",
    "common.close": "Cerrar",
    "common.all": "Todos",

    "vrac.publish": "Publicar un lote",
    "vrac.filters": "Filtros",
    "vrac.filter.quality": "Calidad",
    "vrac.filter.qty": "Cantidad (kg)",
    "vrac.filter.acidityMax": "Acidez máx (º)",
    "vrac.filter.governorate": "Gobernación",
    "vrac.filter.price": "Precio (TND/kg)",
    "vrac.filter.incoterm": "Incoterm",
    "vrac.filter.min": "Mín",
    "vrac.filter.max": "Máx",
    "vrac.filter.reset": "Restablecer",
    "vrac.sort": "Ordenar",
    "vrac.sort.recent": "Más recientes",
    "vrac.sort.price_asc": "Precio ascendente",
    "vrac.sort.price_desc": "Precio descendente",
    "vrac.sort.qty_desc": "Cantidad",
    "vrac.empty": "Ningún lote coincide con tu búsqueda.",
    "vrac.results": "{n} lote(s)",

    "lot.acidity": "Acidez",
    "lot.peroxides": "Índice de peróxidos",
    "lot.k270": "K270",
    "lot.polyphenols": "Polifenoles",
    "lot.panel": "Panel test",
    "lot.incoterm": "Incoterm",
    "lot.origin": "Origen",
    "lot.availability": "Disponibilidad",
    "lot.description": "Descripción",
    "lot.documents": "Análisis y documentos",
    "lot.characteristics": "Características",
    "lot.seller": "Vendedor",
    "lot.makeOffer": "Hacer una oferta",
    "lot.contact": "Contactar",
    "lot.notFound": "Lote no encontrado",
    "lot.perKg": "/ kg",
    "offer.subtitle": "Inicie una negociación privada con el vendedor.",
    "lot.back": "Volver al mercado",

    "offer.title": "Hacer una oferta",
    "offer.price": "Precio ofrecido",
    "offer.quantity": "Cantidad",
    "offer.message": "Mensaje",
    "offer.send": "Enviar oferta",
    "offer.sent": "¡Oferta enviada!",

    "lotform.new": "Nuevo lote a granel",
    "lotform.edit": "Editar lote",
    "lotform.title": "Título del lote",
    "lotform.variety": "Variedad",
    "lotform.acidity": "Acidez (º)",
    "lotform.peroxides": "Índice de peróxidos",
    "lotform.k270": "K270",
    "lotform.polyphenols": "Polifenoles",
    "lotform.panel": "Panel test",
    "lotform.governorate": "Gobernación de origen",
    "lotform.country": "País de origen",
    "lotform.availability": "Disponibilidad",
    "lotform.photos": "Fotos",
    "lotform.docs": "Análisis (PDF)",
    "lotform.addFiles": "Añadir archivos",
    "lotform.uploading": "Subiendo…",
    "lotform.created": "¡Lote publicado!",
    "lotform.updated": "Lote actualizado",

    "mylots.new": "Publicar un lote",
    "mylots.empty": "Aún no has publicado ningún lote.",
    "mylots.notVerifiedTitle": "Cuenta no verificada",
    "mylots.notVerified": "Solo los vendedores verificados pueden publicar lotes.",
    "mylots.markSold": "Marcar como vendido",
    "mylots.reactivate": "Reactivar",
    "mylots.withdraw": "Retirar",
    "mylots.edit": "Editar",
    "status.available": "Disponible",
    "status.sold": "Vendido",
    "status.withdrawn": "Retirado",

    "myoffers.empty": "Aún no hay ofertas.",
    "myoffers.sent": "Enviada",
    "myoffers.received": "Recibida",

    "req.publish": "Publicar una solicitud",
    "req.new": "Nueva solicitud de compra",
    "req.quality": "Calidad buscada",
    "req.quantity": "Cantidad (kg)",
    "req.targetPrice": "Precio objetivo (TND/kg)",
    "req.origin": "Origen preferido",
    "req.description": "Detalles",
    "req.submit": "Publicar solicitud",
    "req.created": "¡Solicitud publicada!",
    "req.empty": "Aún no hay solicitudes de compra.",
    "req.looking": "busca",
    "req.buyerNote": "Publica lo que buscas para recibir ofertas.",

    "cond.market": "Mercado Envasado",
    "cond.publish": "Publicar un lote envasado",
    "cond.units": "unidades",
    "cond.format": "Formato",
    "cond.minOrder": "Pedido mínimo",
    "cond.brand": "Marca",
    "cond.whiteLabel": "Marca blanca",
    "cond.whiteLabelBadge": "Marca blanca",
    "cond.perUnit": "/ unidad",
    "cond.filter.packaging": "Tipo de envase",
    "cond.filter.price": "Precio (TND/unidad)",
    "cond.filter.volume": "Formato (volumen)",
    "packaging.verre": "Vidrio",
    "packaging.pet": "PET",
    "packaging.bidon_metal": "Bidón metálico",
    "packaging.brik": "Brik",
    "packaging.canette": "Lata",
    "packaging.monodose": "Monodosis",
    "packaging.dosettes": "Cápsulas / perlas",
    "lotform.market": "Tipo de mercado",
    "lotform.packaging": "Tipo de envase",
    "lotform.volume": "Volumen por unidad (ml)",
    "lotform.units": "Número de unidades",
    "lotform.minOrder": "Pedido mínimo (unidades)",
    "lotform.brand": "Marca / etiqueta",
    "lotform.whiteLabel": "Marca blanca disponible",
    "lotform.pricePerUnit": "Precio por unidad (TND)",
    "alert.title": "Alertas de nuevos lotes envasados",
    "alert.cta": "Recibir alertas",
    "alert.subtitle": "Recibe notificaciones por correo según tus criterios.",
    "alert.email": "Tu correo",
    "alert.quality": "Calidad (opcional)",
    "alert.packaging": "Envase (opcional)",
    "alert.governorate": "Origen (opcional)",
    "alert.maxPrice": "Precio máx por unidad (opcional)",
    "alert.submit": "Activar alertas",
    "alert.created": "¡Casi listo! Revisa tu correo para confirmar tu alerta.",
    "alert.note": "El envío de correos se activará pronto.",

    "nego.center": "Mensajes y negociaciones",
    "nego.empty": "Aún no hay conversaciones.",
    "nego.selectConv": "Selecciona una conversación",
    "nego.you": "Tú",
    "nego.buyer": "Comprador",
    "nego.seller": "Vendedor",
    "nego.counter": "Contraoferta",
    "nego.accept": "Aceptar",
    "nego.refuse": "Rechazar",
    "nego.send": "Enviar",
    "nego.message": "Mensaje",
    "nego.messagePlaceholder": "Escribe un mensaje…",
    "nego.price": "Precio",
    "nego.quantity": "Cantidad",
    "nego.makeCounter": "Hacer una contraoferta",
    "nego.status.pending": "Pendiente",
    "nego.status.countered": "Contraofertada",
    "nego.status.accepted": "Aceptada",
    "nego.status.refused": "Rechazada",
    "nego.tabActive": "Negociaciones activas",
    "nego.tabConcluded": "Concluidas / Archivadas",
    "nego.emptyActive": "No hay negociaciones activas.",
    "nego.emptyConcluded": "No hay operaciones concluidas.",
    "nego.lotLabel": "Lote",
    "nego.offerStatus": "Estado de la oferta",
    "nego.status.expired": "Expirada",
    "nego.awaiting": "Esperando tu respuesta",
    "nego.concluded": "Operación cerrada",
    "nego.closedUnavailable": "Lote no disponible",
    "nego.downloadQuote": "Descargar confirmación de presupuesto (PDF)",
    "nego.lotUnavailableMsg": "Este lote ya no está disponible.",
    "nego.summary": "Resumen",
    "nego.finalQty": "Cantidad",
    "nego.finalPrice": "Precio unitario",
    "nego.total": "Importe total",
    "nego.commBuyer": "Comisión comprador",
    "nego.commSeller": "Comisión vendedor",
    "nego.export": "Operación de exportación (internacional)",
    "nego.transportNote": "La plataforma no gestiona el transporte. La logística la organizan las partes según el Incoterm acordado.",
    "nego.offerLine": "Oferta: {qty} × {price}",
    "admin.commission.title": "Tabla de comisiones",
    "admin.commission.vracNatB": "Granel nacional — comprador (%)",
    "admin.commission.vracNatS": "Granel nacional — vendedor (%)",
    "admin.commission.vracExpB": "Granel exportación — comprador (%)",
    "admin.commission.vracExpS": "Granel exportación — vendedor (%)",
    "admin.commission.condB": "Envasado — comprador (%)",
    "admin.commission.condS": "Envasado — vendedor (%)",
    "admin.commission.saved": "Tabla guardada.",
    "emailconf.checkTitle": "Revise su correo",
    "emailconf.checkDesc": "Hemos enviado un enlace de confirmación a {email}. Haga clic en él para activar su cuenta y luego inicie sesión.",
    "emailconf.spamHelp": "¿No recibió el correo? Revise su carpeta de spam / correo no deseado y luego haga clic en «Reenviar el correo de confirmación».",
    "emailconf.resend": "Reenviar el correo de confirmación",
    "emailconf.resent": "Correo de confirmación reenviado.",
    "emailconf.loginBlockedTitle": "Confirme su dirección de correo",
    "emailconf.loginBlockedDesc": "Su dirección de correo aún no está confirmada. Haga clic en el enlace que le enviamos para acceder a su cuenta.",
    "emailconf.confirming": "Confirmando…",
    "emailconf.confirmedTitle": "Correo confirmado",
    "emailconf.confirmedDesc": "Su dirección de correo está confirmada. Ahora puede iniciar sesión.",
    "emailconf.invalidTitle": "Enlace no válido",
    "emailconf.invalidDesc": "Este enlace de confirmación no es válido. Introduzca su correo para recibir un nuevo enlace.",
    "emailconf.expiredTitle": "Enlace caducado",
    "emailconf.expiredDesc": "Este enlace de confirmación ha caducado. Introduzca su correo para recibir un nuevo enlace.",
    "emailconf.goLogin": "Ir a iniciar sesión",
    "emailconf.emailPlaceholder": "Su dirección de correo",
    "emailconf.notKyc": "La confirmación de correo es distinta de la verificación documental (KYC) de su empresa.",
    "emailconf.backToLogin": "Volver a iniciar sesión",
    "notif.title": "Notificaciones",
    "notif.empty": "Sin notificaciones.",
    "notif.markAll": "Marcar todo como leído",
    "myquotes.title": "Mis solicitudes de presupuesto",
    "myquotes.subtitle": "Siga las solicitudes que envió y los presupuestos recibidos.",
    "myquotes.empty": "Aún no ha enviado ninguna solicitud de presupuesto.",
    "myquotes.new": "Nueva solicitud",
    "myquotes.responsesCount": "{n} presupuesto(s) recibido(s)",
    "verifygate.title": "Verificación requerida",
    "verifygate.desc": "Su cuenta debe estar verificada (KYC) para concluir una operación. Puede seguir navegando, solicitando presupuestos y negociando, pero concluir requiere una cuenta verificada.",
    "verifygate.counterparty": "La otra parte aún no está verificada. Podrá concluir cuando ambas cuentas estén verificadas.",
    "verifygate.cta": "Completar la verificación",
    "verifygate.later": "Más tarde",
    "packaging.loggedInNote": "Solicitud enviada como {company}. Aparecerá en «Mis solicitudes de presupuesto».",
    "packaging.viewMyQuotes": "Ver mis solicitudes de presupuesto",
    "cookie.title": "Respetamos tu privacidad",
    "cookie.message": "Utilizamos cookies esenciales para el funcionamiento del sitio y, con tu consentimiento, cookies de análisis y marketing. Puedes aceptar, rechazar o personalizar tus opciones.",
    "cookie.policy": "Política de cookies",
    "cookie.accept": "Aceptar todo",
    "cookie.reject": "Rechazar todo",
    "cookie.manage": "Personalizar",
    "cookie.save": "Guardar mis opciones",
    "cookie.essential": "Cookies esenciales",
    "cookie.essentialDesc": "Necesarias para el funcionamiento del sitio (siempre activas).",
    "cookie.analytics": "Análisis",
    "cookie.analyticsDesc": "Nos ayudan a entender cómo se usa el sitio.",
    "cookie.marketing": "Marketing",
    "cookie.marketingDesc": "Personalización de contenidos y anuncios.",
    "admin.treasury.title": "Tesorería de comisiones",
    "admin.treasury.subtitle": "Facturado frente a cobrado por mes. Cobro manual por transferencia bancaria (el estado «Pagada» lo valida un administrador).",
    "admin.treasury.runReminders": "Enviar recordatorios",
    "admin.treasury.remindersSent": "{n} recordatorio(s) de pago enviado(s)",
    "admin.treasury.remindersError": "Error al enviar los recordatorios",
    "admin.treasury.billed": "Facturado",
    "admin.treasury.collected": "Cobrado",
    "admin.treasury.outstanding": "Pendiente",
    "admin.treasury.overdue": "Vencidas",
    "admin.treasury.invoices": "facturas",
    "admin.treasury.paid": "pagadas",
    "admin.treasury.awaiting": "en revisión",
    "admin.treasury.issued": "emitidas",
    "admin.treasury.month": "Mes",
    "admin.treasury.noData": "Aún no hay facturas.",
    "pricedigest.badge": "Gratis · Semanal",
    "pricedigest.title": "Reciba los precios del mercado cada semana",
    "pricedigest.desc": "Un correo por semana con los precios del aceite de oliva en origen en Túnez y la tendencia del mercado. Cancele con un clic.",
    "pricedigest.subscribe": "Suscribirme",
    "pricedigest.consent": "Acepto recibir este correo semanal y la",
    "pricedigest.privacy": "política de protección de datos",
    "pricedigest.consentRequired": "Acepte para continuar.",
    "pricedigest.optinNote": "Doble confirmación: recibirá un correo para validar su suscripción.",
    "dash.menu.adminInvoices": "Facturas",
    "admin.invoices.title": "Facturas (todas)",
    "admin.invoices.allStatuses": "Todos los estados",
    "admin.invoices.period": "Periodo (mes)",
    "admin.invoices.search": "Buscar",
    "admin.invoices.searchPlaceholder": "N.º factura, operación, empresa…",
    "admin.invoices.count": "Facturas",
    "admin.invoices.empty": "Ninguna factura coincide con estos filtros.",
    "admin.invoices.export": "Exportar",
    "admin.invoices.exportCsv": "CSV (.csv)",
    "admin.invoices.exportExcel": "Excel (.xlsx)",
    "admin.invoices.exportError": "Error al exportar.",
    "admin.digest.title": "Resumen semanal de precios",
    "admin.digest.subtitle": "Vista previa y prueba del correo enviado automáticamente cada lunes a los suscriptores confirmados.",
    "admin.digest.subscribers": "suscriptores confirmados",
    "admin.digest.preview": "Vista previa",
    "admin.digest.previewTitle": "Vista previa del resumen de precios",
    "admin.digest.testEmail": "Correo de prueba",
    "admin.digest.sendTest": "Enviar una prueba",
    "admin.digest.testSent": "Correo de prueba enviado a {email}",
    "admin.digest.testError": "Error al enviar la prueba.",
    "admin.digest.emailRequired": "Introduzca un correo.",
    "admin.digest.unavailable": "No hay datos de precios para generar el resumen.",
  },
};

export default t;
